/* Customima · medalla con diseño por IA (fase 3, sustituye a Zakeke)
   La clienta escribe lo que quiere grabar; el servidor (App Proxy /apps/ia) devuelve su propuesta (una sola
   desde el 23-sep-2026; la cambia con «¿Cambiamos algo?») como lista de ELEMENTOS en milímetros y este
   fichero la dibuja sobre la foto real de la medalla.
   Reglas de taller: zona grabable = diámetro − 1 mm por lado, letra mínima 1,6 mm (caligrafía 2,2 mm),
   línea fina 0,18 mm. Al añadir a la cesta viajan: resumen legible, JSON del diseño, JPG y SVG a tamaño real. */
(function () {
  'use strict';
  var G = window.__cmIA = window.__cmIA || { bound: false, current: null, texto: '', propuestas: null, elegida: 0, aviso: '', quedan: null, estado: 'inicio' };

  var NS = 'http://www.w3.org/2000/svg';
  var CDN = 'https://cdn.shopify.com/s/files/1/0590/8044/2013/';
  var API = '/apps/ia';                       // App Proxy de Shopify → servidor cstmm-ia
  var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 1000px)') : null;
  // Paso a paso (9-oct-2026); con ?cmpasos=0, la ficha de antes
  var WZ_ON = !/[?&]cmpasos=0/.test(location.search);
  function deskActive() { return !/[?&]cmdesk=0/.test(location.search) && !!mqDesk && mqDesk.matches; }

  // ---------- medidas ----------
  // Cada medalla trae su diámetro, la calibración de su foto (centro y radio del disco en píxeles de la
  // foto de 1000×1000), la cara lisa que se pinta encima (0 = la foto ya es lisa y no se pinta nada) y, si
  // cuelga de un agujero del propio disco, dónde está (mm desde el centro, y hacia abajo). El agujero está
  // también en servidor/app/prompt.py (MEDALLAS): si se cambia aquí, cambiarlo allí.
  var MEDALLAS = {
    // Colgante de Oro Personalizado, 20 mm: piloto desde el 23-sep-2026. Cuelga de un agujero arriba.
    'medalla-customima-de-oro-1': {
      d: 20, foto: { cx: 496.2, cy: 524.4, r: 163.7 }, cara: 0,
      agujero: { x: -0.45, y: -8.44, r: 0.7 },
      recorte: { arriba: 15.2, abajo: 10.6, lado: 10.8 },
      dorado: { src: CDN + 'products/mor02.jpg?v=1647961977&width=1000', fill: '#f3e5b5', ink: '#a58e57' },
      plateado: { src: CDN + 'files/mor02_75abc113-fdea-42f0-8d7c-8e5b29084e7e.jpg?v=1705501148&width=1000', fill: '#d3d4d8', ink: '#8f929f' }
    },
    // Colgante de Oro Personalizado, 15 mm: primer piloto. Cuelga de una anilla soldada.
    'medalla-customima-de-oro': {
      d: 15, foto: { cx: 497, cy: 508, r: 131 }, cara: 124, agujero: null,
      recorte: { arriba: 10.6, abajo: 8, lado: 8.9 },
      dorado: { src: CDN + 'products/OR02-18K.jpg?v=1649673902&width=1000', fill: '#f5e7b6', ink: '#a58e57' },
      plateado: { src: CDN + 'files/2_4d9328ab-ed0b-4219-b07e-ddf52029f943.png?v=1742488835&width=1000', fill: '#e2e5f4', ink: '#9ea1b0' }
    }
  };
  var POR_DEFECTO = 'medalla-customima-de-oro-1';
  var HAIR = 0.18, D, ER, K, PHOTO, PK, CARA, AGUJERO, RECORTE, METAL, VIEW, SIDE_X, MED_Y, ROTULO;
  function aplicarMedalla(handle) {
    var m = MEDALLAS[handle] || MEDALLAS[POR_DEFECTO];
    D = m.d; ER = D / 2 - 1; K = D / 15;
    PHOTO = m.foto; PK = (D / 2) / PHOTO.r; CARA = m.cara; AGUJERO = m.agujero; RECORTE = m.recorte;
    METAL = { dorado: m.dorado, plateado: m.plateado };
    ROTULO = 2.4 * K;                                   // franja de «DELANTE / DETRÁS» bajo cada medalla
    var h = RECORTE.arriba + RECORTE.abajo + ROTULO;    // la vista previa es 2:1 (cm-medalla-ia.css)
    VIEW = { w: 2 * h, h: h };
    SIDE_X = { delante: -h / 2, detras: h / 2 };
    MED_Y = RECORTE.arriba - h / 2;
  }
  aplicarMedalla(POR_DEFECTO);
  // ---------- las letras ----------
  // Las diez que puede elegir la clienta (Susana, 24-sep-2026: «los diez»). La misma lista está en
  // guia/guia-grabado.cjs (tipografia.estilos), que es la que lee el servidor: si se cambia allí, cambiarla aquí.
  // La IA compone con la caligrafía y la de palo; las demás llegan si la clienta las pide o con «Otra letra».
  // Inter es la de «Palo» y también la de «Negrita» (peso 700); las demás tienen un solo peso.
  var ESTILOS = [
    { id: 'caligrafia', nombre: 'Caligrafía', letra: 'Allura', peso: 400, en: 'en caligrafía' },
    { id: 'manuscrita', nombre: 'Manuscrita', letra: 'Caveat', peso: 500, en: 'en letra manuscrita' },
    { id: 'infantil', nombre: 'Infantil', letra: 'Fredoka', peso: 500, en: 'en letra infantil' },
    { id: 'grafiti', nombre: 'Grafiti', letra: 'Permanent Marker', peso: 400, en: 'en letra grafiti' },
    { id: 'monograma', nombre: 'Monograma', letra: 'Cinzel Decorative', peso: 700, en: 'en monograma' },
    { id: 'palo', nombre: 'Palo', letra: 'Inter', peso: 400, en: 'en letra de palo' },
    { id: 'negrita', nombre: 'Negrita', letra: 'Inter', peso: 700, en: 'en negrita' },
    { id: 'clasica', nombre: 'Clásica', letra: 'Playfair Display', peso: 400, en: 'en letra clásica' },
    { id: 'maquina', nombre: 'Máquina de escribir', letra: 'Courier Prime', peso: 400, en: 'en letra de máquina de escribir' },
    { id: 'gotica', nombre: 'Gótica', letra: 'UnifrakturMaguntia', peso: 400, en: 'en letra gótica' }
  ];
  var ESTILO_POR_ID = {};
  ESTILOS.forEach(function (e) { ESTILO_POR_ID[e.id] = e; });
  // Por letra: min, letra mínima en mm (por confirmar en la prueba de taller) · esp, si admite espaciado · base, de
  // la y del motor (dominant-baseline central) a la línea base, y colgar, de la línea base a la «hanging» (la de
  // los textos del borde de abajo), en fracciones del cuerpo, medidas en Chrome (servidor/app/tinta.json y
  // hoja/prueba-trazos.html) · ttf, su fichero TTF en Google Fonts, para pasar el texto a trazos (ver más abajo,
  // «las letras, a trazos») · c, su letra en el enlace de compartir (las de antes, A e I, no cambian).
  var LETRAS = {
    'Allura': { min: 2.2, esp: 0, base: 0.175, colgar: 0.64, ttf: 'allura/v23/9oRPNYsQpS4zjuAPjA', c: 'A' },
    'Caveat': { min: 2.2, esp: 0, base: 0.33, colgar: 0.768, ttf: 'caveat/v23/WnznHAc5bAfYB2QRah7pcpNvOx-pjcB9SII', c: 'V' },
    'Fredoka': { min: 1.8, esp: 1, base: 0.365, colgar: 0.776, ttf: 'fredoka/v17/X7nP4b87HvSqjb_WIi2yDCRwoQ_k7367_B-i2yQag0-mac3OwyLMFg', c: 'F' },
    'Permanent Marker': { min: 2.2, esp: 0, base: 0.395, colgar: 0.888, ttf: 'permanentmarker/v16/Fh4uPib9Iyv2ucM6pGQMWimMp004Hao', c: 'M' },
    'Cinzel Decorative': { min: 2.4, esp: 1, base: 0.305, colgar: 0.784, ttf: 'cinzeldecorative/v19/daaHSScvJGqLYhG8nNt8KPPswUAPniZoaelD', c: 'Z' },
    'Inter': { min: 1.6, esp: 1, base: 0.365, colgar: 0.776, c: 'I', ttf: {
      300: 'inter/v20/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuOKfMZg', 400: 'inter/v20/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuLyfMZg',
      700: 'inter/v20/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuFuYMZg' } },
    'Playfair Display': { min: 2.0, esp: 1, base: 0.415, colgar: 0.864, ttf: 'playfairdisplay/v40/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKdFvUDQ', c: 'P' },
    'Courier Prime': { min: 1.8, esp: 1, base: 0.22, colgar: 0.624, ttf: 'courierprime/v11/u-450q2lgwslOqpF_6gQ8kELWwY', c: 'C' },
    'UnifrakturMaguntia': { min: 2.6, esp: 0, base: 0.265, colgar: 0.624, ttf: 'unifrakturmaguntia/v22/WWXPlieVYwiGNomYU-ciRLRvEmK7oaVunw', c: 'G' }
  };
  ESTILOS.forEach(function (e) { if (!LETRAS[e.letra].peso) LETRAS[e.letra].peso = e.peso; });
  var LETRA_CORTA = {}, LETRA_LARGA = {};
  Object.keys(LETRAS).forEach(function (f) { LETRA_CORTA[f] = LETRAS[f].c; LETRA_LARGA[LETRAS[f].c] = f; });
  // Lo que se pide a Google Fonts por cada letra. Las de un solo estilo no admiten otro peso: pedirles cursiva
  // o peso 500 devuelve un 400 y el JPG del pedido salía con otra letra (arreglado 23-sep-2026).
  var ESPEC_FUENTE = { 'Allura': '', 'Great Vibes': '', 'Inter': ':wght@300;400;700', 'Cinzel': ':wght@500',
    'Caveat': ':wght@500', 'Fredoka': ':wght@500', 'Permanent Marker': '', 'Cinzel Decorative': ':wght@700',
    'Playfair Display': ':wght@400', 'Courier Prime': '', 'UnifrakturMaguntia': '' };
  function pesoDe(el) { return el.letra === 'Inter' ? (+el.peso || 400) : LETRAS[el.letra] ? LETRAS[el.letra].peso : (+el.peso || 500); }
  function minFont(f) { return LETRAS[f] ? LETRAS[f].min : f === 'Great Vibes' ? 2.2 : 1.6; }
  // La caligrafía de antes (Great Vibes) pasa a la de ahora; una letra que no es de las diez, a la de palo.
  function familiaDe(letra, texto) {
    if (letra === 'Great Vibes') return 'Allura';
    if (letra) return LETRAS[letra] ? letra : 'Inter';
    texto = String(texto || '');
    return /\d/.test(texto) || (texto.length > 1 && texto === texto.toUpperCase()) ? 'Inter' : 'Allura';
  }
  // Las ocho que no carga el snippet (Allura e Inter 300 y 400) se piden a Google Fonts la primera vez que hacen
  // falta: al abrir «Otra letra» o al llegar un diseño que las lleva. Hasta que están, la vista previa y el ajuste
  // de seguridad medirían con otra letra, así que se vuelve a pintar cuando llegan.
  var HOJA_LETRAS = 'https://fonts.googleapis.com/css2?family=Caveat:wght@500&family=Fredoka:wght@500&family=Permanent+Marker' +
    '&family=Cinzel+Decorative:wght@700&family=Playfair+Display:wght@400&family=Courier+Prime&family=UnifrakturMaguntia' +
    '&family=Inter:wght@700&display=swap';
  var hojaLetras = null, letrasListas = { 'Allura|400': 1, 'Inter|300': 1, 'Inter|400': 1 };
  function letrasDe(caras) {                          // [[letra, peso, textos]] de lo que se ve en esas caras
    var v = {};
    caras.forEach(function (els) {
      (els || []).forEach(function (e) {
        if (!e || !e.letra || e.texto == null) return;
        var k = e.letra + '|' + pesoDe(e);
        v[k] = v[k] || [e.letra, pesoDe(e), ''];
        v[k][2] += e.texto;
      });
    });
    return Object.keys(v).map(function (k) { return v[k]; });
  }
  function faltanLetras(caras) { return letrasDe(caras).filter(function (f) { return !letrasListas[f[0] + '|' + f[1]]; }); }
  function cargarLetras(lista) {
    if (!lista.length || !document.fonts || !document.fonts.load) return Promise.resolve();
    if (!hojaLetras) hojaLetras = new Promise(function (ok) {
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = HOJA_LETRAS;
      l.onload = ok; l.onerror = ok;
      document.head.appendChild(l);
    });
    return hojaLetras.then(function () {
      return Promise.all(lista.map(function (f) {
        return document.fonts.load(f[1] + ' 20px "' + f[0] + '"', f[2] || 'Aa').catch(function () {})
          .then(function () { letrasListas[f[0] + '|' + f[1]] = 1; });   // aunque falle: no se pide en bucle
      }));
    });
  }

  // ---------- utilidades de dibujo (mm; centro de cada medalla = 0,0) ----------
  var uid = 0, INK = '#a58e57';
  function f2(v) { return (+v || 0).toFixed(3); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function txtEl(s, font, italic, size, x, y, o) {
    o = o || {};
    return '<text x="' + f2(x) + '" y="' + f2(y) + '"' + (o.rot ? ' transform="rotate(' + o.rot + ' ' + f2(x) + ' ' + f2(y) + ')"' : '') +
      ' text-anchor="middle" dominant-baseline="central" font-family="' + (o.laser ? font : "'" + font + "'") + '" font-weight="' + (o.w || 500) + '"' +
      (italic ? ' font-style="italic"' : '') + (o.ls ? ' letter-spacing="' + o.ls + '"' : '') +
      ' font-size="' + f2(size) + '" fill="' + o.ink + '" data-chk="1">' + esc(s) + '</text>';   // con valor: si no, no es XML válido al reinsertar
  }
  function pathText(s, font, italic, size, r, modo, o) {
    o = o || {}; var id = 'cmia' + (++uid), d;
    if (modo === 'anillo') d = 'M0 ' + f2(r) + 'A' + f2(r) + ' ' + f2(r) + ' 0 1 1 0 ' + f2(-r) + 'A' + f2(r) + ' ' + f2(r) + ' 0 1 1 0 ' + f2(r);
    else if (modo === 'abajo') d = 'M' + f2(-r) + ' 0A' + f2(r) + ' ' + f2(r) + ' 0 0 0 ' + f2(r) + ' 0';
    else d = 'M' + f2(-r) + ' 0A' + f2(r) + ' ' + f2(r) + ' 0 0 1 ' + f2(r) + ' 0';
    return '<path id="' + id + '" d="' + d + '" fill="none"/><text font-family="' + (o.laser ? font : "'" + font + "'") + '" font-weight="' + (o.w || 500) + '"' +
      (italic ? ' font-style="italic"' : '') + ' font-size="' + f2(size) + '" fill="' + o.ink + '" letter-spacing="' + (o.ls || 0) + '"' +
      (modo === 'abajo' ? ' dominant-baseline="hanging"' : '') + ' data-ring="' + f2(r) + '" data-modo="' + modo + '"' + '><textPath ' + (o.laser ? 'xlink:href="#' + id + '" ' : '') + 'href="#' + id + '" startOffset="50%" text-anchor="middle">' + esc(s) + '</textPath></text>';
  }
  function linea(x1, y1, x2, y2, ink, w) { return '<path d="M' + f2(x1) + ' ' + f2(y1) + 'L' + f2(x2) + ' ' + f2(y2) + '" stroke="' + ink + '" stroke-width="' + (w || HAIR) + '" stroke-linecap="round" fill="none"/>'; }
  function punto(x, y, r, ink) { return '<circle cx="' + f2(x) + '" cy="' + f2(y) + '" r="' + f2(r || 0.15) + '" fill="' + ink + '"/>'; }
  function rombo(x, y, s, ink) { return '<path d="M' + f2(x) + ' ' + f2(y - s) + 'L' + f2(x + s * 0.7) + ' ' + f2(y) + 'L' + f2(x) + ' ' + f2(y + s) + 'L' + f2(x - s * 0.7) + ' ' + f2(y) + 'Z" fill="' + ink + '"/>'; }
  var HP = 'M0 .95C0 .95-1 .35-1-.3-1-.72-.66-1-.3-1-.14-1 0-.9 0-.72 0-.9.14-1 .3-1 .66-1 1-.72 1-.3 1 .35 0 .95 0 .95Z';
  function corazon(x, y, tam, relleno, ink) {
    var s = (tam || 1) / 2;   // tam = alto aproximado
    return '<path d="' + HP + '" transform="translate(' + f2(x) + ' ' + f2(y) + ') scale(' + f2(s) + ')" ' +
      (relleno ? 'fill="' + ink + '"' : 'fill="none" stroke="' + ink + '" stroke-width="' + f2(HAIR / s) + '" stroke-linejoin="round"') + '/>';
  }
  function estrella(x, y, r, relleno, ink) {
    var p = '', i, a, rr;
    for (i = 0; i < 10; i++) { a = -Math.PI / 2 + i * Math.PI / 5; rr = i % 2 ? r * 0.42 : r; p += (i ? 'L' : 'M') + f2(x + rr * Math.cos(a)) + ' ' + f2(y + rr * Math.sin(a)); }
    p += 'Z';
    return '<path d="' + p + '" ' + (relleno ? 'fill="' + ink + '"' : 'fill="none" stroke="' + ink + '" stroke-width="' + HAIR + '" stroke-linejoin="round"') + '/>';
  }
  function destello(x, y, s, ink) {
    return '<path d="M' + f2(x) + ' ' + f2(y - s) + 'Q' + f2(x) + ' ' + f2(y) + ' ' + f2(x + s * 0.8) + ' ' + f2(y) + 'Q' + f2(x) + ' ' + f2(y) + ' ' + f2(x) + ' ' + f2(y + s) +
      'Q' + f2(x) + ' ' + f2(y) + ' ' + f2(x - s * 0.8) + ' ' + f2(y) + 'Q' + f2(x) + ' ' + f2(y) + ' ' + f2(x) + ' ' + f2(y - s) + 'Z" fill="' + ink + '"/>';
  }
  function infinito(x, y, w, conCorazon, ink) {
    var a = w / 2, h = w * 0.28;
    var d = 'M' + f2(x) + ' ' + f2(y) + 'C' + f2(x - a * 0.35) + ' ' + f2(y - h * 1.4) + ' ' + f2(x - a) + ' ' + f2(y - h * 1.4) + ' ' + f2(x - a) + ' ' + f2(y) +
      'S' + f2(x - a * 0.35) + ' ' + f2(y + h * 1.4) + ' ' + f2(x) + ' ' + f2(y) +
      'C' + f2(x + a * 0.35) + ' ' + f2(y - h * 1.4) + ' ' + f2(x + a) + ' ' + f2(y - h * 1.4) + ' ' + f2(x + a) + ' ' + f2(y) +
      'S' + f2(x + a * 0.35) + ' ' + f2(y + h * 1.4) + ' ' + f2(x) + ' ' + f2(y) + 'Z';
    return '<path d="' + d + '" fill="none" stroke="' + ink + '" stroke-width="' + HAIR + '"/>' + (conCorazon ? corazon(x + a * 0.55, y - h * 1.55, w * 0.17, true, ink) : '');
  }
  function hoja(bx, by, a, L, w, ink) {
    var tx = bx + L * Math.cos(a), ty = by + L * Math.sin(a), mx = (bx + tx) / 2, my = (by + ty) / 2, nx = -Math.sin(a) * w, ny = Math.cos(a) * w;
    return '<path d="M' + f2(bx) + ' ' + f2(by) + 'Q' + f2(mx + nx) + ' ' + f2(my + ny) + ' ' + f2(tx) + ' ' + f2(ty) + 'Q' + f2(mx - nx) + ' ' + f2(my - ny) + ' ' + f2(bx) + ' ' + f2(by) + 'Z" fill="' + ink + '"/>';
  }
  function laurel(R, a0, a1, n, ink) {
    n = Math.max(3, Math.min(10, n || 7));
    var rad = function (d) { return d * Math.PI / 180; }, dir = a1 > a0 ? 1 : -1, s = '', i, t, ad, a, bx, by, tang, sc, L = 1.05, w = 0.36;
    var p0 = [R * Math.cos(rad(a0)), R * Math.sin(rad(a0))], p1 = [R * Math.cos(rad(a1)), R * Math.sin(rad(a1))];
    s += '<path d="M' + f2(p0[0]) + ' ' + f2(p0[1]) + 'A' + f2(R) + ' ' + f2(R) + ' 0 ' + (Math.abs(a1 - a0) > 180 ? 1 : 0) + ' ' + (a1 > a0 ? 1 : 0) + ' ' + f2(p1[0]) + ' ' + f2(p1[1]) + '" fill="none" stroke="' + ink + '" stroke-width="' + HAIR + '" stroke-linecap="round"/>';
    for (i = 0; i < n; i++) {
      t = (i + 0.6) / (n + 0.2); ad = a0 + (a1 - a0) * t; a = rad(ad); bx = R * Math.cos(a); by = R * Math.sin(a); tang = a + dir * Math.PI / 2; sc = 1 - 0.35 * t;
      s += hoja(bx, by, tang - 0.593, L * sc, w * sc, ink) + hoja(bx, by, tang + 0.593, L * sc, w * sc, ink);
    }
    var ae = rad(a1);
    return s + hoja(R * Math.cos(ae), R * Math.sin(ae), ae + dir * Math.PI / 2, L * 0.6, w * 0.55, ink);
  }
  function rama(x0, y0, x1, y1, n, ink) {
    n = Math.max(2, Math.min(9, n || 5));
    var mx = (x0 + x1) / 2 - (y1 - y0) * 0.18, my = (y0 + y1) / 2 + (x1 - x0) * 0.18, s = '', i, t, u, bx, by, dx, dy, a;
    s += '<path d="M' + f2(x0) + ' ' + f2(y0) + 'Q' + f2(mx) + ' ' + f2(my) + ' ' + f2(x1) + ' ' + f2(y1) + '" fill="none" stroke="' + ink + '" stroke-width="' + HAIR + '" stroke-linecap="round"/>';
    for (i = 1; i <= n; i++) {
      t = i / (n + 0.6); u = 1 - t;
      bx = u * u * x0 + 2 * u * t * mx + t * t * x1; by = u * u * y0 + 2 * u * t * my + t * t * y1;
      dx = 2 * u * (mx - x0) + 2 * t * (x1 - mx); dy = 2 * u * (my - y0) + 2 * t * (y1 - my); a = Math.atan2(dy, dx);
      s += hoja(bx, by, a + (i % 2 ? 0.62 : -0.62), 0.95 * (1 - 0.3 * t), 0.32 * (1 - 0.3 * t), ink);
    }
    return s;
  }
  function luna(x, y, r, giro, ink) {
    return '<g transform="rotate(' + (giro || 0) + ' ' + f2(x) + ' ' + f2(y) + ')"><path d="M' + f2(x) + ' ' + f2(y - r) + 'A' + f2(r) + ' ' + f2(r) + ' 0 1 0 ' + f2(x) + ' ' + f2(y + r) +
      'A' + f2(r * 0.62) + ' ' + f2(r) + ' 0 1 1 ' + f2(x) + ' ' + f2(y - r) + 'Z" fill="none" stroke="' + ink + '" stroke-width="' + HAIR + '"/></g>';
  }
  // Siluetas y dibujos de biblioteca (cuadrícula 24×24). f = macizo.
  var BIB = {
    gata: '<path d="M9 2.8L10.3 5.4C11.4 5.1 12.6 5.1 13.7 5.4L15 2.8C15.6 4.3 15.8 6 15.3 7.4 14.9 8.6 14 9.4 13.3 9.8 15.6 10.7 17.3 13.3 17.6 16.4 17.8 18.6 17.2 20.3 16.1 21.2H7.9C6.8 20.3 6.2 18.6 6.4 16.4 6.7 13.3 8.4 10.7 10.7 9.8 10 9.4 9.1 8.6 8.7 7.4 8.2 6 8.4 4.3 9 2.8Z" class="f"/><path d="M15.6 21C18.4 21.4 20.8 20.1 21.1 18 21.3 16.7 20.3 15.9 19.3 16.4" fill="none" stroke-width="1.05" stroke-linecap="round"/>',
    bulldog_frances: '<path fill-rule="evenodd" class="f" d="M12 21C9 21 6.6 19.6 5.6 17.2 4.8 15.3 4.9 13 5.6 11.3 4.4 10.1 3.4 7.9 3.3 5.4 3.2 3.6 4.2 2.6 5.6 3.1 7.4 3.8 9 5.7 9.8 7.9 10.5 7.7 11.2 7.6 12 7.6S13.5 7.7 14.2 7.9C15 5.7 16.6 3.8 18.4 3.1 19.8 2.6 20.8 3.6 20.7 5.4 20.6 7.9 19.6 10.1 18.4 11.3 19.1 13 19.2 15.3 18.4 17.2 17.4 19.6 15 21 12 21ZM9.3 11.7A1 1 0 1 0 9.31 11.7ZM14.7 11.7A1 1 0 1 0 14.71 11.7ZM12 14.3C10.9 14.3 10.3 14.8 10.3 15.3S11.1 16.2 12 16.2 13.7 15.8 13.7 15.3 13.1 14.3 12 14.3Z"/>',
    perro: '<path class="f" d="M12 21C9.4 21 7.4 19.4 6.6 16.9 6 15 6.2 12.8 7 11.2 6 9.6 5.7 7.4 6 4.9 6.2 3.2 7.3 2.7 8.5 3.6 9.8 4.6 10.7 6.2 11.1 7.8 11.4 7.7 11.7 7.7 12 7.7S12.6 7.7 12.9 7.8C13.3 6.2 14.2 4.6 15.5 3.6 16.7 2.7 17.8 3.2 18 4.9 18.3 7.4 18 9.6 17 11.2 17.8 12.8 18 15 17.4 16.9 16.6 19.4 14.6 21 12 21ZM10 12.6A.9.9 0 1 0 10.01 12.6ZM14 12.6A.9.9 0 1 0 14.01 12.6ZM12 15.4C11.1 15.4 10.6 15.8 10.6 16.2S11.3 17 12 17 13.4 16.6 13.4 16.2 12.9 15.4 12 15.4Z"/>',
    pajaro: '<path class="f" d="M2.5 9.5C5.5 9 8.5 10 10.5 12.5 12 9 15.5 6.5 21.5 6 18 8 16.5 10.5 16 13 15.3 16.5 12 18.5 8.5 18L11 15.5C7.5 15.3 4.5 13 2.5 9.5Z"/>',
    mariposa: '<path d="M12 8.5v9.5M12 8.5C11 6 10 4.5 8.8 3.8M12 8.5C13 6 14 4.5 15.2 3.8" fill="none"/><path d="M11.5 9C8 4 3 4.5 3.5 8.5 4 11.5 8 12.5 11.5 12ZM11.5 12.5C8 12.5 5 14.5 6 17.5 7 19.5 10 18 11.5 15Z" fill="none"/><g transform="translate(24 0) scale(-1 1)"><path d="M11.5 9C8 4 3 4.5 3.5 8.5 4 11.5 8 12.5 11.5 12ZM11.5 12.5C8 12.5 5 14.5 6 17.5 7 19.5 10 18 11.5 15Z" fill="none"/></g>',
    ancla: '<circle cx="12" cy="4.8" r="1.8" fill="none"/><path d="M12 6.6V20M8 10h8M4.5 14C5 17.8 8.2 20 12 20S19 17.8 19.5 14M3.3 15.6L4.5 14l1.8 1M20.7 15.6L19.5 14l-1.8 1" fill="none"/>',
    arbol: '<circle cx="12" cy="12" r="9" fill="none"/><path d="M12 20.5V7M12 13C10 11 8 10.5 6 10.3M12 13C14 11 16 10.5 18 10.3M12 10C10.6 9 9.6 8 9 6.3M12 10C13.4 9 14.4 8 15 6.3M12 16C10.6 15 9 14.8 7.3 15M12 16C13.4 15 15 14.8 16.7 15" fill="none"/>',
    cruz: '<path class="f" d="M10.6 3h2.8v5h4.6v2.8h-4.6V21h-2.8V10.8H6V8h4.6Z"/>',
    alianzas: '<circle cx="9.3" cy="13.5" r="5.2" fill="none"/><circle cx="14.7" cy="13.5" r="5.2" fill="none"/><path class="f" d="M13.2 5.5l1.5-1.8 1.5 1.8-1.5 1.8z"/>'
  };
  BIB.gato = BIB.gata;
  function dibujo(markup, x, y, tam, ink) {
    var s = tam / 24, b = HAIR / s;
    return '<g transform="translate(' + f2(x - 12 * s) + ' ' + f2(y - 12 * s) + ') scale(' + s.toFixed(4) + ')" fill="none" stroke="' + ink + '" stroke-width="' + b.toFixed(3) +
      '" stroke-linecap="round" stroke-linejoin="round">' + markup.replace(/ class="f"/g, ' fill="' + ink + '" stroke="none"') + '</g>';
  }
  // Constelaciones del zodiaco (formas estilizadas; puntos normalizados en una caja de −5..5)
  var ZODIACO = {
    aries: { p: [[-4, 1.6], [-1.6, -0.4], [1.4, -1.6], [3.6, -0.6]], e: [[0, 1], [1, 2], [2, 3]] },
    tauro: { p: [[-4.2, -2.6], [-2.4, -1], [-0.4, 0.2], [1.4, 1.2], [3.4, 2.2], [1.2, -1.8], [3.2, -3]], e: [[0, 1], [1, 2], [2, 3], [3, 4], [2, 5], [5, 6]] },
    geminis: { p: [[-3.2, -3.4], [-3, -0.8], [-2.4, 1.8], [-0.6, 2.6], [1.4, 2.2], [2.4, -0.4], [2.8, -3], [0.6, -2.4]], e: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 6], [1, 7], [7, 5]] },
    cancer: { p: [[-3.6, -2], [-1.2, -0.4], [0.6, 1.8], [1, -1.6], [3.4, -2.8]], e: [[0, 1], [1, 2], [1, 3], [3, 4]] },
    leo: { p: [[-3.8, 2.2], [-3.4, -0.2], [-1.8, -1.6], [0.2, -2.4], [1.8, -1], [2.6, 1.4], [0.6, 2.4], [-1.4, 2]], e: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 6], [6, 7], [7, 0]] },
    virgo: { p: [[-4.2, -1.4], [-2, -0.6], [-0.4, 0.8], [1.6, 0.2], [3.4, 1.6], [0.2, -2.4], [2.4, -2.8]], e: [[0, 1], [1, 2], [2, 3], [3, 4], [2, 5], [5, 6]] },
    libra: { p: [[-3.4, 1.4], [-1.6, -1.4], [1.2, -1.8], [3.2, 0.8], [-0.4, 0.6]], e: [[0, 1], [1, 4], [4, 2], [2, 3]] },
    escorpio: { p: [[-4, -2.4], [-2.6, -1.4], [-1, -0.6], [0.6, 0.6], [1.8, 1.8], [3.2, 2], [3.8, 0.6], [2.6, -0.4]], e: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 6], [6, 7]] },
    sagitario: { p: [[-3.6, 1.8], [-1.6, 0.6], [0.2, -0.8], [2.2, -2.2], [-0.6, 2.2], [1.4, 1.4], [2.8, 0.2]], e: [[0, 1], [1, 2], [2, 3], [1, 4], [4, 5], [5, 6], [6, 2]] },
    capricornio: { p: [[-4, -1.6], [-1.6, -2.2], [0.8, -1], [2.6, 0.6], [0.4, 2], [-2, 1.2]], e: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 0]] },
    acuario: { p: [[-4, -1], [-2.4, 0.4], [-0.6, -0.8], [1, 0.6], [2.6, -0.8], [3.8, 0.6]], e: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5]] },
    piscis: { p: [[-4.2, -1.1], [-3.3, -1.8], [-2.3, -1.5], [-2.1, -0.5], [-3, 0.1], [-4, -0.3], [-0.5, 0.6], [1.3, 1.5], [3.2, 2.4], [2.9, 0.8], [2.5, -0.9], [2.3, -2.5], [2.9, -3.4]], e: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 0], [3, 6], [6, 7], [7, 8], [8, 9], [9, 10], [10, 11], [11, 12]] }
  };
  function constelacion(nombre, x, y, tam, ink) {
    var z = ZODIACO[String(nombre || '').toLowerCase()] || ZODIACO.piscis, sc = (tam || 7) / 9, s = '';
    var p = z.p.map(function (q) { return [x + q[0] * sc, y + q[1] * sc]; });
    z.e.forEach(function (e) { s += linea(p[e[0]][0], p[e[0]][1], p[e[1]][0], p[e[1]][1], ink, 0.1); });
    p.forEach(function (q, i) { s += i % 4 === 0 ? estrella(q[0], q[1], 0.42, true, ink) : punto(q[0], q[1], 0.17, ink); });
    return s;
  }
  function trazo(d, x, y, tam, ink) {
    if (!/^[\sMLCQAZmlcqaz0-9.,\-]+$/.test(String(d || ''))) return '';   // solo trazados simples
    var s = (tam || 6) / 24;
    return '<g transform="translate(' + f2(x - 12 * s) + ' ' + f2(y - 12 * s) + ') scale(' + s.toFixed(4) + ')" fill="none" stroke="' + ink + '" stroke-width="' + (HAIR / s).toFixed(3) + '" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></g>';
  }

  // ---------- un elemento del diseño → SVG ----------
  function pintarElemento(el, ink, laser) {
    if (!el || !el.tipo) return '';
    var x = +el.x || 0, y = +el.y || 0, tam = +el.tam || 0, o = { ink: ink, laser: laser, ls: el.espaciado || 0, rot: el.giro || 0, w: pesoDe(el) };
    switch (el.tipo) {
      case 'texto': return txtEl(el.texto, el.letra || 'Allura', !!el.cursiva, Math.max(tam, minFont(el.letra)), x, y, o);
      case 'arco': return pathText(el.texto, el.letra || 'Inter', !!el.cursiva, Math.max(tam, 1.6), +el.radio || ER - 1.45, el.posicion === 'abajo' ? 'abajo' : 'arriba', o);
      case 'circulo_texto': return pathText(el.texto, el.letra || 'Inter', !!el.cursiva, Math.max(tam, 1.6), +el.radio || ER - 1.45, 'anillo', o);
      case 'corazon': return corazon(x, y, tam || 1, el.relleno !== false, ink);
      case 'estrella': return estrella(x, y, tam || 0.5, el.relleno !== false, ink);
      case 'infinito': return infinito(x, y, +el.ancho || 5, !!el.relleno, ink);
      case 'destello': return destello(x, y, tam || 0.5, ink);
      case 'punto': return punto(x, y, tam || 0.15, ink);
      case 'filete': {
        var half = +el.ancho || 2.4, m = el.motivo || 'rombo';
        if (m === 'ninguno') return linea(-half, y, half, y, ink);
        return linea(-half, y, -0.75, y, ink) + (m === 'corazon' ? corazon(0, y, 0.84, true, ink) : m === 'estrella' ? estrella(0, y, 0.48, true, ink) : rombo(0, y, 0.32, ink)) + linea(0.75, y, half, y, ink);
      }
      case 'circulo': return '<circle cx="0" cy="0" r="' + f2(Math.min(+el.radio || 4.2, ER - 0.15)) + '" fill="none" stroke="' + ink + '" stroke-width="' + HAIR + '"/>';
      case 'laurel': return laurel(Math.min(+el.radio || 5.4, 5.7), +el.desde || 98, +el.hasta || 232, +el.n || 7, ink);
      case 'rama': return rama(x, y, +el.x2 || 0, +el.y2 || 0, +el.n || 5, ink);
      case 'luna': return luna(x, y, +el.radio || 2.5, +el.giro || 0, ink);
      case 'silueta': return BIB[el.nombre] ? dibujo(BIB[el.nombre], x, y, tam || 6, ink) : '';
      case 'dibujo': return dibujoFoto(el, ink, laser);
      case 'constelacion': return constelacion(el.nombre, x, y, tam || 7, ink);
      case 'trazo': return trazo(el.d, x, y, tam || 6, ink);
      default: return '';
    }
  }
  function pintarCara(els, cx, cy, ink, laser) {
    if (!els || !els.length) return '';
    return '<g transform="translate(' + f2(cx) + ' ' + f2(cy) + ')">' + els.map(function (e) { return pintarElemento(e, ink, laser); }).join('') + '</g>';
  }

  // ---------- las letras, a trazos (fichero del láser) ----------
  // Susana, 24-sep-2026: «pasa las letras a trazos». En el fichero del láser cada texto va como su contorno
  // (<path>): el taller no instala ninguna letra y se graba exactamente lo que se ve. HarfBuzz (harfbuzzjs, MIT: el
  // mismo motor con el que Chrome coloca las letras) está en los assets del tema, junto a este fichero; las letras
  // son las TTF de Google Fonts (licencia libre), con su versión fija (las URL de LETRAS: las que da su CSS a un
  // navegador que no conoce), porque el CDN de Shopify sirve los .ttf del tema convertidos a WOFF2 y HarfBuzz no
  // los lee (comprobado el 24-sep-2026). Todo se carga solo cuando hace falta. HarfBuzz da la forma de cada
  // letra y su sitio: el avance, el interletraje, las ligaduras y las alternativas de la manuscrita, igual que la
  // vista previa. Con espaciado, como Chrome, sin ligaduras ni alternativas. En los textos del borde, cada letra se
  // gira sobre el arco como hace <textPath>. Comprobado contra Chrome, letra a letra, en hoja/prueba-trazos.html.
  // (opentype.js se probó antes y no sirve: no aplica bien el interletraje de Inter, Fredoka y Playfair.)
  var ASSETS = (function () { var s = document.currentScript && document.currentScript.src; return s ? s.split('?')[0].replace(/[^\/]*$/, '') : ''; })();
  var cargas = {};
  function cargarHarfbuzz() {
    if (window.cmHarfBuzz) return Promise.resolve(window.cmHarfBuzz);
    return cargas.hb || (cargas.hb = new Promise(function (ok, ko) {
      var t = setTimeout(function () { fin(new Error('harfbuzz: no llega')); }, 20000);
      function fin(e) { clearTimeout(t); window.removeEventListener('cm-harfbuzz', listo); if (e) ko(e); else ok(window.cmHarfBuzz); }
      function listo() { fin(window.cmHarfBuzz ? null : new Error('harfbuzz')); }
      window.addEventListener('cm-harfbuzz', listo);
      var s = document.createElement('script');
      s.type = 'module'; s.src = ASSETS + 'cm-harfbuzz.js';     // módulo: fija cmHarfBuzz y avisa con «cm-harfbuzz»
      s.onerror = function () { fin(new Error('harfbuzz')); };
      document.head.appendChild(s);
    }).catch(function (e) { delete cargas.hb; throw e; }));
  }
  // ---------- el fichero del láser, como lo quiere el taller ----------
  // Susana, 9-oct-2026, con cuatro SVG de Illustrator de muestra («este es el formato que necesitamos para poder
  // grabar directamente»): solo rellenos negros, sin trazos (stroke), sin textos, sin guías, y el lienzo ajustado al
  // dibujo. Los trazos (corazón, filete, laurel, dibujos de la biblioteca…) se pasan a su contorno y todo se une en un
  // solo <path> sin solapes: en el láser, un solape (la barra de la «A» de Inter sobre sus patas) puede quedar hueco.
  // Dos librerías, en los assets del tema: PathKit (cm-pathkit.*, pathkit-wasm 1.0.0, BSD: los trazos de Skia, el
  // motor de dibujo de Chrome) lee cada forma y pasa los trazos a contorno; Clipper (cm-clipper.js, clipper-lib 6.4.2,
  // Boost) une los contornos. La unión de PathKit no sirve: probado el 9-oct, en letras de Inter giradas sobre un arco
  // se comía el hueco de la «R» y de la «A». Clipper trabaja con enteros (aquí, décimas de micra) y no falla.
  function cargarScript(src, listo) {
    return new Promise(function (ok, ko) {
      if (listo()) { ok(); return; }
      var s = document.createElement('script');
      s.src = src; s.onload = function () { listo() ? ok() : ko(new Error(src)); }; s.onerror = function () { ko(new Error(src)); };
      document.head.appendChild(s);
    });
  }
  function cargarMotorLaser() {
    if (window.cmPathKit && window.ClipperLib) return Promise.resolve(window.cmPathKit);
    return cargas.laser || (cargas.laser = Promise.all([
      cargarScript(ASSETS + 'cm-pathkit.js', function () { return !!window.PathKitInit; }).then(function () {
        return window.cmPathKit || window.PathKitInit({ locateFile: function () { return ASSETS + 'cm-pathkit.wasm'; } });
      }),
      cargarScript(ASSETS + 'cm-clipper.js', function () { return !!window.ClipperLib; })
    ]).then(function (r) { window.cmPathKit = r[0]; return r[0]; }).catch(function (e) { delete cargas.laser; throw e; }));
  }
  // Lo que se graba de un SVG ya dibujado en la página (con las letras ya a trazos), como un solo contorno en las
  // unidades del SVG (mm). Cada forma, con su transformación; las blancas restan (huecos dibujados encima).
  var LASER_ESCALA = 10000, LASER_TOLERANCIA = 0.002;          // enteros de 0,1 µm; curvas en tramos de 2 µm de flecha
  function contornoLaser(svgEl, PK) {
    var CL = window.ClipperLib, raiz = svgEl.getScreenCTM().inverse(), total = [];
    var num = function (n, a) { return parseFloat(n.getAttribute(a)) || 0; };
    function dDe(n) {
      var t = n.tagName.toLowerCase(), x, y, rx, ry, w, h;
      if (t === 'path') return n.getAttribute('d');
      if (t === 'circle' || t === 'ellipse') {
        x = num(n, 'cx'); y = num(n, 'cy'); rx = t === 'circle' ? num(n, 'r') : num(n, 'rx'); ry = t === 'circle' ? rx : num(n, 'ry');
        return rx > 0 && ry > 0 ? 'M' + (x - rx) + ' ' + y + 'A' + rx + ' ' + ry + ' 0 1 0 ' + (x + rx) + ' ' + y + 'A' + rx + ' ' + ry + ' 0 1 0 ' + (x - rx) + ' ' + y + 'Z' : '';
      }
      if (t === 'rect') { x = num(n, 'x'); y = num(n, 'y'); w = num(n, 'width'); h = num(n, 'height'); return w > 0 && h > 0 ? 'M' + x + ' ' + y + 'h' + w + 'v' + h + 'h' + (-w) + 'Z' : ''; }
      if (t === 'line') return 'M' + num(n, 'x1') + ' ' + num(n, 'y1') + 'L' + num(n, 'x2') + ' ' + num(n, 'y2');
      if (t === 'polyline' || t === 'polygon') { var pts = (n.getAttribute('points') || '').trim(); return pts ? 'M' + pts + (t === 'polygon' ? 'Z' : '') : ''; }
      return '';
    }
    // De un path de PathKit (ya en mm) a polígonos de Clipper: las curvas, en tramos rectos
    function poligonos(p) {
      var polys = [], cur = null, x = 0, y = 0, S = LASER_ESCALA;
      var add = function (px, py) { cur.push({ X: Math.round(px * S), Y: Math.round(py * S) }); x = px; y = py; };
      var tramos = function (largo) { return Math.max(2, Math.min(64, Math.ceil(Math.sqrt(largo / LASER_TOLERANCIA)))); };
      p.toCmds().forEach(function (c) {
        var v = c[0], x0 = x, y0 = y, n, i, t, u;
        if (v === PK.MOVE_VERB) { cur = []; polys.push(cur); add(c[1], c[2]); }
        else if (!cur) return;
        else if (v === PK.LINE_VERB) add(c[1], c[2]);
        else if (v === PK.QUAD_VERB || v === PK.CONIC_VERB) {
          var w = v === PK.CONIC_VERB ? c[5] : 1;
          n = tramos(Math.hypot(c[1] - x0, c[2] - y0) + Math.hypot(c[3] - c[1], c[4] - c[2]));
          for (i = 1; i <= n; i++) {
            t = i / n; var a = (1 - t) * (1 - t), b = 2 * t * (1 - t) * w, e = t * t, den = a + b + e;
            add((a * x0 + b * c[1] + e * c[3]) / den, (a * y0 + b * c[2] + e * c[4]) / den);
          }
        } else if (v === PK.CUBIC_VERB) {
          n = tramos(Math.hypot(c[1] - x0, c[2] - y0) + Math.hypot(c[3] - c[1], c[4] - c[2]) + Math.hypot(c[5] - c[3], c[6] - c[4]));
          for (i = 1; i <= n; i++) {
            t = i / n; u = 1 - t;
            add(u * u * u * x0 + 3 * u * u * t * c[1] + 3 * u * t * t * c[3] + t * t * t * c[5], u * u * u * y0 + 3 * u * u * t * c[2] + 3 * u * t * t * c[4] + t * t * t * c[6]);
          }
        }
      });
      return polys.filter(function (q) { return q.length > 2; });
    }
    function operar(polys, regla, resta) {
      var c = new CL.Clipper(), sol = [];
      c.AddPaths(total, CL.PolyType.ptSubject, true);
      c.AddPaths(polys, CL.PolyType.ptClip, true);
      c.Execute(resta ? CL.ClipType.ctDifference : CL.ClipType.ctUnion, sol, CL.PolyFillType.pftNonZero, regla);
      total = sol;
    }
    var blanco = function (c) { return /^rgb\(\s*255,\s*255,\s*255\s*\)$/.test(c) || c === '#ffffff' || c === 'white'; };
    function poner(p, n, regla, resta) {
      var m = raiz.multiply(n.getScreenCTM());
      p.transform(m.a, m.c, m.e, m.b, m.d, m.f, 0, 0, 1);
      var polys = poligonos(p);
      p.delete();
      if (polys.length) operar(polys, regla, resta);
    }
    svgEl.querySelectorAll('path, circle, ellipse, rect, line, polyline, polygon').forEach(function (n) {
      if (n.closest('defs, clipPath, mask, symbol, marker, pattern')) return;
      var cs = getComputedStyle(n), d = dDe(n);
      if (!d || cs.display === 'none' || parseFloat(cs.opacity) === 0) return;
      if (cs.fill !== 'none') {
        var f = PK.FromSVGString(d);
        if (f) poner(f, n, cs.fillRule === 'evenodd' ? CL.PolyFillType.pftEvenOdd : CL.PolyFillType.pftNonZero, blanco(cs.fill));
      }
      var sw = parseFloat(cs.strokeWidth) || 0;
      if (cs.stroke !== 'none' && sw > 0) {
        var s = PK.FromSVGString(d);
        if (!s) return;
        var dash = cs.strokeDasharray && cs.strokeDasharray !== 'none' ? cs.strokeDasharray.split(/[\s,]+/).map(parseFloat).filter(function (v) { return v > 0; }) : [];
        if (dash.length) s.dash(dash[0], dash[1] || dash[0], 0);
        var ok = s.stroke({ width: sw, miter_limit: parseFloat(cs.strokeMiterlimit) || 4,
          cap: cs.strokeLinecap === 'round' ? PK.StrokeCap.ROUND : cs.strokeLinecap === 'square' ? PK.StrokeCap.SQUARE : PK.StrokeCap.BUTT,
          join: cs.strokeLinejoin === 'round' ? PK.StrokeJoin.ROUND : cs.strokeLinejoin === 'bevel' ? PK.StrokeJoin.BEVEL : PK.StrokeJoin.MITER });
        if (ok) poner(s, n, CL.PolyFillType.pftNonZero, blanco(cs.stroke)); else s.delete();
      }
    });
    if (!total.length) return null;
    var S = LASER_ESCALA, x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    total.forEach(function (r) { r.forEach(function (q) { x0 = Math.min(x0, q.X); y0 = Math.min(y0, q.Y); x1 = Math.max(x1, q.X); y1 = Math.max(y1, q.Y); }); });
    // El dibujo, pegado a la esquina (0, 0), como en las muestras de Illustrator; en mm con cuatro decimales
    var d = total.map(function (r) {
      return 'M' + r.map(function (q) { return +((q.X - x0) / S).toFixed(4) + ' ' + +((q.Y - y0) / S).toFixed(4); }).join('L') + 'Z';
    }).join('');
    return { d: d, x: x0 / S, y: y0 / S, w: (x1 - x0) / S, h: (y1 - y0) / S };
  }
  function ficheroLetra(letra, peso) {
    var l = LETRAS[letra];
    if (!l) return null;
    return 'https://fonts.gstatic.com/s/' + (typeof l.ttf === 'string' ? l.ttf : l.ttf[peso === 300 || peso === 700 ? peso : 400]) + '.ttf';
  }
  // El interletraje antiguo (tabla «kern», formato 0: pares de glifos), el que trae Permanent Marker en vez de GPOS.
  // Chrome lo aplica y este HarfBuzz no (harfbuzzjs viene sin él), así que se aplica aquí. null si no hay.
  function kernAntiguo(buf) {
    var v = new DataView(buf), n = v.getUint16(4), i, kern = null, gpos = false;
    for (i = 0; i < n; i++) {
      var tag = String.fromCharCode(v.getUint8(12 + 16 * i), v.getUint8(13 + 16 * i), v.getUint8(14 + 16 * i), v.getUint8(15 + 16 * i));
      if (tag === 'GPOS') gpos = true;
      if (tag === 'kern') kern = v.getUint32(20 + 16 * i);
    }
    if (gpos || kern == null || v.getUint16(kern) !== 0) return null;     // con GPOS, HarfBuzz ya hace el interletraje
    var pares = {}, sub = kern + 4, t, nt = v.getUint16(kern + 2);
    for (t = 0; t < nt; t++) {
      var largo = v.getUint16(sub + 2), cobertura = v.getUint16(sub + 4);
      if ((cobertura >> 8) === 0 && (cobertura & 1)) {                // formato 0, horizontal
        var np = v.getUint16(sub + 6), j, q = sub + 14;
        for (j = 0; j < np; j++, q += 6) pares[v.getUint16(q) + ',' + v.getUint16(q + 2)] = v.getInt16(q + 4);
      }
      sub += largo;
    }
    return pares;
  }
  // Una letra lista para colocar y dibujar: { hb, font, upem, kern (el antiguo, si lo hay), glifos (contornos ya leídos) }
  function cargarLetraTTF(letra, peso) {
    var f = ficheroLetra(letra, peso);
    if (!f) return Promise.reject(new Error('letra ' + letra));
    return cargas[f] || (cargas[f] = Promise.all([cargarHarfbuzz(), fetch(f).then(function (r) {
      if (!r.ok) throw new Error(f);
      return r.arrayBuffer();
    })]).then(function (a) {
      var hb = a[0], face = new hb.Face(new hb.Blob(a[1]));
      return { hb: hb, font: new hb.Font(face), upem: face.upem, kern: kernAntiguo(a[1]), glifos: {} };
    }).catch(function (e) { delete cargas[f]; throw e; }));
  }
  var SIN_LIGADURAS = ['liga', 'clig', 'dlig', 'hlig', 'calt'];
  // Dónde va cada letra de un texto, en mm: HarfBuzz da el glifo, su avance y su desplazamiento; el espaciado va
  // detrás de cada letra, la última también (como Chrome). Devuelve los glifos (id, x de la pluma, desplazamiento,
  // avance y el espaciado que lleva detrás) y el ancho total.
  function colocarGlifos(L, texto, tam, ls) {
    var hb = L.hb, b = new hb.Buffer(), k = tam / L.upem, x = 0, v = [];
    b.addText(String(texto));
    b.guessSegmentProperties();
    hb.shape(L.font, b, ls ? SIN_LIGADURAS.map(function (t) { return new hb.Feature(t, 0); }) : undefined);
    var info = b.getGlyphInfos(), pos = b.getGlyphPositions();
    info.forEach(function (g, i) {
      var cola = i === info.length - 1 || info[i + 1].cluster !== g.cluster ? ls : 0;
      var a = (pos[i].xAdvance + (L.kern && i < info.length - 1 ? L.kern[g.codepoint + ',' + info[i + 1].codepoint] || 0 : 0)) * k;
      v.push({ id: g.codepoint, c: g.cluster, x: x, dx: pos[i].xOffset * k, dy: -pos[i].yOffset * k, a: a, ls: cola });
      x += a + cola;
    });
    return { glifos: v, ancho: x };
  }
  function n3(v) { return String(Math.round(v * 1000) / 1000); }              // mm con tres decimales: 1 µm
  // El contorno de un glifo (unidades de la letra, y hacia arriba) en mm: su origen en (ox, oy), girado (c y s:
  // coseno y seno) y movido a (tx, ty)
  function datosGlifo(L, id, k, ox, oy, c, s, tx, ty) {
    var cmds = L.glifos[id] || (L.glifos[id] = L.font.glyphToJson(id));
    var p = function (u, w) { var x = ox + u * k, y = oy - w * k; return n3(x * c - y * s + tx) + ' ' + n3(x * s + y * c + ty); }, d = '';
    cmds.forEach(function (m) {
      var a = m.values;
      if (m.type === 'M' || m.type === 'L') d += m.type + p(a[0], a[1]);
      else if (m.type === 'Q') d += 'Q' + p(a[0], a[1]) + ' ' + p(a[2], a[3]);
      else if (m.type === 'C') d += 'C' + p(a[0], a[1]) + ' ' + p(a[2], a[3]) + ' ' + p(a[4], a[5]);
      else if (m.type === 'Z') d += 'Z';
    });
    return d;
  }
  // Un texto recto centrado en (x, y), con la y del motor (dominant-baseline central): la línea base está base·tam más abajo
  function trazoRecto(L, texto, tam, ls, x, y, base) {
    var c = colocarGlifos(L, texto, tam, ls), x0 = x - c.ancho / 2, yb = y + base * tam, k = tam / L.upem, d = '';
    c.glifos.forEach(function (q) { d += datosGlifo(L, q.id, k, x0 + q.x + q.dx, yb + q.dy, 1, 0, 0, 0); });
    return d;
  }
  // Un texto que sigue el borde, centrado arriba ('arriba' y 'anillo', sobre su línea base) o abajo ('abajo',
  // colgado de su «hanging»), como los caminos de pathText(): el punto medio de cada letra (con su espaciado) va
  // sobre el arco y la letra se gira con él. Lo que no cabe en el camino no se dibuja, igual que en el navegador.
  function trazoArco(L, texto, tam, ls, r, modo, colgar, puestos) {
    var c = colocarGlifos(L, texto, tam, ls), largo = (modo === 'anillo' ? 2 : 1) * Math.PI * r, s0 = (largo - c.ancho) / 2;
    var dv = modo === 'abajo' ? colgar * tam : 0, ini = modo === 'anillo' ? Math.PI / 2 : Math.PI, k = tam / L.upem, d = '';
    c.glifos.forEach(function (q) {
      var medio = (q.a + q.ls) / 2, s = s0 + q.x + medio;
      if (s < 0 || s > largo) return;
      var fi = modo === 'abajo' ? Math.PI - s / r : ini + s / r;
      var giro = modo === 'abajo' ? fi - Math.PI / 2 : fi + Math.PI / 2, co = Math.cos(giro), se = Math.sin(giro), px = r * Math.cos(fi), py = r * Math.sin(fi);
      if (puestos) puestos.push({ x: px - co * medio, y: py - se * medio, giro: giro * 180 / Math.PI });   // para las pruebas
      d += datosGlifo(L, q.id, k, -medio + q.dx, dv + q.dy, co, se, px, py);
    });
    return d;
  }
  // Cambia, dentro de un SVG ya dibujado (y en la página, para que el ajuste de seguridad haya podido medir), cada
  // texto del grabado por su contorno. Devuelve una promesa; si una letra no carga, falla y quien llama decide.
  function textosATrazos(cont) {
    var textos = Array.prototype.slice.call(cont.querySelectorAll('text[data-chk], text[data-ring]'));
    var fam = function (t) { return (t.getAttribute('font-family') || '').replace(/['"]/g, '').trim(); };
    var letras = {};
    textos.forEach(function (t) {
      var k = fam(t) + '|' + (+t.getAttribute('font-weight') || 400);
      if (!letras[k]) letras[k] = cargarLetraTTF(fam(t), +t.getAttribute('font-weight') || 400);
    });
    var claves = Object.keys(letras);
    return Promise.all(claves.map(function (k) { return letras[k]; })).then(function (fuentes) {
      var porClave = {};
      claves.forEach(function (k, i) { porClave[k] = fuentes[i]; });
      textos.forEach(function (t) {
        var f = fam(t), font = porClave[f + '|' + (+t.getAttribute('font-weight') || 400)], L = LETRAS[f];
        var tam = parseFloat(t.getAttribute('font-size')) || 2, ls = parseFloat(t.getAttribute('letter-spacing')) || 0;
        var tp = t.querySelector('textPath'), texto = (tp || t).textContent, d, guia = null;
        if (tp) {
          guia = cont.querySelector('#' + (tp.getAttribute('href') || tp.getAttribute('xlink:href') || '').slice(1));
          d = trazoArco(font, texto, tam, ls, parseFloat(t.getAttribute('data-ring')) || 5, t.getAttribute('data-modo'), L.colgar);
        } else {
          d = trazoRecto(font, texto, tam, ls, parseFloat(t.getAttribute('x')) || 0, parseFloat(t.getAttribute('y')) || 0, L.base);
        }
        var p = document.createElementNS(NS, 'path');
        p.setAttribute('d', d || 'M0 0');
        p.setAttribute('fill', t.getAttribute('fill') || '#000000');
        if (t.getAttribute('transform')) p.setAttribute('transform', t.getAttribute('transform'));
        p.setAttribute('data-texto', texto);
        p.setAttribute('data-letra', f + (f === 'Inter' ? ' ' + (+t.getAttribute('font-weight') || 400) : ''));
        t.parentNode.replaceChild(p, t);
        if (guia) guia.remove();                  // el camino del texto (sin trazo): el láser lo leería como una línea
      });
    });
  }

  // ---------- «Subir foto»: de una imagen a trazos ----------
  // Susana, 24-sep-2026: la clienta sube una foto de su letra o de un dibujo (se procesa aquí, al momento) o de su
  // mascota o de una persona (la dibuja la IA de imagen en el servidor, en línea fina). En los dos casos la imagen pasa
  // aquí a blanco y negro, se le quitan las motas, se recorta, la línea se deja de un grosor uniforme (el de la línea
  // fina de taller, 0,18 mm a su tamaño) y se convierte en contornos: un <path> que se ve en la vista previa, en las
  // miniaturas y en el JPG, y que va tal cual al fichero del láser. Los trazos se guardan en G.dibujos[ref] (y en la
  // sesión del navegador, por si se recarga); el diseño solo lleva el recuadro y la referencia (elemento «dibujo»).
  function aGris(fuente, maxLado) {
    var w0 = fuente.width, h0 = fuente.height, k = Math.min(1, maxLado / Math.max(w0, h0));
    var w = Math.max(1, Math.round(w0 * k)), h = Math.max(1, Math.round(h0 * k)), c = document.createElement('canvas');
    c.width = w; c.height = h;
    var x = c.getContext('2d');
    x.fillStyle = '#fff'; x.fillRect(0, 0, w, h); x.drawImage(fuente, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h).data, g = new Uint8Array(w * h), sat = new Uint8Array(w * h), i;
    for (i = 0; i < w * h; i++) {
      var r = d[i * 4], v = d[i * 4 + 1], a = d[i * 4 + 2], mx = Math.max(r, v, a), mn = Math.min(r, v, a);
      g[i] = (r * 299 + v * 587 + a * 114) / 1000;
      sat[i] = mx ? (mx - mn) * 255 / mx : 0;          // cuánto color tiene (el papel, poco; la madera, mucho)
    }
    return { g: g, sat: sat, w: w, h: h };
  }
  function umbralFijo(g, t) { var b = new Uint8Array(g.length); for (var i = 0; i < g.length; i++) b[i] = g[i] < t ? 1 : 0; return b; }
  // Umbral local (Bradley): cada píxel contra la media de su entorno, para fotos de papel con sombras y luz desigual
  function umbralLocal(g, w, h) {
    var r = Math.max(8, Math.round(Math.max(w, h) / 24)), W = w + 1, I = new Float64Array(W * (h + 1)), b = new Uint8Array(w * h), x, y;
    for (y = 1; y <= h; y++) { var fila = 0; for (x = 1; x <= w; x++) { fila += g[(y - 1) * w + x - 1]; I[y * W + x] = I[(y - 1) * W + x] + fila; } }
    for (y = 0; y < h; y++) {
      var y0 = Math.max(0, y - r), y1 = Math.min(h - 1, y + r);
      for (x = 0; x < w; x++) {
        var x0 = Math.max(0, x - r), x1 = Math.min(w - 1, x + r), n = (x1 - x0 + 1) * (y1 - y0 + 1);
        var media = (I[(y1 + 1) * W + x1 + 1] - I[y0 * W + x1 + 1] - I[(y1 + 1) * W + x0] + I[y0 * W + x0]) / n, v = g[y * w + x];
        b[y * w + x] = v < media * 0.85 && v < media - 14 ? 1 : 0;
      }
    }
    return b;
  }
  function otsu(g) {
    var hist = new Array(256).fill(0), total = g.length, suma = 0, sumB = 0, wB = 0, max = 0, t = 128, i;
    for (i = 0; i < total; i++) hist[g[i]]++;
    for (i = 0; i < 256; i++) suma += i * hist[i];
    for (i = 0; i < 256; i++) {
      wB += hist[i]; if (!wB) continue;
      var wF = total - wB; if (!wF) break;
      sumB += i * hist[i];
      var mB = sumB / wB, mF = (suma - sumB) / wF, entre = wB * wF * (mB - mF) * (mB - mF);
      if (entre > max) { max = entre; t = i; }
    }
    return t;
  }
  // El papel de una foto: la zona clara más grande, con lo escrito dentro (sus huecos), un poco hacia dentro para que su
  // borde no cuente como tinta. Así la mesa, la veta de la madera o la sombra del móvil no se graban. null si no hay un
  // papel claro (la foto es toda del dibujo): entonces vale la foto entera.
  function zonaDelPapel(g, sat, w, h) {
    var t = otsu(g), claro = new Uint8Array(w * h), eti = new Int32Array(w * h), pila = new Int32Array(w * h), mejor = 0, area = 0, e = 0, i;
    for (i = 0; i < w * h; i++) claro[i] = g[i] >= t && sat[i] < 70 ? 1 : 0;           // claro y casi sin color
    // un reflejo de la ventana en la mesa puede tocar el papel por un hilo de píxeles: se corta encogiendo lo claro
    // antes de buscar la zona más grande, y después se le devuelve su tamaño
    var r = Math.max(2, Math.round(Math.max(w, h) / 90)), nucleo = cambiarGrosor(claro, w, h, -r);
    for (i = 0; i < w * h; i++) {
      if (!nucleo[i] || eti[i]) continue;
      e++; var top = 0, n = 0; pila[top++] = i; eti[i] = e;
      while (top) {
        var q = pila[--top], qx = q % w; n++;
        if (qx > 0 && !eti[q - 1] && nucleo[q - 1]) { eti[q - 1] = e; pila[top++] = q - 1; }
        if (qx < w - 1 && !eti[q + 1] && nucleo[q + 1]) { eti[q + 1] = e; pila[top++] = q + 1; }
        if (q >= w && !eti[q - w] && nucleo[q - w]) { eti[q - w] = e; pila[top++] = q - w; }
        if (q < w * (h - 1) && !eti[q + w] && nucleo[q + w]) { eti[q + w] = e; pila[top++] = q + w; }
      }
      if (n > area) { area = n; mejor = e; }
    }
    if (area < 0.08 * w * h || area > 0.95 * w * h) return null;
    var papel = new Uint8Array(w * h), fuera = new Uint8Array(w * h), top2 = 0;
    for (i = 0; i < w * h; i++) papel[i] = eti[i] === mejor ? 1 : 0;
    papel = cambiarGrosor(papel, w, h, r + 1);
    for (i = 0; i < w * h; i++) papel[i] &= claro[i];
    for (i = 0; i < w * h; i++) {                      // lo que no es papel y toca el borde de la foto está fuera
      var bx = i % w, by = (i - bx) / w;
      if ((bx === 0 || by === 0 || bx === w - 1 || by === h - 1) && !papel[i] && !fuera[i]) { fuera[i] = 1; pila[top2++] = i; }
    }
    while (top2) {
      var p = pila[--top2], px = p % w;
      if (px > 0 && !papel[p - 1] && !fuera[p - 1]) { fuera[p - 1] = 1; pila[top2++] = p - 1; }
      if (px < w - 1 && !papel[p + 1] && !fuera[p + 1]) { fuera[p + 1] = 1; pila[top2++] = p + 1; }
      if (p >= w && !papel[p - w] && !fuera[p - w]) { fuera[p - w] = 1; pila[top2++] = p - w; }
      if (p < w * (h - 1) && !papel[p + w] && !fuera[p + w]) { fuera[p + w] = 1; pila[top2++] = p + w; }
    }
    for (i = 0; i < w * h; i++) if (!fuera[i]) papel[i] = 1;          // lo escrito (los huecos del papel) es papel
    return cambiarGrosor(papel, w, h, -Math.max(3, Math.round(Math.max(w, h) / 120)));
  }
  function quitarMotas(b, w, h, minimo) {             // manchas sueltas (polvo, ruido, la sombra de una esquina)
    var eti = new Int32Array(w * h), pila = new Int32Array(w * h), areas = [0], i, e = 0;
    for (i = 0; i < w * h; i++) {
      if (!b[i] || eti[i]) continue;
      e++; var top = 0, area = 0; pila[top++] = i; eti[i] = e;
      while (top) {
        var q = pila[--top], qx = q % w, qy = (q - qx) / w; area++;
        for (var dy = -1; dy <= 1; dy++) for (var dx = -1; dx <= 1; dx++) {
          var nx = qx + dx, ny = qy + dy;
          if (nx < 0 || ny < 0 || nx >= w || ny >= h) continue;
          var k = ny * w + nx;
          if (b[k] && !eti[k]) { eti[k] = e; pila[top++] = k; }
        }
      }
      areas.push(area);
    }
    for (i = 0; i < w * h; i++) if (b[i] && areas[eti[i]] < minimo) b[i] = 0;
  }
  function recortar(b, w, h, m) {
    var x0 = w, y0 = h, x1 = -1, y1 = -1, x, y;
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) if (b[y * w + x]) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    if (x1 < 0) return null;
    var W = x1 - x0 + 1 + 2 * m, H = y1 - y0 + 1 + 2 * m, o = new Uint8Array(W * H);
    for (y = y0; y <= y1; y++) for (x = x0; x <= x1; x++) o[(y - y0 + m) * W + x - x0 + m] = b[y * w + x];
    return { b: o, w: W, h: H };
  }
  // Distancia (chaflán 3-4, en px) de cada píxel de valor a al más cercano de otro valor
  function distancia(b, w, h, a) {
    var d = new Float32Array(w * h), x, y, i, v;
    for (i = 0; i < w * h; i++) d[i] = b[i] === a ? 1e9 : 0;
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
      i = y * w + x; if (!d[i]) continue; v = d[i];
      if (x > 0) v = Math.min(v, d[i - 1] + 3);
      if (y > 0) { v = Math.min(v, d[i - w] + 3); if (x > 0) v = Math.min(v, d[i - w - 1] + 4); if (x < w - 1) v = Math.min(v, d[i - w + 1] + 4); }
      d[i] = v;
    }
    for (y = h - 1; y >= 0; y--) for (x = w - 1; x >= 0; x--) {
      i = y * w + x; if (!d[i]) continue; v = d[i];
      if (x < w - 1) v = Math.min(v, d[i + 1] + 3);
      if (y < h - 1) { v = Math.min(v, d[i + w] + 3); if (x < w - 1) v = Math.min(v, d[i + w + 1] + 4); if (x > 0) v = Math.min(v, d[i + w - 1] + 4); }
      d[i] = v;
    }
    for (i = 0; i < w * h; i++) d[i] /= 3;
    return d;
  }
  function grosorDeLinea(b, w, h) {                   // el de la mayoría de sus líneas (mediana de las crestas)
    var d = distancia(b, w, h, 1), v = [], x, y;
    for (y = 1; y < h - 1; y++) for (x = 1; x < w - 1; x++) {
      var i = y * w + x, di = d[i];
      if (di && di >= d[i - 1] && di >= d[i + 1] && di >= d[i - w] && di >= d[i + w]) v.push(di);
    }
    if (!v.length) return 1;
    v.sort(function (p, q) { return p - q; });
    return Math.max(1, 2 * v[v.length >> 1] - 1);
  }
  function cambiarGrosor(b, w, h, r) {                // r > 0 engorda y r < 0 adelgaza, en px por cada lado
    if (Math.abs(r) < 0.5) return b;
    var fuera = r > 0, d = distancia(b, w, h, fuera ? 0 : 1), o = new Uint8Array(b), a = Math.abs(r);
    for (var i = 0; i < w * h; i++) if (fuera ? !b[i] && d[i] <= a : b[i] && d[i] <= a) o[i] = fuera ? 1 : 0;
    return o;
  }
  // Contornos (cuadrados en marcha) con la tinta siempre a la derecha, así cada punto sigue a uno solo; en diagonal la
  // tinta se toca (8 vecinos), para que una línea fina no se corte. Devuelve lazos [x0, y0, x1, y1, …] en px.
  function contornos(b, w, h) {
    var W2 = 2 * w + 6, sig = new Map(), x, y;
    var v = function (px, py) { return px >= 0 && py >= 0 && px < w && py < h && b[py * w + px] ? 1 : 0; };
    var clave = function (px, py) { return (py + 2) * W2 + px + 2; };
    var seg = function (ax, ay, bx, by) { sig.set(clave(ax, ay), [ax, ay, bx, by]); };
    for (y = -1; y < h; y++) for (x = -1; x < w; x++) {
      var c = v(x, y) * 8 + v(x + 1, y) * 4 + v(x + 1, y + 1) * 2 + v(x, y + 1);
      if (!c || c === 15) continue;
      var Tx = 2 * x + 1, Ty = 2 * y, Rx = 2 * x + 2, Ry = 2 * y + 1, Bx = 2 * x + 1, By = 2 * y + 2, Lx = 2 * x, Ly = 2 * y + 1;
      switch (c) {
        case 8: seg(Tx, Ty, Lx, Ly); break;
        case 4: seg(Rx, Ry, Tx, Ty); break;
        case 2: seg(Bx, By, Rx, Ry); break;
        case 1: seg(Lx, Ly, Bx, By); break;
        case 7: seg(Lx, Ly, Tx, Ty); break;
        case 11: seg(Tx, Ty, Rx, Ry); break;
        case 13: seg(Rx, Ry, Bx, By); break;
        case 14: seg(Bx, By, Lx, Ly); break;
        case 12: seg(Rx, Ry, Lx, Ly); break;
        case 3: seg(Lx, Ly, Rx, Ry); break;
        case 9: seg(Tx, Ty, Bx, By); break;
        case 6: seg(Bx, By, Tx, Ty); break;
        case 10: seg(Tx, Ty, Rx, Ry); seg(Bx, By, Lx, Ly); break;
        case 5: seg(Lx, Ly, Tx, Ty); seg(Rx, Ry, Bx, By); break;
      }
    }
    var lazos = [];
    sig.forEach(function (s0) {
      if (s0.hecho) return;
      var lazo = [], sg = s0;
      while (sg && !sg.hecho) { sg.hecho = 1; lazo.push(sg[0] / 2, sg[1] / 2); sg = sig.get(clave(sg[2], sg[3])); }
      if (lazo.length >= 6) lazos.push(lazo);
    });
    return lazos;
  }
  function simplificar(p, tol) {                       // Ramer-Douglas-Peucker sobre un lazo cerrado
    var n = p.length / 2, marca = new Uint8Array(n), i, lejos = 0, dmax = -1;
    if (n < 4) return p;
    for (i = 1; i < n; i++) { var dx = p[2 * i] - p[0], dy = p[2 * i + 1] - p[1]; if (dx * dx + dy * dy > dmax) { dmax = dx * dx + dy * dy; lejos = i; } }
    marca[0] = marca[lejos] = 1;
    var pila = [[0, lejos], [lejos, n]], t2 = tol * tol;
    while (pila.length) {
      var s = pila.pop(), a = s[0], z = s[1], ax = p[2 * a], ay = p[2 * a + 1], bx = p[2 * (z % n)], by = p[2 * (z % n) + 1];
      var ux = bx - ax, uy = by - ay, uu = ux * ux + uy * uy, mejor = -1, dm = t2;
      for (var j = a + 1; j < z; j++) {
        var px = p[2 * j] - ax, py = p[2 * j + 1] - ay, t = uu ? Math.max(0, Math.min(1, (px * ux + py * uy) / uu)) : 0;
        var ex = px - t * ux, ey = py - t * uy, d2 = ex * ex + ey * ey;
        if (d2 > dm) { dm = d2; mejor = j; }
      }
      if (mejor > 0) { marca[mejor] = 1; pila.push([a, mejor], [mejor, z]); }
    }
    var o = [];
    for (i = 0; i < n; i++) if (marca[i]) o.push(p[2 * i], p[2 * i + 1]);
    return o;
  }
  // La imagen (foto de papel o dibujo de la IA), a trazos: { d (en px), w, h } del recuadro de su tinta. grosor: el de la
  // línea, en fracción del lado mayor (0,016 ≈ 0,18 mm con el dibujo a 11 mm); foto: umbral local (fotos de papel)
  function trazarImagen(fuente, o) {
    var gr = aGris(fuente, o.maxLado || 1200), b = o.foto ? umbralLocal(gr.g, gr.w, gr.h) : umbralFijo(gr.g, 140);
    if (o.foto) {
      var papel = zonaDelPapel(gr.g, gr.sat, gr.w, gr.h);
      if (papel) for (var i = 0; i < b.length; i++) b[i] &= papel[i];
    }
    quitarMotas(b, gr.w, gr.h, Math.max(10, Math.round(gr.w * gr.h / 25000)));
    var lado = Math.max(gr.w, gr.h), m = Math.ceil(lado * (o.grosor || 0.02)) + 2, r = recortar(b, gr.w, gr.h, m);
    if (!r) return null;
    if (o.grosor) {
      var ahora = grosorDeLinea(r.b, r.w, r.h), quiero = o.grosor * Math.max(r.w - 2 * m, r.h - 2 * m);
      r.b = cambiarGrosor(r.b, r.w, r.h, Math.max(-ahora / 3, (quiero - ahora) / 2));
    }
    var lazos = contornos(r.b, r.w, r.h).map(function (l) { return simplificar(l, 0.6); }), x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9, d = '';
    lazos.forEach(function (l) { for (var i = 0; i < l.length; i += 2) { x0 = Math.min(x0, l[i]); x1 = Math.max(x1, l[i]); y0 = Math.min(y0, l[i + 1]); y1 = Math.max(y1, l[i + 1]); } });
    if (!lazos.length) return null;
    lazos.forEach(function (l) {
      for (var i = 0; i < l.length; i += 2) d += (i ? 'L' : 'M') + (Math.round((l[i] - x0) * 10) / 10) + ' ' + (Math.round((l[i + 1] - y0) * 10) / 10);
      d += 'Z';
    });
    return { d: d, w: Math.round((x1 - x0) * 10) / 10, h: Math.round((y1 - y0) * 10) / 10 };
  }
  // El dibujo en la medalla: sus trazos, encajados en su recuadro sin deformarse. Si falta (la página se ha recargado y
  // la sesión no lo guardaba), un recuadro que pide volver a subir la foto; en el fichero del láser, nada.
  function dibujoFoto(el, ink, laser) {
    var d = G.dibujos && G.dibujos[el.ref], W = +el.ancho || +el.tam || 8, H = +el.tam || 8, cx = +el.x || 0, cy = +el.y || 0;
    if (!d && el.ref === 'ia') return laser ? '' : '<text x="' + f2(cx) + '" y="' + f2(cy) + '" text-anchor="middle" dominant-baseline="central" font-family="system-ui, sans-serif" font-size="1" fill="' + ink + '" opacity=".75">Dibujando…</text>';
    if (!d) return laser ? '' : '<rect x="' + f2(cx - W / 2) + '" y="' + f2(cy - H / 2) + '" width="' + f2(W) + '" height="' + f2(H) + '" rx=".6" fill="none" stroke="' + ink +
      '" stroke-width=".12" stroke-dasharray=".5 .35"/><text x="' + f2(cx) + '" y="' + f2(cy) + '" text-anchor="middle" dominant-baseline="central" font-family="system-ui, sans-serif" font-size=".9" fill="' + ink + '">Vuelve a subir la foto</text>';
    var k = Math.min(W / d.w, H / d.h);
    return '<path d="' + d.d + '" transform="translate(' + f2(cx - d.w * k / 2) + ' ' + f2(cy - d.h * k / 2) + ') scale(' + k.toFixed(5) + ')" fill="' + ink + '" fill-rule="evenodd"/>';
  }
  G.dibujos = G.dibujos || (function () { try { return JSON.parse(sessionStorage.getItem('cm-ia-dibujos') || '{}') || {}; } catch (e) { return {}; } })();
  function guardarDibujos() { try { sessionStorage.setItem('cm-ia-dibujos', JSON.stringify(G.dibujos)); } catch (e) {} }

  // ---------- resumen legible para el pedido ----------
  // Nombres en castellano de los adornos: este resumen lo leen la clienta (paso 3) y el taller
  // (propiedades «Delante» y «Detrás» del pedido), así que nada de nombres internos.
  var ADORNO = {
    corazon: 'corazón', estrella: 'estrella', infinito: 'infinito', destello: 'destello',
    filete: 'filete', circulo: 'filete circular', laurel: 'corona de laurel',
    rama: 'rama de olivo', luna: 'luna'
  };
  function yLista(a) { return a.length < 2 ? (a[0] || '') : a.slice(0, -1).join(', ') + ' y ' + a[a.length - 1]; }
  function resumen(els) {
    if (!els || !els.length) return 'Sin grabado';
    var textos = [], adornos = {}, letras = {};
    els.forEach(function (e) {
      if (e.tipo === 'texto' || e.tipo === 'arco' || e.tipo === 'circulo_texto') {
        // El texto en anillo cierra con un « ·» para dar la vuelta entera; en el resumen sobra.
        textos.push('«' + String(e.texto || '').replace(/\s*·\s*$/, '').trim() + '»');
        if (e.letra) letras[e.letra + (e.letra === 'Inter' && pesoDe(e) === 700 ? ' negrita' : '')] = 1;
      }
      else if (e.tipo === 'silueta') adornos[NOMBRE_SILUETA[e.nombre] || ('silueta de ' + e.nombre)] = 1;
      else if (e.tipo === 'dibujo') {                  // el taller lee aquí si es línea fina o fotojoya
        var dd = G.dibujos[e.ref] || {};
        if (dd.tipo === 'ilustracion') adornos['dibujo hecho por la IA (' + (dd.nombre || 'sin descripción') + ')'] = 1;
        else if (dd.tipo === 'catalogo') adornos['dibujo «' + (dd.nombre || '') + '» (biblioteca)'] = 1;
        else adornos[DIBUJO_DE[dd.tipo + (dd.estilo === 'fotojoya' ? '-fotojoya' : '')] || DIBUJO_DE[dd.tipo] || 'dibujo de su foto'] = 1;
      }
      else if (e.tipo === 'constelacion') adornos['constelación de ' + String(e.nombre || '').charAt(0).toUpperCase() + String(e.nombre || '').slice(1)] = 1;
      else if (e.tipo === 'trazo') adornos['dibujo'] = 1;
      else if (e.tipo === 'filete') adornos['filete' + (e.motivo === 'corazon' ? ' con corazón'
        : e.motivo === 'estrella' ? ' con estrella' : '')] = 1;
      else if (e.tipo !== 'punto') adornos[ADORNO[e.tipo] || e.tipo] = 1;
    });
    var ad = Object.keys(adornos), fu = Object.keys(letras), partes = [];
    // La letra va una sola vez al final, no detrás de cada texto.
    if (textos.length) partes.push(textos.join(' · '));
    if (ad.length) partes.push(yLista(ad));
    if (fu.length) partes.push('letra ' + yLista(fu));
    return partes.length ? partes.join(' · ') : 'Solo dibujo';
  }


  // ---------- atajos de retoque ----------
  // Solo deciden QUÉ se le ofrece; el cambio en sí lo hace la IA en el servidor.
  var QUITAR = {
    corazon: 'el corazón', estrella: 'la estrella', infinito: 'el infinito', destello: 'el destello',
    filete: 'el filete', circulo: 'el filete circular', laurel: 'la corona de laurel',
    rama: 'la rama de olivo', luna: 'la luna', silueta: 'la silueta',
    constelacion: 'la constelación', trazo: 'el dibujo'
  };
  // Las ilustraciones de la guía de grabado (brújula, trébol, montaña, cáliz…) vienen de
  // cm-ilustraciones.js, que se carga antes. Se añaden a la biblioteca de siluetas al arrancar.
  function cargarIlustraciones() {
    var I = window.cmIlustraciones && window.cmIlustraciones.ILUS;
    if (I) Object.keys(I).forEach(function (k) { BIB[k] = I[k]; });
  }
  var NOMBRE_SILUETA = { brujula: 'brújula', trebol: 'trébol', montana: 'montaña', caliz: 'cáliz', cruz: 'cruz' };
  var DIBUJO_DE = { letra: 'su letra o dibujo (de su foto)', mascota: 'dibujo de su mascota (IA, de su foto)', retrato: 'retrato (IA, de su foto)',
    'mascota-fotojoya': 'fotojoya de su mascota (IA, de su foto)', 'retrato-fotojoya': 'retrato en fotojoya (IA, de su foto)' };
  var QUITAR_SILUETA = { brujula: 'la brújula', trebol: 'el trébol', montana: 'la montaña', caliz: 'el cáliz', cruz: 'la cruz' };
  var ES_TEXTO = { texto: 1, arco: 1, circulo_texto: 1 };
  function textosDe(els) { return (els || []).filter(function (e) { return ES_TEXTO[e.tipo]; }); }
  function adornosDe(els) {
    var v = [];
    (els || []).forEach(function (e) {
      var k = e.tipo === 'silueta' ? 'silueta:' + e.nombre : e.tipo;
      if (!ES_TEXTO[e.tipo] && e.tipo !== 'punto' && v.indexOf(k) < 0) v.push(k);
    });
    return v;
  }
  var FECHA = /[0-9]{1,2}[./-][0-9]{1,2}[./-][0-9]{2,4}|(19|20)[0-9]{2}/;
  function conFecha(els) { return textosDe(els).filter(function (e) { return FECHA.test(e.texto || ''); }); }
  function principalDe(els) {
    var c = null;
    textosDe(els).forEach(function (e) { if (!c || (+e.tam || 0) > (+c.tam || 0)) c = e; });
    return c;
  }
  // Hasta cuatro, en orden de utilidad y según lo que tenga la medalla elegida.
  function atajos(p) {
    var v = [], ad = adornosDe(p.delante), pr = principalDe(p.delante);
    var q = ad.length && (ad[0].indexOf('silueta:') === 0 ? QUITAR_SILUETA[ad[0].slice(8)] : QUITAR[ad[0]]);
    if (q) v.push('quita ' + q);
    if (conFecha(p.delante).length || conFecha(p.detras).length) v.push('la fecha en romanos');
    if (!(p.detras && p.detras.length)) v.push('algo por detrás');
    if (pr && !/[0-9]/.test(pr.texto || '')) v.push('más grande el nombre');
    if (ad.indexOf('corazon') < 0) v.push('añade un corazón');
    if (ad.indexOf('estrella') < 0) v.push('añade una estrella');
    if (pr && pr.texto !== String(pr.texto || '').toLocaleUpperCase('es-ES')) v.push('en mayúsculas');
    return v.slice(0, 4);
  }
  // ---------- ficha ----------
  function el(tag, attrs, parent) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { if (attrs[k] != null) n.setAttribute(k, attrs[k]); });
    if (parent) parent.appendChild(n);
    return n;
  }
  // En el móvil, al tocar un botón con el teclado abierto, la caja de texto perdía el foco, el teclado se
  // cerraba y la página se recolocaba antes de que llegara el toque: el primero se perdía («tengo que darle a
  // Aplicar dos veces», Susana, 23-sep-2026). Con esto la caja conserva el foco hasta que el botón ha hecho lo
  // suyo; después se cierra el teclado a mano.
  function sinQuitarFoco(b) { b.addEventListener('mousedown', function (e) { e.preventDefault(); }); return b; }
  // Desplegables como los del tema («Descripción», «Detalles y cuidados»): el título, una línea con lo que hay dentro
  // y la cruz del tema (animated-plus), que gira con aria-expanded. Susana, 24-sep-2026: «veo el botón de añadir a la
  // cesta muy abajo, quizás con desplegables». Van cerrados «¿Cambiamos algo?» y «Revisa y confirma».
  // n: el número del paso, si el desplegable es un paso entero («Revisa y confirma» es el 3); clase: su estado (is-active).
  function cabDesplegable(id, titulo, sub, abierto, extra, n, clase) {
    return '<button type="button" class="cm-dp__cab group' + (clase ? ' ' + clase : '') + '" aria-expanded="' + (abierto ? 'true' : 'false') + '" aria-controls="' + id + '"' + (extra || '') + '>' +
      (n ? '<span class="cm-dp__n" aria-hidden="true">' + n + '</span>' : '') +
      '<span class="cm-dp__txt"><span class="cm-dp__tit">' + esc(titulo) + '</span><span class="cm-dp__sub">' + esc(sub || '') + '</span></span>' +
      '<span class="animated-plus group-expanded:rotate" aria-hidden="true"></span></button>';
  }
  function copia(o) { return o == null ? o : JSON.parse(JSON.stringify(o)); }
  function refsDe(p) {
    var v = [];
    ['delante', 'detras'].forEach(function (k) { ((p && p[k]) || []).forEach(function (e) { if (e && e.tipo === 'dibujo' && e.ref) v.push(e.ref); }); });
    return v;
  }
  var ICONO_FOTO = {
    camara: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 8.5a2 2 0 0 1 2-2h2.2l1.4-2h5.8l1.4 2h2.2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z"/><circle cx="12" cy="13" r="3.6"/></svg>',
    letra: '<svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 19c2.5-.3 3.6-2.6 4.6-5.4C9.8 10 11 5 14.4 5c2 0 2.4 2.1 1.5 4-1 2.1-3.6 3.6-5.6 3.9M12.5 19H20"/></svg>',
    pata: '<svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><ellipse cx="7.2" cy="9.3" rx="1.7" ry="2.2"/><ellipse cx="11" cy="6.6" rx="1.7" ry="2.3"/><ellipse cx="15" cy="6.8" rx="1.7" ry="2.3"/><ellipse cx="18.3" cy="10" rx="1.6" ry="2.1"/><path d="M8.4 16.5c0-2.8 2-5 4-5s3.9 2.2 3.9 5c0 2-1.7 2.6-3.9 2.6s-4-.6-4-2.6z"/></svg>',
    persona: '<svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="8.3" r="3.6"/><path d="M4.8 19.5c.8-3.6 3.7-5.6 7.2-5.6s6.4 2 7.2 5.6"/></svg>',
    candado: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#6b625c" stroke-width="1.8" aria-hidden="true"><rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/></svg>'
  };

  // ---------- compartir: el diseño viaja dentro del enlace (Susana, 23-sep-2026: «que genere un enlace») ----------
  // Nada se guarda en el servidor (ni nombres ni fechas): el enlace lleva el diseño en ?diseno=1.<base64url de un
  // JSON con claves cortas>. Quien lo abre ve la misma medalla, con el mismo metal, y puede retocarla o pedirla.
  // Un enlace se puede manipular, así que lo que trae se sanea con las mismas reglas que el servidor (_elemento
  // en app/ia.py): solo esos tipos y campos, las diez letras, los dibujos de la biblioteca y números acotados.
  var CAMPOS_IA = {
    texto: ['texto', 'letra', 'peso', 'tam', 'espaciado', 'x', 'y'],
    arco: ['texto', 'letra', 'peso', 'tam', 'espaciado', 'radio', 'posicion'],
    circulo_texto: ['texto', 'letra', 'peso', 'tam', 'espaciado', 'radio'],
    corazon: ['x', 'y', 'tam', 'relleno'],
    estrella: ['x', 'y', 'tam', 'relleno'],
    luna: ['x', 'y', 'radio', 'giro'],
    filete: ['y', 'ancho', 'motivo'],
    silueta: ['nombre', 'x', 'y', 'tam']
  };
  var NUM_IA = { tam: [0.2, 20], x: [-12, 12], y: [-12, 12], radio: [0, 12], espaciado: [0, 0.3], ancho: [0, 12], giro: [-360, 360], peso: [100, 900] };
  var SILUETAS_IA = ['montana', 'caliz', 'brujula', 'trebol', 'cruz'];
  var CLAVE_CORTA = { tipo: 't', texto: 's', letra: 'l', tam: 'z', x: 'x', y: 'y', peso: 'w', espaciado: 'k', radio: 'r', posicion: 'p', relleno: 'f', nombre: 'n', giro: 'g', ancho: 'a', motivo: 'm' };
  var TIPO_CORTO = { texto: 't', arco: 'a', circulo_texto: 'c', corazon: 'h', estrella: 'e', luna: 'l', filete: 'f', silueta: 's' };
  function invertir(o) { var r = {}; Object.keys(o).forEach(function (k) { r[o[k]] = k; }); return r; }
  var CLAVE_LARGA = invertir(CLAVE_CORTA), TIPO_LARGO = invertir(TIPO_CORTO);
  function tiene(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  function saneaElemento(e) {
    if (!e || typeof e !== 'object' || typeof e.tipo !== 'string' || !tiene(CAMPOS_IA, e.tipo)) return null;
    var o = { tipo: e.tipo };
    CAMPOS_IA[e.tipo].forEach(function (k) {
      var v = e[k];
      if (v == null) return;
      if (tiene(NUM_IA, k)) { v = +v; if (isFinite(v)) o[k] = Math.min(NUM_IA[k][1], Math.max(NUM_IA[k][0], Math.round(v * 100) / 100)); }
      else if (k === 'relleno') o[k] = !!v;
      else o[k] = String(v).replace(/[\u0000-\u001f\u007f]/g, '').slice(0, 80);
    });
    if (tiene(ES_TEXTO, o.tipo)) {
      if (!o.texto || !o.texto.trim()) return null;
      o.letra = familiaDe(o.letra, o.texto);
      o.tam = Math.max(o.tam || 0, minFont(o.letra));
      if (o.letra === 'Inter') { if (o.peso != null) o.peso = o.peso <= 350 ? 300 : o.peso < 650 ? 400 : 700; }
      else delete o.peso;
      if (!LETRAS[o.letra].esp) delete o.espaciado;
      if (o.tipo === 'arco') o.posicion = o.posicion === 'abajo' ? 'abajo' : 'arriba';
    } else if (o.tipo === 'silueta') { if (SILUETAS_IA.indexOf(o.nombre) < 0) return null; }
    else if (o.tipo === 'filete') o.motivo = o.motivo === 'corazon' ? 'corazon' : 'ninguno';
    else if (o.tipo === 'corazon') o.relleno = !!o.relleno && (o.tam || 1) <= 0.8;
    else if (o.tipo === 'estrella') o.relleno = !!o.relleno && (o.tam || 0.5) <= 0.5;
    return o;
  }
  function aBase64url(s) {
    var b = new TextEncoder().encode(s), t = '', i;
    for (i = 0; i < b.length; i++) t += String.fromCharCode(b[i]);
    return btoa(t).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function deBase64url(s) {
    s = s.replace(/-/g, '+').replace(/_/g, '/');
    while (s.length % 4) s += '=';
    var t = atob(s), b = new Uint8Array(t.length), i;
    for (i = 0; i < t.length; i++) b[i] = t.charCodeAt(i);
    return new TextDecoder().decode(b);
  }
  function caraCorta(els) {
    return (els || []).map(saneaElemento).filter(Boolean).map(function (e) {
      var c = {};
      Object.keys(e).forEach(function (k) { c[CLAVE_CORTA[k]] = k === 'tipo' ? TIPO_CORTO[e.tipo] : k === 'letra' ? LETRA_CORTA[e.letra] : e[k]; });
      return c;
    });
  }
  function caraLarga(els) {
    if (!Array.isArray(els)) return null;
    var v = els.slice(0, 10).map(function (c) {
      if (!c || typeof c !== 'object') return null;
      var e = {};
      Object.keys(c).forEach(function (k) { if (tiene(CLAVE_LARGA, k)) e[CLAVE_LARGA[k]] = c[k]; });
      e.tipo = tiene(TIPO_LARGO, c.t) ? TIPO_LARGO[c.t] : '';
      if (tiene(LETRA_LARGA, e.letra)) e.letra = LETRA_LARGA[e.letra];
      return saneaElemento(e);
    }).filter(Boolean);
    return v.length ? v : null;
  }
  function codigoDelDiseno(p) {
    return '1.' + aBase64url(JSON.stringify({ n: String(p.nombre || '').slice(0, 40), d: caraCorta(p.delante), r: caraCorta(p.detras) }));
  }
  // null si el enlace no trae diseño; false si lo trae pero no se puede leer
  function disenoDelEnlace() {
    var c = new URLSearchParams(location.search).get('diseno');
    if (!c) return null;
    try {
      if (c.slice(0, 2) !== '1.' || c.length > 4000) return false;
      var o = JSON.parse(deBase64url(c.slice(2)));
      var p = { nombre: String(o.n || 'Tu diseño').replace(/[\u0000-\u001f\u007f]/g, '').slice(0, 40), explicacion: '', delante: caraLarga(o.d), detras: caraLarga(o.r) };
      return p.delante || p.detras ? p : false;
    } catch (e) { return false; }
  }
  function sesionId() {
    try {
      var k = localStorage.getItem('cm-ia-sesion');
      if (!k) { k = (Math.random().toString(36).slice(2) + Date.now().toString(36)); localStorage.setItem('cm-ia-sesion', k); }
      return k;
    } catch (e) { return 'anon' + Math.random().toString(36).slice(2); }
  }

  // El chat de la tienda (Oct8ne): se abre como si la clienta tocara su burbuja; si no ha cargado, con su
  // función, y si tampoco está, por WhatsApp.
  function abrirChat() {
    var burbuja = document.getElementById('livechat-wrapper');
    if (burbuja) { burbuja.click(); return; }
    try { if (window.oct8ne && typeof window.oct8ne.open === 'function') { window.oct8ne.open(); return; } } catch (e) {}
    var wa = document.querySelector('#whatsapp-button a[href]');
    window.open(wa ? wa.href : 'https://api.whatsapp.com/send?phone=34656807108', '_blank', 'noopener');
  }

  function init(root) {
    var cfg = JSON.parse(root.querySelector('script[type="application/json"]').textContent);
    aplicarMedalla(cfg.handle);
    cargarIlustraciones();
    var formId = root.getAttribute('data-form-id');
    var form = document.getElementById(formId) || document.querySelector('form[action*="/cart/add"]');
    if (form && form.getAttribute('id')) formId = form.getAttribute('id');
    var svg = root.querySelector('[data-cm-svg]'), ui = root.querySelector('[data-cm-ui]'), msg = root.querySelector('[data-cm-msg]'), hiddenBox = root.querySelector('[data-cm-hidden]');
    var stage = root.querySelector('.cm-p__stage'), note = root.querySelector('.cm-p__note');
    svg.setAttribute('viewBox', (-VIEW.w / 2) + ' ' + (-VIEW.h / 2) + ' ' + VIEW.w + ' ' + VIEW.h);
    // La ficha se ordena para que los diseños se vean sin bajar (cm-medalla-ia.css, «Ficha sin bajar»)
    document.documentElement.classList.add('cm-ia-pagina');
    // Compartir: en la esquina de la vista previa, cuando ya hay un diseño
    var compartirBtn = el('button', { type: 'button', class: 'cm-ia__compartir', 'aria-label': 'Compartir el diseño', title: 'Compartir el diseño', hidden: '' }, stage);
    compartirBtn.innerHTML = '<svg viewBox="0 0 24 24" width="19" height="19" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M12 3.5v11M8 7.5l4-4 4 4"/><path d="M8.5 10.5H6.5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-2"/></svg>';
    compartirBtn.addEventListener('click', compartir);
    var copiado = el('span', { class: 'cm-ia__copiado', role: 'status' }, stage), copiadoT = null;
    // Mientras la IA trabaja (diseño, cambio o dibujo de la foto), un velo sobre la medalla con un círculo que gira, el
    // texto y una barra que se mueve (Susana, 9-oct-2026: «se ve poco que está pensando… muéstralo más visual»). La
    // vista previa va pegada arriba en el móvil, así que se ve esté donde esté la clienta.
    var pensandoBox = el('div', { class: 'cm-ia__pensando', role: 'status', 'aria-live': 'polite', hidden: '' }, stage);
    pensandoBox.innerHTML = '<span class="cm-ia__giro" aria-hidden="true"></span><b class="cm-ia__pensando-txt"></b><i class="cm-ia__pensando-barra" aria-hidden="true"><i></i></i>';
    function pensando(texto) {
      pensandoBox.hidden = !texto;
      pensandoBox.querySelector('.cm-ia__pensando-txt').textContent = texto || '';
    }
    // Paso a paso: «Delante / Detrás · gratis» arriba a la izquierda y «Ejemplo» mientras no se ha escrito nada
    var carasBtn = [], ejemploBadge = el('span', { class: 'cm-ia__ejemplo', hidden: '' }, stage);
    ejemploBadge.textContent = 'Ejemplo';
    if (WZ_ON) {
      var carasBox = el('div', { class: 'cm-ia__caras', role: 'group', 'aria-label': 'Qué cara ver' }, stage);
      [['delante', 'Delante'], ['detras', 'Detrás · gratis']].forEach(function (c) {
        var b = el('button', { type: 'button', class: 'cm-ia__cara', 'data-cara': c[0], 'aria-pressed': 'false' }, carasBox);
        b.textContent = c[1];
        b.addEventListener('click', function () { G.cara = c[0]; pintar(); });
        carasBtn.push(b);
      });
    }

    function currentVariant() {
      var f = document.getElementById(formId) || form, i = f && f.querySelector('input[name="id"], select[name="id"]');
      var id = i ? String(i.value) : null, k;
      for (k = 0; k < cfg.variants.length; k++) if (String(cfg.variants[k].id) === id) return cfg.variants[k];
      return cfg.variants[0];
    }
    function metalKey(v) {
      for (var i = 0; i < cfg.options.length; i++) if (/color/i.test(cfg.options[i]) && v && /plat|blanc/i.test(v.options[i] || '')) return 'plateado';
      return 'dorado';
    }
    function propuesta() { return G.propuestas && G.propuestas[G.elegida] || null; }

    // ---- interfaz ----
    ui.innerHTML = '';
    var caja = el('div', { class: 'cm-ia__caja' }, ui);
    // Con el diseño ya en pantalla, la caja se pliega en una línea para que quepa a la vista lo que sigue
    var pedido = el('div', { class: 'cm-ia__pedido' }, caja);
    var pedidoTxt = el('span', { class: 'cm-ia__idea' }, pedido);
    var cambiar = el('button', { type: 'button', class: 'cm-ia__cambiar', 'aria-label': 'Cambiar lo que quieres grabar' }, pedido);
    cambiar.textContent = 'Cambiar';
    var fotoFila = el('div', { class: 'cm-fo__fila' }, caja);
    var lab = el('label', { class: 'cm-ia__lab', for: 'cm-ia-texto' }, fotoFila);
    lab.textContent = 'Cuéntanos qué quieres grabar';
    var subir = sinQuitarFoco(el('button', { type: 'button', class: 'cm-fo__subir' }, fotoFila));
    subir.innerHTML = ICONO_FOTO.camara + 'Subir foto';
    var ta = el('textarea', { id: 'cm-ia-texto', class: 'cm-ia__ta', rows: '3', maxlength: '400', placeholder: 'Por ejemplo: «los nombres de mis nietos, Lucas y Vera», «nuestra fecha de boda, 14 de junio de 2019», «mi gata Luna»' }, caja);
    ta.value = G.texto || '';
    // Los botones solo se apagan de verdad mientras trabajan: si se apagaran también con el texto corto, un
    // teclado que escribe sin avisar a la página (autocorrector, sugerencias) dejaría el botón apagado y el
    // primer toque no haría nada. Con poco texto se ven atenuados (is-off) y, si se tocan, lo dicen.
    function pintaGen() { boton.classList.toggle('is-off', ta.value.trim().length < 3); }
    ['input', 'change', 'keyup', 'compositionend'].forEach(function (t) { ta.addEventListener(t, function () { G.texto = ta.value; if (t === 'input') msg.textContent = ''; pintaGen(); }); });
    var boton = sinQuitarFoco(el('button', { type: 'button', class: 'cm-ia__gen' }, caja));
    boton.textContent = '✨ Generar diseño con IA';
    var pista = el('p', { class: 'cm-ia__pista' }, caja);
    pintaGen();
    var trabajando = el('div', { class: 'cm-ia__trabajando', hidden: '' }, caja);
    trabajando.innerHTML = '<span class="cm-ia__punto"></span>Diseñando tu medalla…';
    var explica = el('p', { class: 'cm-ia__explica' }, ui);
    // la espera del dibujo de la IA (la tarjeta de la foto, con sus ajustes, va dentro de «¿Cambiamos algo?»)
    var fotoEstado = el('div', { class: 'cm-fo__estado', role: 'status', hidden: '' }, ui);

    // ---- paso de retoque: la clienta pide un cambio y la IA rehace su diseño ----
    // Es un desplegable que se cierra al llegar cada diseño, para que el botón de la cesta se vea sin bajar. Dentro va
    // todo lo que cambia el diseño: la foto, las letras, los atajos, la caja, el historial y el chat.
    var rt = el('div', { class: 'cm-rt cm-dp', hidden: '' }, ui);
    rt.insertAdjacentHTML('beforeend', cabDesplegable('cm-dp-rt', WZ_ON ? '¿Otro cambio? Pídeselo a la IA' : '¿Cambiamos algo?', '', false));
    var rtCab = sinQuitarFoco(rt.lastChild), rtSub = rtCab.querySelector('.cm-dp__sub');
    var rtCuerpo = el('div', { class: 'cm-dp__cuerpo', id: 'cm-dp-rt', hidden: '' }, rt);
    var fotoTarjeta = el('div', { class: 'cm-fo__tarjeta', hidden: '' }, rtCuerpo);
    var rtChips = el('div', { class: 'cm-rt__chips' }, rtCuerpo);
    // «Otra letra» (Susana, 24-sep-2026): su diseño en las diez letras, para elegir al momento y sin gastar cambios
    var le = el('div', { class: 'cm-le', hidden: '' }, rtCuerpo);
    var rtFila = el('div', { class: 'cm-rt__fila' }, rtCuerpo);
    var rtTa = el('input', { type: 'text', class: 'cm-rt__ta', maxlength: '120', enterkeyhint: 'send',
      placeholder: '…o dinos tú qué cambiar', 'aria-label': 'Qué quieres cambiar' }, rtFila);
    var rtOk = sinQuitarFoco(el('button', { type: 'button', class: 'cm-rt__ok' }, rtFila));
    rtOk.textContent = 'Aplicar';
    var rtTrab = el('div', { class: 'cm-rt__trab', hidden: '' }, rtCuerpo);
    rtTrab.innerHTML = '<span class="cm-ia__punto"></span>Retocando tu medalla…';
    // Lo que contesta la IA, justo debajo de la caja y en un recuadro: en gris y al final no se veía
    var rtMsg = el('p', { class: 'cm-rt__msg', role: 'status' }, rtCuerpo);
    var rtHist = el('ul', { class: 'cm-rt__hist' }, rtCuerpo);
    var rtUndo = el('button', { type: 'button', class: 'cm-rt__undo', hidden: '' }, rtCuerpo);
    rtUndo.textContent = 'Deshacer el último cambio';
    var rtPista = el('p', { class: 'cm-ia__pista' }, rtCuerpo);
    // Si no sale como quiere, que nos escriba (Susana, 23-sep-2026)
    var ayuda = el('button', { type: 'button', class: 'cm-ia__ayuda' }, rtCuerpo);
    ayuda.innerHTML = '<span class="cm-ia__ayuda-ico" aria-hidden="true"><svg viewBox="0 0 24 24" width="19" height="19">' +
      '<path d="M4.5 5.5h15a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H10l-4.5 3.5V16.5h-1a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
      '<path d="M8 10h8M8 13h5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></span>' +
      '<span class="cm-ia__ayuda-txt"><strong>¿No consigues el diseño que quieres?</strong><span>Escríbenos al chat y lo diseñamos contigo.</span></span>' +
      '<span class="cm-ia__ayuda-ir" aria-hidden="true">›</span>';
    ayuda.addEventListener('click', abrirChat);
    var rtPila = [], rtHechos = [], rtOcupado = false;

    function pintaOk() { rtOk.classList.toggle('is-off', rtTa.value.trim().length < 3); }
    ['input', 'change', 'keyup', 'compositionend'].forEach(function (t) {
      rtTa.addEventListener(t, function () { if (t === 'input') rtMsg.textContent = ''; pintaOk(); });
    });
    pintaOk();
    function aplicarCambio() {
      if (rtOcupado) return;
      var cambio = rtTa.value.trim();
      if (cambio.length < 3) { rtMsg.classList.remove('is-err'); rtMsg.textContent = 'Escribe qué quieres cambiar, por ejemplo «la fecha en romanos».'; rtTa.focus(); return; }
      pedirRetoque(cambio);
    }
    rtTa.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); aplicarCambio(); } });
    rtOk.addEventListener('click', aplicarCambio);
    rtUndo.addEventListener('click', function () {
      if (!rtPila.length || rtOcupado) return;
      var u = rtPila.pop();
      G.propuestas[G.elegida] = u.p;
      G.base = u.base;
      rtHechos.pop();
      rtMsg.textContent = '';
      if (WZ_ON) wzAdoptar();
      pintar(); sincronizar();
      if (WZ_ON) wzPintar();
    });
    // El historial y el deshacer son de la propuesta que está elegida: si se genera de nuevo o se
    // cambia de propuesta, dejan de tener sentido. Y con un diseño nuevo el desplegable vuelve a cerrarse.
    function rtReset() { rtPila = []; rtHechos = []; G.rtAbierto = false; G.rtUltimo = ''; }
    // Abierto o cerrado se guarda en G: al cambiar de metal el tema vuelve a pintar el diseñador y lo abierto sigue abierto
    function abrirRt(si) {
      G.rtAbierto = !!si;
      rtCab.setAttribute('aria-expanded', si ? 'true' : 'false');
      rtCuerpo.hidden = !si;
    }
    // Recién abierto, que se vean los atajos: en el móvil, por encima de los botones flotantes de WhatsApp y chat y sin
    // meter la cabecera bajo la vista previa pegada arriba
    function verRt() {
      if (rtCuerpo.hidden) return;
      var movil = htmlCls.contains('cm-movil-arriba'), c = rtCab.getBoundingClientRect(), fin = rtChips.getBoundingClientRect().bottom;
      var bajar = Math.min(fin - (window.innerHeight - (movil ? 150 : 16)), c.top - (movil ? stage.getBoundingClientRect().bottom : 0) - 8);
      if (bajar > 0) window.scrollBy(0, bajar);
    }
    rtCab.addEventListener('click', function () { abrirRt(!G.rtAbierto); if (G.rtAbierto) setTimeout(verRt, 30); });

    // ---- «Subir foto» (Susana, 24-sep-2026; maqueta hoja/maqueta-foto.html): letra o dibujo, mascota o retrato ----
    // La letra o el dibujo se pasan a trazos aquí, al momento. La mascota y el retrato los dibuja la IA de imagen en el
    // servidor (/dibujo, ~35 s) a partir de la foto, reducida a 1024 px; luego se pasan a trazos igual. La foto no se
    // guarda en ningún sitio: aquí solo queda, mientras dura la página, para «Otro dibujo» o para cambiar el trazo.
    // La mascota y el retrato, en dos estilos (Susana, 25-sep-2026: «para la foto, puedes hacer diseño también estilo
    // fotojoya»): línea fina, o fotojoya, como las fotojoyas de mascota de la tienda (sombras en masas negras, silueta
    // recortada). El estilo va en G.dibujos[ref].estilo; sin él, es línea fina.
    var FOTO_TIPO = {
      letra: { titulo: 'Tu letra, tal cual', idea: function () { return 'Mi letra o mi dibujo (foto)'; },
               explica: function () { return 'Tu letra, tal cual, grabada en línea fina.'; } },
      mascota: { titulo: 'Dibujada por nuestra IA', tituloFj: 'Fotojoya, por nuestra IA',
                 idea: function (n, fj) { return (fj ? 'Fotojoya de mi mascota' : 'Dibujo de mi mascota') + (n ? ', ' + n : ''); },
                 explica: function (n, fj) {
                   return fj ? (n || 'Tu mascota') + ' en estilo fotojoya, con sus luces y sombras' + (n ? ', y debajo su nombre en caligrafía.' : '.')
                     : 'El dibujo de ' + (n || 'tu mascota') + ' en línea fina' + (n ? ' y, debajo, su nombre en caligrafía.' : '.');
                 } },
      retrato: { titulo: 'Dibujado por nuestra IA', tituloFj: 'Fotojoya, por nuestra IA',
                 idea: function (n, fj) { return (fj ? 'Retrato en fotojoya' : 'Retrato') + (n ? ' de ' + n : ''); },
                 explica: function (n, fj) {
                   return 'El retrato de ' + (n || 'esa persona') + (fj ? ' en estilo fotojoya, con sus luces y sombras' : ' en línea fina') +
                     (n ? (fj ? ', y debajo su nombre en caligrafía.' : ' y, debajo, su nombre en caligrafía.') : '.');
                 } }
    };
    function esFotojoya(d) { return !!d && d.estilo === 'fotojoya'; }
    function tituloFoto(d) { var t = FOTO_TIPO[d.tipo]; return esFotojoya(d) && t.tituloFj ? t.tituloFj : t.titulo; }
    G.fotoEstilo = G.fotoEstilo || 'linea';
    var GROSOR = { fino: 0.011, normal: 0.016, grueso: 0.022 };   // de la línea, en fracción del lado mayor del dibujo
    G.fuentes = G.fuentes || {};
    document.querySelectorAll('.cm-fo__velo, .cm-fo__hoja').forEach(function (n) { n.remove(); });   // de un diseñador anterior
    var velo = el('div', { class: 'cm-fo__velo', hidden: '' }, document.body);
    var hoja = el('div', { class: 'cm-fo__hoja', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Subir una foto', hidden: '' }, document.body);
    hoja.innerHTML = '<div class="cm-fo__asa"></div><h2><span class="cm-fo__tit">¿Qué quieres grabar de tu foto?</span><button type="button" class="cm-fo__cerrar" aria-label="Cerrar">×</button></h2>' +
      '<div class="cm-fo__paso" data-paso="1">' +
      '<button type="button" class="cm-fo__op" data-tipo="letra"><i>' + ICONO_FOTO.letra + '</i><span><b>Letra o dibujo</b><small>Una nota a mano, una firma o el dibujo de tus hijos. La grabamos tal cual.</small><em>La ves al momento</em></span></button>' +
      '<button type="button" class="cm-fo__op" data-tipo="mascota"><i>' + ICONO_FOTO.pata + '</i><span><b>Tu mascota</b><small>Nuestra IA la dibuja a partir de tu foto, en línea fina o como una fotojoya.</small><em>En unos 30 segundos</em></span></button>' +
      '<button type="button" class="cm-fo__op" data-tipo="retrato"><i>' + ICONO_FOTO.persona + '</i><span><b>Un retrato</b><small>Nuestra IA dibuja a esa persona con su parecido, en línea fina o como una fotojoya.</small><em>En unos 30 segundos</em></span></button>' +
      '<p class="cm-fo__priv">' + ICONO_FOTO.candado + '<span>Tu foto solo se usa para hacer tu joya.</span></p></div>' +
      '<div class="cm-fo__paso" data-paso="2" hidden>' +
      '<p class="cm-fo__lab"></p><div class="cm-fo__estilos" role="radiogroup">' +
      '<button type="button" class="cm-fo__estilo" data-estilo="linea" role="radio"><img alt=""><b>Línea fina</b><small>Pocos trazos, delicado</small></button>' +
      '<button type="button" class="cm-fo__estilo" data-estilo="fotojoya" role="radio"><img alt=""><b>Fotojoya</b><small>Con sus luces y sombras</small></button></div>' +
      '<label class="cm-fo__campo"><span>¿Cómo se llama? <small>Si nos lo dices, lo grabamos debajo</small></span><input type="text" maxlength="24" autocomplete="off"></label>' +
      '<label class="cm-fo__check"><input type="checkbox"><span>Tengo permiso de la persona de la foto y acepto que la IA de Customima (OpenAI) la dibuje solo para esta joya.</span></label>' +
      '<button type="button" class="cm-fo__elegir">' + ICONO_FOTO.camara + 'Elegir foto</button>' +
      '<p class="cm-fo__consejo"></p></div>' +
      '<input type="file" accept="image/*" hidden>';
    var hojaTit = hoja.querySelector('.cm-fo__tit'), paso1 = hoja.querySelector('[data-paso="1"]'), paso2 = hoja.querySelector('[data-paso="2"]');
    var fotoNombre = hoja.querySelector('.cm-fo__campo input'), fotoCampo = hoja.querySelector('.cm-fo__campo');
    var fotoCheck = hoja.querySelector('.cm-fo__check'), fotoConsejo = hoja.querySelector('.cm-fo__consejo');
    var fotoElegir = hoja.querySelector('.cm-fo__elegir'), fotoInput = hoja.querySelector('input[type="file"]'), fotoTipo = 'letra';
    var fotoEstiloLab = hoja.querySelector('.cm-fo__lab'), fotoEstilos = hoja.querySelector('.cm-fo__estilos');
    // Línea fina o fotojoya, con un ejemplo de cada uno (el perro o la abuela de prueba, inventados por la IA)
    function pintaEstilos() {
      fotoEstilos.setAttribute('aria-label', fotoEstiloLab.textContent);
      Array.prototype.forEach.call(fotoEstilos.querySelectorAll('.cm-fo__estilo'), function (b) {
        var e = b.getAttribute('data-estilo'), on = e === G.fotoEstilo;
        b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.querySelector('img').src = ASSETS + 'cm-fo-' + (fotoTipo === 'retrato' ? 'retrato' : 'mascota') + '-' + e + '.jpg';
      });
    }
    Array.prototype.forEach.call(fotoEstilos.querySelectorAll('.cm-fo__estilo'), function (b) {
      b.addEventListener('click', function () { G.fotoEstilo = b.getAttribute('data-estilo'); pintaEstilos(); });
    });
    function abrirHoja(tipo) {
      velo.hidden = hoja.hidden = false; htmlCls.add('cm-fo-abierta');
      if (tipo) elegirTipo(tipo); else { paso1.hidden = false; paso2.hidden = true; hojaTit.textContent = '¿Qué quieres grabar de tu foto?'; }
    }
    function cerrarHoja() { velo.hidden = hoja.hidden = true; htmlCls.remove('cm-fo-abierta'); }
    function elegirTipo(tipo) {
      fotoTipo = tipo; paso1.hidden = true; paso2.hidden = false;
      hojaTit.textContent = tipo === 'letra' ? 'Tu letra o tu dibujo' : tipo === 'mascota' ? 'Tu mascota' : 'Un retrato';
      fotoCampo.hidden = tipo === 'letra'; fotoCheck.hidden = tipo !== 'retrato';
      fotoEstiloLab.hidden = fotoEstilos.hidden = tipo === 'letra';
      if (tipo !== 'letra') { fotoEstiloLab.textContent = tipo === 'mascota' ? '¿Cómo la dibujamos?' : '¿Cómo lo dibujamos?'; pintaEstilos(); }
      fotoConsejo.textContent = tipo === 'letra' ? 'Sale mejor con buena luz, de frente y sobre papel blanco liso.'
        : 'Sale mejor de frente, con buena luz y con ' + (tipo === 'mascota' ? 'tu mascota sola.' : 'esa persona sola.');
      pintaElegir();
    }
    function pintaElegir() { fotoElegir.classList.toggle('is-off', fotoTipo === 'retrato' && !fotoCheck.querySelector('input').checked); }
    fotoCheck.querySelector('input').addEventListener('change', pintaElegir);
    subir.addEventListener('click', function () { abrirHoja(); });
    velo.addEventListener('click', cerrarHoja);
    hoja.querySelector('.cm-fo__cerrar').addEventListener('click', cerrarHoja);
    Array.prototype.forEach.call(hoja.querySelectorAll('.cm-fo__op'), function (b) {
      b.addEventListener('click', function () { elegirTipo(b.getAttribute('data-tipo')); });
    });
    fotoElegir.addEventListener('click', function () {
      if (fotoElegir.classList.contains('is-off')) { fotoCheck.classList.add('is-aviso'); return; }
      fotoInput.value = ''; fotoInput.click();
    });
    fotoInput.addEventListener('change', function () {
      var f = fotoInput.files && fotoInput.files[0];
      if (!f) return;
      cerrarHoja();
      if (fotoTipo === 'letra') procesarLetra(f);
      else procesarDibujo(f, fotoTipo, fotoNombre.value.trim().slice(0, 24), null, G.fotoEstilo);
    });
    function leerFoto(f) {
      if (window.createImageBitmap) return createImageBitmap(f, { imageOrientation: 'from-image' }).catch(function () { return cargarImagen(URL.createObjectURL(f)); });
      return cargarImagen(URL.createObjectURL(f));
    }
    function cargarImagen(src) {
      return new Promise(function (ok, ko) { var im = new Image(); im.onload = function () { ok(im); }; im.onerror = ko; im.src = src; });
    }
    function lienzo(fuente, maxLado) {
      var k = Math.min(1, maxLado / Math.max(fuente.width, fuente.height)), c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(fuente.width * k)); c.height = Math.max(1, Math.round(fuente.height * k));
      var x = c.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, c.width, c.height); x.drawImage(fuente, 0, 0, c.width, c.height);
      return c;
    }
    function miniatura(fuente) { return lienzo(fuente, 120).toDataURL('image/jpeg', 0.75); }
    function nuevaRef() { return 'f' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
    function estadoFoto(texto, tipo) {
      fotoEstado.hidden = !texto;
      pensando(tipo === 'trabajando' ? texto : '');
      fotoEstado.className = 'cm-fo__estado' + (tipo ? ' is-' + tipo : '');
      fotoEstado.innerHTML = texto ? (tipo === 'trabajando' ? '<span class="cm-ia__punto"></span>' : '') + '<span>' + esc(texto) + '</span>' +
        (tipo === 'trabajando' ? '<i class="cm-fo__barra"></i>' : '') : '';
      if (texto) fotoEstado.scrollIntoView({ block: 'nearest' });
    }
    function procesarLetra(f) {
      estadoFoto('Leyendo tu foto…', 'trabajando');
      leerFoto(f).then(function (bm) {
        var r = trazarImagen(bm, { foto: true, grosor: GROSOR.normal, maxLado: 1400 });
        if (!r || r.w < 10 || r.h < 10) return estadoFoto('No encontramos letra ni dibujo en esa foto. Prueba con buena luz, de frente y sobre papel blanco liso.', 'err');
        var ref = nuevaRef();
        G.dibujos[ref] = { d: r.d, w: r.w, h: r.h, tipo: 'letra', mini: miniatura(bm) };
        G.fuentes[ref] = { imagen: bm, grosor: 'normal', archivo: f };
        guardarDibujos();
        estadoFoto('');
        ponerDisenoFoto(ref, '');
      }).catch(function () { estadoFoto('No hemos podido abrir esa foto. Prueba con otra (JPG o PNG).', 'err'); });
    }
    function procesarDibujo(f, tipo, nombre, jpgYa, estilo) {
      var fj = estilo === 'fotojoya';
      estadoFoto('Preparando tu foto…', 'trabajando');
      var foto = jpgYa ? Promise.resolve(jpgYa) : leerFoto(f).then(function (bm) {
        var c = lienzo(bm, 1024);
        return { jpg: c.toDataURL('image/jpeg', 0.86).split(',')[1], mini: miniatura(bm), archivo: f };   // archivo: la foto tal cual, para el pedido
      });
      foto.then(function (fo) {
        estadoFoto('Dibujando ' + (nombre ? 'a ' + nombre : tipo === 'mascota' ? 'a tu mascota' : 'tu retrato') + (fj ? ' en estilo fotojoya' : '') + '… unos 30 segundos', 'trabajando');
        return fetch(API + '/dibujo', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ foto: fo.jpg, tipo: fj ? tipo + '-fotojoya' : tipo, sesion: sesionId() }) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (r) {
            if (!r.ok) return estadoFoto(r.d && r.d.mensaje || 'No hemos podido dibujar la foto. Inténtalo de nuevo.', 'err');
            esperarDibujo(r.d.encargo, 0, fo, tipo, nombre, fj ? 'fotojoya' : 'linea');
          });
      }).catch(function () { estadoFoto('No hemos podido conectar. Revisa tu conexión e inténtalo otra vez.', 'err'); });
    }
    function esperarDibujo(encargo, intentos, fo, tipo, nombre, estilo) {
      if (intentos > 120) return estadoFoto('Está tardando más de lo normal. Vuelve a intentarlo en un momento.', 'err');
      setTimeout(function () {
        fetch(API + '/estado?encargo=' + encodeURIComponent(encargo)).then(function (r) { return r.json(); }).then(function (d) {
          if (d.estado === 'trabajando' || d.estado === 'parcial') return esperarDibujo(encargo, intentos + 1, fo, tipo, nombre, estilo);
          if (d.estado === 'error' || !d.dibujo) return estadoFoto(d.aviso || d.mensaje || 'No hemos podido dibujar la foto. Inténtalo de nuevo.', 'err');
          return cargarImagen('data:image/jpeg;base64,' + d.dibujo).then(function (im) {
            // La fotojoya no se iguala a una línea: sus masas negras son el dibujo. Se traza a 512 px, unos 0,025 mm por
            // píxel con el dibujo a 11,5 mm (lo que resuelve el láser): 25-70 KB de trazado.
            var r = trazarImagen(im, estilo === 'fotojoya' ? { foto: false, grosor: 0, maxLado: 512 } : { foto: false, grosor: GROSOR.normal, maxLado: 1024 });
            if (!r) return estadoFoto('No hemos podido dibujar la foto. Prueba con otra.', 'err');
            var ref = nuevaRef();
            G.dibujos[ref] = { d: r.d, w: r.w, h: r.h, tipo: tipo, nombre: nombre, mini: fo.mini, estilo: estilo };
            G.fuentes[ref] = { foto: fo, tipo: tipo, nombre: nombre, estilo: estilo };
            guardarDibujos();
            estadoFoto('');
            ponerDisenoFoto(ref, nombre);
          });
        }).catch(function () { esperarDibujo(encargo, intentos + 2, fo, tipo, nombre, estilo); });
      }, intentos === 0 ? 4000 : 1500);
    }
    function r2(v) { return Math.round(v * 100) / 100; }
    // El dibujo que pide la IA al diseñar («dibujar»: un teckel, un faro…), sin foto: lo dibuja la IA de imagen en línea fina
    // (/ilustrar, ~30 s), se pasa a trazos como el de una mascota y ocupa el sitio del elemento «dibujo» de ref "ia".
    function ilustrarDiseno(descripcion) {
      pensando('La IA está dibujando tu diseño… unos 30 segundos');
      fetch(API + '/ilustrar', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ descripcion: descripcion, sesion: sesionId() }) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (r) {
          if (!r.ok) return sinIlustracion(r.d && r.d.mensaje || 'No hemos podido hacer el dibujo. Prueba otra vez o sube una foto.');
          esperarIlustracion(r.d.encargo, 0, descripcion);
        }).catch(function () { sinIlustracion('No hemos podido conectar para hacer el dibujo. Revisa tu conexión e inténtalo otra vez.'); });
    }
    function esperarIlustracion(encargo, intentos, descripcion) {
      if (intentos > 120) return sinIlustracion('El dibujo está tardando más de lo normal. Vuelve a intentarlo en un momento.');
      var recibido = false;                         // con el dibujo ya aquí, un fallo al pintarlo no lo vuelve a pedir
      setTimeout(function () {
        fetch(API + '/estado?encargo=' + encodeURIComponent(encargo)).then(function (r) { return r.json(); }).then(function (d) {
          if (d.estado === 'trabajando' || d.estado === 'parcial') return esperarIlustracion(encargo, intentos + 1, descripcion);
          if (d.estado === 'error' || !d.dibujo) return sinIlustracion(d.aviso || d.mensaje || 'No hemos podido hacer el dibujo.');
          recibido = true;
          return cargarImagen('data:image/jpeg;base64,' + d.dibujo).then(function (im) {
            var r = trazarImagen(im, { foto: false, grosor: GROSOR.normal, maxLado: 1024 });
            if (!r) return sinIlustracion('No hemos podido hacer el dibujo.');
            var ref = nuevaRef(), p = propuesta();
            G.dibujos[ref] = { d: r.d, w: r.w, h: r.h, tipo: 'ilustracion', nombre: descripcion, mini: miniatura(im) };
            guardarDibujos();
            if (!p) return;
            ['delante', 'detras'].forEach(function (k) { (p[k] || []).forEach(function (e) { if (e.tipo === 'dibujo' && e.ref === 'ia') e.ref = ref; }); });
            G.base = copia(p);
            pensando('');
            if (WZ_ON) wzAdoptar();
            pintar(); sincronizar();
            if (WZ_ON) wzPintar();
          });
        }).catch(function (e) {
          if (recibido) { pensando(''); if (window.console) console.warn('cm-medalla-ia: dibujo de la IA', e); return; }
          esperarIlustracion(encargo, intentos + 2, descripcion);
        });
      }, intentos === 0 ? 4000 : 1500);
    }
    // Si no se puede dibujar, fuera su hueco: el resto del diseño se vuelve a colocar y la clienta lee por qué
    function sinIlustracion(aviso) {
      pensando('');
      var p = propuesta();
      if (!p) return;
      var q = copia(p);
      ['delante', 'detras'].forEach(function (k) { if (q[k]) { q[k] = q[k].filter(function (e) { return !(e.tipo === 'dibujo' && e.ref === 'ia'); }); if (!q[k].length) q[k] = null; } });
      G.aviso = aviso;
      colocarDiseno(q).then(function (r) {
        G.propuestas[G.elegida] = r || q; G.base = copia(G.propuestas[G.elegida]);
        if (WZ_ON) wzAdoptar();
        pintar(); sincronizar();
        if (WZ_ON) wzPintar();
      });
    }
    // El diseño con la foto: el dibujo de protagonista y, si hay nombre, debajo en caligrafía. Lo coloca el servidor
    // (/colocar, sin IA) para que quepa y deje su aire a la anilla; si no contesta, vale tal cual.
    function ponerDisenoFoto(ref, nombre) {
      // tan grande como quepa con 2 mm de margen (Susana, 9-oct-2026), con el nombre debajo en proporción
      var d = G.dibujos[ref], t = FOTO_TIPO[d.tipo], H = 9, W = H * d.w / d.h;
      if (W > 11) { W = 11; H = W * d.h / d.w; }
      var els = [{ tipo: 'dibujo', ref: ref, x: 0, y: 0, tam: r2(H), ancho: r2(W) }];
      if (nombre) els.push({ tipo: 'texto', texto: nombre, letra: 'Allura', tam: Math.min(2.6, wzTam(nombre, 'Allura', 400, 9, 2.6)), x: 0, y: 0 });
      wzAmpliar(wzApilar(els, 0.6));
      var p = { nombre: nombre || tituloFoto(d), explicacion: t.explica(nombre, esFotojoya(d)), delante: els, detras: null };
      colocarDiseno(p).then(function (q) {
        G.propuestas = [q || p]; G.elegida = 0; G.base = copia(G.propuestas[0]); G.aviso = ''; G.estado = 'listo';
        G.texto = t.idea(nombre, esFotojoya(d)); G.compartido = false;
        rtReset(); rtMsg.textContent = '';
        pintar(); sincronizar(); plegar(true);
      });
    }
    function colocarDiseno(p) {
      return fetch(API + '/colocar', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sesion: sesionId(), diametro: D, diseno: { nombre: p.nombre, explicacion: p.explicacion, delante: p.delante || null, detras: p.detras || null } }) })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { return d && d.propuesta ? Object.assign(d.propuesta, { explicacion: p.explicacion }) : null; })
        .catch(function () { return null; });
    }
    // La tarjeta de la foto: su miniatura, «Cambiar foto», «Otro dibujo» (la IA, con la misma foto), el estilo del dibujo
    // (línea fina o fotojoya: la IA lo vuelve a dibujar con la misma foto), el trazo de la letra y en qué cara va
    function pintaFoto() {
      var p = propuesta(), refs = refsDe(p), ref = refs[0], d = ref && G.dibujos[ref];
      if (d && !FOTO_TIPO[d.tipo]) d = null;       // el dibujo que hace la IA sin foto no tiene tarjeta de foto
      fotoTarjeta.hidden = !d;
      if (!d) return;
      var fu = G.fuentes[ref], cara = (p.detras || []).some(function (e) { return e.ref === ref; }) ? 'detras' : 'delante';
      var estilo = esFotojoya(d) ? 'fotojoya' : 'linea';
      fotoTarjeta.innerHTML = '<div class="cm-fo__top"><img src="' + esc(d.mini || '') + '" alt=""><span><b>' + esc(tituloFoto(d)) + '</b>' +
        '<span class="cm-fo__acciones"><button type="button" data-accion="cambiar">Cambiar foto</button>' +
        (d.tipo !== 'letra' && fu && fu.foto ? '<button type="button" data-accion="otro">Otro dibujo</button>' : '') + '</span></span></div>' +
        (d.tipo !== 'letra' && fu && fu.foto ? '<div class="cm-fo__seg"><span>Estilo</span>' + [['linea', 'Línea fina'], ['fotojoya', 'Fotojoya']].map(function (e) {
          return '<button type="button" data-estilo="' + e[0] + '"' + (estilo === e[0] ? ' class="is-on"' : '') + '>' + e[1] + '</button>'; }).join('') + '</div>' : '') +
        (d.tipo === 'letra' && fu && fu.imagen ? '<div class="cm-fo__seg"><span>Trazo</span>' + ['fino', 'normal', 'grueso'].map(function (g) {
          return '<button type="button" data-grosor="' + g + '"' + (fu.grosor === g ? ' class="is-on"' : '') + '>' + g.charAt(0).toUpperCase() + g.slice(1) + '</button>'; }).join('') + '</div>' : '') +
        '<div class="cm-fo__seg"><span>Va</span><button type="button" data-cara="delante"' + (cara === 'delante' ? ' class="is-on"' : '') + '>Delante</button>' +
        '<button type="button" data-cara="detras"' + (cara === 'detras' ? ' class="is-on"' : '') + '>Detrás</button></div>';
      Array.prototype.forEach.call(fotoTarjeta.querySelectorAll('button'), function (b) {
        sinQuitarFoco(b).addEventListener('click', function () {
          if (b.getAttribute('data-accion') === 'cambiar') abrirHoja(d.tipo);
          else if (b.getAttribute('data-accion') === 'otro') procesarDibujo(null, fu.tipo, fu.nombre, fu.foto, estilo);
          else if (b.getAttribute('data-estilo')) {
            if (b.getAttribute('data-estilo') === estilo) return;
            G.fotoEstilo = b.getAttribute('data-estilo');
            procesarDibujo(null, fu.tipo, fu.nombre, fu.foto, G.fotoEstilo);
          }
          else if (b.getAttribute('data-grosor')) cambiarTrazo(ref, b.getAttribute('data-grosor'));
          else if (b.getAttribute('data-cara')) moverFoto(ref, b.getAttribute('data-cara'));
        });
      });
    }
    function cambiarTrazo(ref, g) {
      var fu = G.fuentes[ref], d = G.dibujos[ref];
      if (!fu || !fu.imagen || fu.grosor === g) return;
      var r = trazarImagen(fu.imagen, { foto: true, grosor: GROSOR[g], maxLado: 1400 });
      if (!r) return;
      d.d = r.d; d.w = r.w; d.h = r.h; fu.grosor = g;
      guardarDibujos(); pintar(); sincronizar();
    }
    function moverFoto(ref, cara) {
      var p = propuesta(), otra = cara === 'delante' ? 'detras' : 'delante';
      if (!p || !(p[otra] || []).some(function (e) { return e.ref === ref; })) return;
      var q = copia(p), el0 = null;
      q[otra] = (q[otra] || []).filter(function (e) { if (e.ref === ref) { el0 = e; return false; } return true; });
      if (!q[otra].length) q[otra] = null;
      el0.x = 0; el0.y = 0.3;
      q[cara] = (q[cara] || []).concat([el0]);
      colocarDiseno(q).then(function (r) {
        rtPila.push({ p: copia(p), base: G.base });
        rtHechos.push(cara === 'detras' ? 'la foto detrás' : 'la foto delante');
        G.propuestas[G.elegida] = r || q; G.base = copia(G.propuestas[G.elegida]);
        pintar(); sincronizar();
      });
    }

    boton.addEventListener('click', generar);
    ta.addEventListener('keydown', function (e) { if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') generar(); });
    cambiar.addEventListener('click', function () { G.plegada = false; root.classList.remove('cm-ia--hecho'); ta.focus(); });

    // Al llegar el diseño la caja se pliega en «Tu idea: … · Cambiar» y la página se coloca para que se
    // vea sin bajar: en móvil, con la vista previa pegada arriba y justo debajo la idea, la explicación y
    // «¿Cambiamos algo?»; en escritorio, solo si no se ve entero. De golpe y a la vez que se pliega la
    // caja, que ya mueve lo de abajo: un desplazamiento suave se queda a medias.
    function plegar(colocar) {
      if (WZ_ON) { wzLlega(); return; }                 // en el paso a paso, el diseño que llega lleva al paso que toca
      G.plegada = true;
      pedidoTxt.textContent = G.texto ? 'Tu idea: «' + G.texto + '»' : 'Diseño compartido contigo';
      root.classList.add('cm-ia--hecho');
      if (colocar) verDisenos();
    }
    function verDisenos() {
      if (!root.isConnected || !root.classList.contains('cm-ia--hecho')) return;
      var tope = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cm-tope')) || 0;
      var arriba = pedido.getBoundingClientRect().top;
      // hasta «¿Cambiamos algo?», que es por donde sigue (cerrado: su cabecera)
      var fin = (!rt.hidden ? (rtCuerpo.hidden ? rtCab : rtChips) : explica.textContent ? explica : pedido).getBoundingClientRect().bottom, y;
      if (document.documentElement.classList.contains('cm-movil-arriba')) y = arriba - (tope + stage.offsetHeight + 12);
      else if (arriba >= tope + 8 && fin <= window.innerHeight - 8) return;
      else y = Math.min(arriba - tope - 16, fin - window.innerHeight + 16);
      if (Math.abs(y) >= 4) window.scrollBy(0, y);
    }

    function pistaTexto() {
      if (G.quedan == null) return 'La IA diseña tu medalla y después puedes pedirle los cambios que quieras.';
      return 'Te quedan ' + G.quedan + ' diseño' + (G.quedan === 1 ? '' : 's') + ' hoy.';
    }
    function generar() {
      var texto = (ta.value || '').trim();
      if (boton.disabled) return;
      if (texto.length < 3) { msg.textContent = 'Cuéntanos qué quieres grabar: un nombre, una fecha, una frase…'; ta.focus(); return; }
      G.texto = texto; G.estado = 'trabajando'; msg.textContent = '';
      boton.disabled = true; trabajando.hidden = false; pensando('La IA está diseñando tu medalla…');
      ta.blur();                                  // ya está pedido: se cierra el teclado
      fetch(API + '/generar', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ texto: texto, sesion: sesionId(), diametro: D }) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, status: r.status, d: d }; }); })
        .then(function (r) {
          if (!r.ok) {
            trabajando.hidden = true; pensando(''); boton.disabled = false; G.estado = 'inicio';
            msg.textContent = r.d && r.d.mensaje ? r.d.mensaje : 'No hemos podido generar el diseño. Inténtalo de nuevo.';
            return;
          }
          if (typeof r.d.quedan === 'number') { G.quedan = r.d.quedan; pista.textContent = pistaTexto(); }
          esperar(r.d.encargo, 0);
        })
        .catch(function () { trabajando.hidden = true; pensando(''); boton.disabled = false; G.estado = 'inicio'; msg.textContent = 'No hemos podido conectar. Revisa tu conexión e inténtalo otra vez.'; });
    }
    // Se enseña UNA propuesta, en la vista previa (Susana, 23-sep-2026: «con los cambios que el cliente ponga
    // ya podemos trabajar más propuestas»). El servidor manda una sola; si mandara varias, vale la primera y no
    // se espera a las demás. Se espera hasta ~1 minuto: si la llamada falla, el servidor la repite una vez.
    function esperar(encargo, intentos) {
      if (intentos > 90) { trabajando.hidden = true; pensando(''); boton.disabled = false; if (!G.propuestas) msg.textContent = 'Está tardando más de lo normal. Vuelve a intentarlo en un momento.'; return; }
      setTimeout(function () {
        fetch(API + '/estado?encargo=' + encodeURIComponent(encargo)).then(function (r) { return r.json(); }).then(function (d) {
          if (d.estado === 'trabajando') return esperar(encargo, intentos + 1);
          if (d.estado === 'error') { trabajando.hidden = true; pensando(''); boton.disabled = false; G.estado = 'inicio'; msg.textContent = d.mensaje || 'No hemos podido generar el diseño. Inténtalo de nuevo.'; return; }
          var lista = (d.propuestas || []).filter(function (p) { return p && (p.delante || p.detras); });
          if (lista.length) {
            G.propuestas = [lista[0]]; G.elegida = 0; G.aviso = d.aviso || ''; G.compartido = false; G.base = copia(lista[0]);
            rtReset();
            // un dibujo que no está en la biblioteca: lo dibuja la IA de imagen (Susana, 9-oct-2026)
            if (lista[0].dibujar && refsDe(lista[0]).indexOf('ia') >= 0) { var dib = lista[0].dibujar; setTimeout(function () { ilustrarDiseno(dib); }, 0); }
            G.estado = 'listo';
            // si mientras tanto se ha cambiado de metal, el tema ha pintado otro diseñador: se pinta ese
            var otro = root.isConnected ? null : G.current;
            if (otro && otro.root !== root && otro.root.isConnected) otro.llegan();
            else { pintar(); sincronizar(); plegar(true); }
          } else if (d.estado === 'parcial') return esperar(encargo, intentos + 1);
          trabajando.hidden = true; pensando(''); trabajando.innerHTML = '<span class="cm-ia__punto"></span>Diseñando tu medalla…'; boton.disabled = false;
          // Sin diseño: la IA explica por qué en «aviso» (una petición que no se puede grabar). Si ya tenía uno
          // de antes, se queda en pantalla.
          if (!lista.length) { msg.textContent = d.aviso || 'No hemos podido diseñar esta petición. Prueba a describirla de otra forma.'; if (!G.propuestas) G.estado = 'inicio'; }
        }).catch(function () { esperar(encargo, intentos + 2); });
      }, intentos === 0 ? 900 : 700);
    }


    // ---- retoque: el cambio lo hace la IA sobre el diseño que la clienta ya tiene delante ----
    // Mismo ida y vuelta que generar (el App Proxy corta pronto): se pide y se pregunta por el encargo.
    function pedirRetoque(cambio) {
      var p = propuesta();
      if (!p || rtOcupado || !cambio || cambio.length < 3) return;
      rtOcupado = true; rtOk.disabled = true; rtOk.textContent = 'Aplicando…'; rtTrab.hidden = false;
      pensando('La IA está aplicando tu cambio…');
      rtMsg.textContent = ''; msg.textContent = '';
      rtTa.blur();                                // ya está pedido: se cierra el teclado
      pintaRetoque();
      var antes = JSON.parse(JSON.stringify(p));
      fetch(API + '/retocar', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          peticion: G.texto || '', cambio: cambio, sesion: sesionId(), diametro: D,
          diseno: { nombre: p.nombre, explicacion: p.explicacion,
                    delante: p.delante || null, detras: p.detras || null }
        })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (r) {
          if (!r.ok) {
            return finRetoque(r.d && r.d.mensaje ? r.d.mensaje
              : 'No hemos podido aplicar el cambio. Inténtalo de nuevo.', 'error');
          }
          if (typeof r.d.quedan === 'number') G.quedanRt = r.d.quedan;
          esperarRetoque(r.d.encargo, 0, antes, cambio);
        })
        .catch(function () { finRetoque('No hemos podido conectar. Revisa tu conexión e inténtalo otra vez.', 'error'); });
    }
    function esperarRetoque(encargo, intentos, antes, cambio) {
      if (intentos > 90) return finRetoque('Está tardando más de lo normal. Vuelve a intentarlo en un momento.', 'error');
      setTimeout(function () {
        fetch(API + '/estado?encargo=' + encodeURIComponent(encargo)).then(function (r) { return r.json(); }).then(function (d) {
          if (d.estado === 'trabajando' || d.estado === 'parcial') return esperarRetoque(encargo, intentos + 1, antes, cambio);
          if (d.estado === 'error') return finRetoque(d.mensaje || 'No hemos podido aplicar el cambio. Inténtalo de nuevo.', 'error');
          var nueva = (d.propuestas || [])[0];
          // La IA devuelve el grabado igual cuando no puede hacer el cambio (una letra que no tenemos, algo que no
          // cabe…) y lo explica en «aviso». Antes se apuntaba con ✓ como hecho y la explicación casi no se veía:
          // parecía que no aplicaba los cambios (Susana, 24-sep-2026). Ahora no se apunta y se enseña por qué.
          if (nueva && (nueva.delante || nueva.detras) && mismoGrabado(antes, nueva)) {
            return finRetoque(d.aviso || 'No hemos podido hacer ese cambio. Prueba a decirlo de otra forma o escríbenos al chat.', 'nota');
          }
          if (nueva && (nueva.delante || nueva.detras)) {
            rtPila.push({ p: antes, base: G.base });
            rtHechos.push(cambio);
            G.propuestas[G.elegida] = nueva;
            G.base = copia(nueva);
            if (WZ_ON) wzAdoptar();
            finRetoque(d.aviso || '', 'ok');
            // en el paso a paso, hecho el cambio se pliega para que se vea la cesta (Susana, 9-oct-2026)
            if (WZ_ON) { G.rtUltimo = cambio; G.rtAbierto = false; }
            pintar(); sincronizar();
            if (WZ_ON) { wzPintar(); setTimeout(wzVer, 40); }
            return;
          }
          // Sin diseño nuevo: la clienta ha preguntado algo que no es un cambio del grabado.
          // Su medalla se queda como estaba y se le enseña lo que contesta la IA.
          finRetoque(d.aviso || 'Por aquí solo podemos cambiar el grabado. Para lo demás, escríbenos por WhatsApp.', 'nota');
        }).catch(function () { esperarRetoque(encargo, intentos + 2, antes, cambio); });
      }, intentos === 0 ? 900 : 700);
    }
    // ¿Se grabaría lo mismo? Mismos elementos, textos y letras, y medidas que no se mueven más de 0,15 mm
    function mismoGrabado(a, b) {
      function igual(x, y) {
        x = x || []; y = y || [];
        if (x.length !== y.length) return false;
        for (var i = 0; i < x.length; i++) {
          var e = x[i] || {}, f = y[i] || {}, claves = {}, k;
          Object.keys(e).concat(Object.keys(f)).forEach(function (c) { claves[c] = 1; });
          for (k in claves) {
            var u = e[k], v = f[k];
            if (typeof u === 'number' && typeof v === 'number') { if (Math.abs(u - v) > 0.15) return false; }
            else if (String(u == null ? '' : u) !== String(v == null ? '' : v)) return false;
          }
        }
        return true;
      }
      return igual(a.delante, b.delante) && igual(a.detras, b.detras);
    }
    // tipo: 'ok' (hecho) · 'nota' (la IA contesta pero no cambia nada) · 'error' (algo falló)
    function finRetoque(aviso, tipo) {
      rtOcupado = false; rtTrab.hidden = true; pensando('');
      rtMsg.textContent = aviso || '';
      if (aviso) G.rtAbierto = true;              // si lo había cerrado mientras tanto, que lea lo que contesta la IA
      rtMsg.classList.toggle('is-err', tipo === 'error');
      rtMsg.classList.toggle('is-nota', tipo === 'nota');
      if (tipo === 'ok') rtTa.value = '';
      rtOk.disabled = false; rtOk.textContent = 'Aplicar'; pintaOk();
      pintaRetoque();
    }
    function rtPistaTexto() {
      if (G.quedanRt == null) return 'Cuéntanos qué cambiarías y la IA lo rehace.';
      return 'Te quedan ' + G.quedanRt + ' cambio' + (G.quedanRt === 1 ? '' : 's') + ' hoy.';
    }
    function pintaRetoque() {
      var p = propuesta();
      rt.hidden = !p || WZ_ON;   // en el paso a paso no va (Susana, 9-oct-2026: al final, la ayuda del chat en su lugar)
      if (rt.hidden) return;
      var hayTexto = textosDe(p.delante).length || textosDe(p.detras).length;
      rtSub.textContent = refsDe(p).length ? 'Cambia la foto o pide a la IA lo que quieras'
        : hayTexto ? 'Elige otra letra o pide a la IA lo que quieras' : 'Pide a la IA lo que quieras';
      if (WZ_ON && G.rtUltimo && !G.rtAbierto) rtSub.textContent = 'Hecho: «' + G.rtUltimo + '». ¿Algo más?';
      abrirRt(G.rtAbierto);
      rtChips.innerHTML = '';
      if (hayTexto) {
        var bl = sinQuitarFoco(el('button', { type: 'button', class: 'cm-rt__chip cm-rt__chip--letra' + (letrasAbiertas ? ' is-on' : ''), 'aria-expanded': letrasAbiertas ? 'true' : 'false' }, rtChips));
        bl.innerHTML = '<span class="cm-rt__aa" aria-hidden="true">Aa</span>Otra letra';
        bl.disabled = rtOcupado;
        bl.addEventListener('click', function () { if (letrasAbiertas) cerrarLetras(); else abrirLetras(); });
      }
      atajos(p).forEach(function (t) {
        var b = sinQuitarFoco(el('button', { type: 'button', class: 'cm-rt__chip' }, rtChips));
        b.textContent = t;
        b.disabled = rtOcupado;
        b.addEventListener('click', function () { pedirRetoque(t); });
      });
      rtHist.innerHTML = '';
      rtHechos.forEach(function (h) { el('li', {}, rtHist).textContent = h; });
      rtUndo.hidden = !rtPila.length || rtOcupado;
      rtPista.textContent = rtPistaTexto();
      pintaLetras();
    }

    // ---- «Otra letra»: las diez letras, cada una con su diseño en miniatura ----
    // Las variantes las calcula el servidor sin la IA (/letras: la tinta real de cada letra y la colocación de
    // siempre), siempre a partir del diseño que hizo la IA (G.base): así volver a la caligrafía lo deja como estaba.
    // Tocar una la pone al momento, sin gastar cambios; «Deshacer» también la quita.
    var letrasAbiertas = false, letrasLista = null, letrasError = '', letrasClave = '', letrasPidiendo = false, letrasPintadas = '', letrasVer = false;
    function baseLetras() { return G.base || propuesta(); }
    function claveBase() { var b = baseLetras(); return b ? JSON.stringify([b.delante, b.detras, D]) : ''; }
    function abrirLetras() {
      letrasAbiertas = true; letrasVer = true;
      var b = baseLetras() || {}, textos = '';
      textosDe(b.delante).concat(textosDe(b.detras)).forEach(function (e) { textos += e.texto; });
      cargarLetras(ESTILOS.map(function (e) { return [e.letra, e.peso, textos]; }));
      pintaRetoque();
      setTimeout(verLetras, 40);
    }
    function cerrarLetras() { letrasAbiertas = false; pintaRetoque(); }
    function verLetras() {
      if (le.hidden) return;
      // en el móvil, por encima de los botones flotantes de WhatsApp y chat de la tienda (abajo a la derecha) y sin
      // meter los atajos bajo la vista previa pegada arriba
      var movil = htmlCls.contains('cm-movil-arriba'), r = le.getBoundingClientRect();
      var bajar = Math.min(r.bottom - (window.innerHeight - (movil ? 150 : 16)), r.top - (movil ? stage.getBoundingClientRect().bottom : 0) - 8);
      if (bajar > 0) window.scrollBy(0, bajar);
    }
    function pedirLetras() {
      var clave = claveBase(), b = baseLetras();
      if (!b) return;
      letrasClave = clave; letrasLista = null; letrasError = ''; letrasPidiendo = true;
      fetch(API + '/letras', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sesion: sesionId(), diametro: D, diseno: { nombre: b.nombre, explicacion: b.explicacion, delante: b.delante || null, detras: b.detras || null } })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (r) {
          if (letrasClave !== clave) return;
          letrasPidiendo = false;
          if (r.ok && r.d && r.d.letras && r.d.letras.length) letrasLista = r.d.letras;
          else letrasError = r.d && r.d.mensaje ? r.d.mensaje : 'No hemos podido preparar las letras. Inténtalo de nuevo.';
          pintaLetras();
        })
        .catch(function () {
          if (letrasClave !== clave) return;
          letrasPidiendo = false; letrasError = 'No hemos podido conectar. Revisa tu conexión e inténtalo otra vez.';
          pintaLetras();
        });
    }
    function mini(els, m) {                              // la medalla en pequeño, con su agujero si lo tiene
      var R = D / 2, c = f2(-R - 0.4), a = f2(2 * R + 0.8);
      return '<svg viewBox="' + c + ' ' + c + ' ' + a + ' ' + a + '" aria-hidden="true"><circle r="' + f2(R) + '" fill="' + m.fill + '"/>' +
        '<circle r="' + f2(R) + '" fill="none" stroke="#d9cfc2" stroke-width=".12"/>' +
        (AGUJERO ? '<circle cx="' + f2(AGUJERO.x) + '" cy="' + f2(AGUJERO.y) + '" r="' + f2(AGUJERO.r) + '" fill="#fff" stroke="#d9cfc2" stroke-width=".08"/>' : '') +
        pintarCara(els, 0, 0, m.ink, false) + '</svg>';
    }
    function pintaLetras() {
      var p = propuesta();
      le.hidden = !letrasAbiertas || !p;
      if (le.hidden) return;
      if (letrasClave !== claveBase() || (!letrasLista && !letrasPidiendo && !letrasError)) pedirLetras();
      var m = METAL[metalKey(currentVariant())], firma = [letrasClave, m.ink, !!letrasLista, letrasError].join('|');
      if (firma !== letrasPintadas) {                   // se rehace solo si cambia: así no se pierde por dónde iba la tira
        letrasPintadas = firma;
        var h = '<p class="cm-le__tit">Elige la letra <small>desliza para ver más</small></p>';
        if (letrasLista) {
          h += '<div class="cm-le__tira">' + letrasLista.map(function (v, i) {
            var q = v.propuesta, cara = q && ((q.delante && q.delante.length ? q.delante : null) || q.detras);
            return '<button type="button" class="cm-le__op" data-i="' + i + '">' +
              (cara ? mini(cara, m) : '<span class="cm-le__no">En esta letra no cabe</span>') + '<b>' + esc(v.nombre) + '</b></button>';
          }).join('') + '</div><p class="cm-le__nota">La fecha y los datos se quedan en la letra fina, para que se lean bien.</p>';
        } else if (letrasError) h += '<p class="cm-le__err" role="status">' + esc(letrasError) + '</p>';
        else h += '<p class="cm-le__cargando"><span class="cm-ia__punto"></span>Preparando las letras…</p>';
        le.innerHTML = h;
        Array.prototype.forEach.call(le.querySelectorAll('.cm-le__op'), function (b) {
          sinQuitarFoco(b).addEventListener('click', function () { ponerLetra(letrasLista[+b.getAttribute('data-i')]); });
        });
        // recién abierta, que se vea entera cuando llegan las letras (y no después, cuando ya está mirando otra cosa)
        if (letrasVer && (letrasLista || letrasError)) { letrasVer = false; setTimeout(verLetras, 30); }
      }
      Array.prototype.forEach.call(le.querySelectorAll('.cm-le__op'), function (b) {
        var v = letrasLista && letrasLista[+b.getAttribute('data-i')], on = !!(v && v.propuesta && mismoGrabado(p, v.propuesta));
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.disabled = !(v && v.propuesta) || rtOcupado;
      });
    }
    // Probar letras es UN cambio, que se va poniendo al día: cada toque apuntaba una línea en el historial y al
    // probar varias se llenaba la lista (Susana, 24-sep-2026: «¿por qué sale todo esto?»). El paso guarda cómo
    // estaba antes de empezar a probar; si se vuelve a esa letra, el paso desaparece; «Deshacer» lo quita entero.
    function ponerLetra(v) {
      var p = propuesta();
      if (!p || !v || !v.propuesta || rtOcupado || mismoGrabado(p, v.propuesta)) return;
      var ultimo = rtPila[rtPila.length - 1];
      if (ultimo && ultimo.letra) rtHechos.pop();
      else rtPila.push({ p: copia(p), base: G.base, letra: true });
      if (mismoGrabado(rtPila[rtPila.length - 1].p, v.propuesta)) rtPila.pop();
      else rtHechos.push(ESTILO_POR_ID[v.id] ? ESTILO_POR_ID[v.id].en : 'letra ' + v.nombre.toLowerCase());
      G.propuestas[G.elegida] = copia(v.propuesta);
      rtMsg.textContent = ''; rtMsg.classList.remove('is-err', 'is-nota');
      if (WZ_ON) wzAdoptar();
      pintar(); sincronizar();
      if (WZ_ON) wzPintar();
    }
    // ---- vista previa ----
    function fotoMedalla(cx, cy, m, k) {
      return '<image clip-path="url(#cmia-foto-' + k + ')" href="' + m.src + '" x="' + f2(cx - PHOTO.cx * PK) + '" y="' + f2(cy - PHOTO.cy * PK) + '" width="' + f2(1000 * PK) + '" height="' + f2(1000 * PK) + '"/>' +
        (CARA ? '<circle cx="' + f2(cx) + '" cy="' + f2(cy) + '" r="' + f2(CARA * PK) + '" fill="' + m.fill + '"/>' : '');
    }
    // Lo que hará falta para pasar las letras a trazos se trae con calma, en cuanto hay un diseño, para que al pedir
    // no haya que esperarlo (HarfBuzz y la letra de cada texto: unos 150 KB comprimidos la primera vez).
    var precargaT = null;
    function precargarTrazos(p) {
      clearTimeout(precargaT);
      precargaT = setTimeout(function () {
        letrasDe([p.delante, p.detras]).forEach(function (f) { cargarLetraTTF(f[0], f[1]).catch(function () {}); });
        cargarMotorLaser().catch(function () {});
      }, 2500);
    }
    function pintar() {
      var v = currentVariant(), m = METAL[metalKey(v)], p = propuesta(), s = '<defs>';
      if (p) {
        var faltan = faltanLetras([p.delante, p.detras]);
        if (faltan.length) cargarLetras(faltan).then(function () { if (root.isConnected && propuesta() === p) pintar(); });
        precargarTrazos(p);
      }
      INK = m.ink;
      ['delante', 'detras'].forEach(function (k) {
        s += '<clipPath id="cmia-foto-' + k + '"><rect x="' + f2(SIDE_X[k] - RECORTE.lado) + '" y="' + f2(MED_Y - RECORTE.arriba) + '" width="' + f2(2 * RECORTE.lado) + '" height="' + f2(RECORTE.arriba + RECORTE.abajo) + '"/></clipPath>';
      });
      s += '<filter id="cmia-eng" x="' + f2(-VIEW.w / 2) + '" y="' + f2(-VIEW.h / 2) + '" width="' + f2(VIEW.w) + '" height="' + f2(VIEW.h) + '" filterUnits="userSpaceOnUse"><feOffset dx=".045" dy=".055" in="SourceAlpha" result="o"/><feFlood flood-color="#fffbe9" flood-opacity=".95"/><feComposite in2="o" operator="in" result="hl"/><feMerge><feMergeNode in="hl"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>';
      ['delante', 'detras'].forEach(function (k) {
        var cx = SIDE_X[k], els = p ? p[k] : null;
        s += (WZ_ON && k !== (G.cara === 'detras' ? 'detras' : 'delante') ? '<g visibility="hidden" data-cm-oculta="1">' : '<g>') + fotoMedalla(cx, MED_Y, m, k);
        if (els && els.length) s += '<g filter="url(#cmia-eng)">' + pintarCara(els, cx, MED_Y, m.ink, false) + '</g>';
        else s += '<text x="' + f2(cx) + '" y="' + f2(MED_Y) + '" text-anchor="middle" dominant-baseline="central" font-size="' + f2(1.25 * K) + '" fill="' + m.ink + '" opacity=".7" font-family="system-ui, sans-serif">' +
          (WZ_ON && W && W.d.tipo === 'foto' && !W.frenteExt && k === 'delante' ? 'Tu foto, aquí' : WZ_ON && p && k === 'detras' ? 'Detrás, sin grabar' : p ? 'Sin grabado' : 'Tu diseño aparecerá aquí') + '</text>';
        s += '<text x="' + f2(cx) + '" y="' + f2(MED_Y + RECORTE.abajo + ROTULO / 2) + '" text-anchor="middle" font-size="' + f2(1.05 * K) + '" font-family="system-ui, sans-serif" fill="#6b625c">' + (k === 'delante' ? 'DELANTE' : 'DETRÁS') + '</text></g>';
      });
      svg.innerHTML = s;
      ajustar();
      compartirBtn.hidden = !p || (WZ_ON && (!!G.ejemplo || (W && W.d.tipo === 'sin')));
      if (WZ_ON) {
        // Paso a paso: una cara cada vez, más grande, con «Delante / Detrás · gratis» (las dos siguen dibujadas: el JPG del
        // pedido las usa)
        var vw = VIEW.h * 1.6, cara = G.cara === 'detras' ? 'detras' : 'delante';
        svg.setAttribute('viewBox', f2(SIDE_X[cara] - vw / 2) + ' ' + f2(-VIEW.h / 2) + ' ' + f2(vw) + ' ' + f2(VIEW.h));
        carasBtn.forEach(function (b) { var on = b.getAttribute('data-cara') === cara; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        ejemploBadge.hidden = !G.ejemplo;
      }
      if (G.propuestas) {
        var p2 = propuesta();
        explica.textContent = (G.aviso ? G.aviso + ' ' : '') + (p2 && p2.explicacion || '');
      }
      pista.textContent = pistaTexto();
      pintaRetoque();
      pintaFoto();
    }
    // Un texto que no cabe dando la vuelta se parte en dos arcos: la mitad arriba y la mitad abajo,
    // como en las medallas clásicas. Se corta por un espacio, nunca por mitad de palabra.
    function partirAnillo(t, r) {
      var texto = (t.textContent || '').replace(/\s*·\s*$/, '').trim();
      var palabras = texto.split(/\s+/);
      if (palabras.length < 2) return;
      var mitad = Math.ceil(texto.length / 2), corte = 0, suma = 0, i;
      for (i = 0; i < palabras.length - 1; i++) { suma += palabras[i].length + 1; if (suma >= mitad) { corte = i + 1; break; } }
      if (!corte) corte = Math.ceil(palabras.length / 2);
      var arriba = palabras.slice(0, corte).join(' '), abajo = palabras.slice(corte).join(' ');
      var fam = (t.getAttribute('font-family') || '').replace(/'/g, ''), fs = t.getAttribute('font-size'), ls = t.getAttribute('letter-spacing') || 0;
      var padre = t.parentNode, ancla = t.nextSibling;
      var html = pathText(arriba, fam, t.getAttribute('font-style') === 'italic', parseFloat(fs), r, 'arriba', { ink: t.getAttribute('fill'), ls: ls }) +
                 pathText(abajo, fam, t.getAttribute('font-style') === 'italic', parseFloat(fs), r, 'abajo', { ink: t.getAttribute('fill'), ls: ls });
      // hay que parsearlo como SVG: innerHTML sobre un <g> crea elementos HTML que no se dibujan
      var doc = new DOMParser().parseFromString('<svg xmlns="' + NS + '">' + html + '</svg>', 'image/svg+xml');
      Array.prototype.slice.call(doc.documentElement.childNodes).forEach(function (n) {
        padre.insertBefore(document.importNode(n, true), ancla);
      });
      var camino = padre.querySelector('#' + t.querySelector('textPath').getAttribute('href').slice(1));
      if (camino) camino.remove();
      t.remove();
    }

    // Último recurso: un texto que no cabe ni en dos arcos pasa a líneas rectas centradas.
    // Nunca se recorta el texto de la clienta: antes se cambia la composición.
    function aLineas(t) {
      var texto = (t.textContent || '').replace(/\s*·\s*$/, '').trim();
      var palabras = texto.split(/\s+/), lineas = ['', '', ''], i = 0;
      palabras.forEach(function (p) {
        if (lineas[i].length && (lineas[i] + ' ' + p).length > Math.ceil(texto.length / 3) && i < 2) i++;
        lineas[i] += (lineas[i] ? ' ' : '') + p;
      });
      lineas = lineas.filter(Boolean);
      var fam = (t.getAttribute('font-family') || '').replace(/'/g, ''), ink = t.getAttribute('fill');
      var italic = t.getAttribute('font-style') === 'italic', tam = Math.max(minFont(fam), 2.6 - 0.35 * lineas.length);
      var alto = tam * 1.15, y0 = -(lineas.length - 1) * alto / 2, html = '';
      lineas.forEach(function (l, j) { html += txtEl(l, fam, italic, tam, 0, y0 + j * alto, { ink: ink }); });
      var padre = t.parentNode, ancla = t.nextSibling;
      var doc = new DOMParser().parseFromString('<svg xmlns="' + NS + '">' + html + '</svg>', 'image/svg+xml');
      Array.prototype.slice.call(doc.documentElement.childNodes).forEach(function (n) { padre.insertBefore(document.importNode(n, true), ancla); });
      var tp = t.querySelector('textPath');
      var camino = tp && padre.querySelector('#' + tp.getAttribute('href').slice(1));
      if (camino) camino.remove();
      t.remove();
    }
    function cabeEnElArco(t) {
      var r = parseFloat(t.getAttribute('data-ring')) || 5.05;
      var media = t.getAttribute('data-modo') === 'anillo' ? 2 * Math.PI * r : Math.PI * r;
      try { return t.getComputedTextLength() <= media * 0.94; } catch (e) { return true; }
    }
    // Ajuste de seguridad: si un texto se sale de la zona grabable, se reduce (nunca por debajo del mínimo)
    function ajustar(cont) {
      cont = cont || svg;
      // texto que sigue el borde: si da más de una vuelta (o de medio arco) se pisa; se reduce hasta que quepa.
      // Dos pasadas: la segunda ajusta los arcos que nacen al partir un anillo demasiado largo.
      for (var pasada = 0; pasada < 2; pasada++) {
        cont.querySelectorAll('text[data-ring]').forEach(function (t) {
          var r = parseFloat(t.getAttribute('data-ring')) || 5.05, media = t.getAttribute('data-modo') === 'anillo' ? 2 * Math.PI * r : Math.PI * r;
          var fam = (t.getAttribute('font-family') || '').replace(/'/g, ''), min = minFont(fam), fs = parseFloat(t.getAttribute('font-size')) || 1.6, k;
          for (k = 0; k < 10; k++) {
            var largo = 0;
            try { largo = t.getComputedTextLength(); } catch (e) { break; }
            if (largo <= media * 0.94) break;
            if (fs <= min) { if (t.getAttribute('data-modo') === 'anillo') partirAnillo(t, r); break; }
            fs = Math.max(min, fs * (media * 0.94 / largo));
            t.setAttribute('font-size', fs.toFixed(2));
            var ls = parseFloat(t.getAttribute('letter-spacing')) || 0;
            if (ls > 0) t.setAttribute('letter-spacing', Math.max(0, ls - 0.04).toFixed(2));
          }
        });
      }
      cont.querySelectorAll('text[data-ring]').forEach(function (t) { if (!cabeEnElArco(t)) aLineas(t); });
      cont.querySelectorAll('text[data-chk]').forEach(function (t) {
        var fam = (t.getAttribute('font-family') || '').replace(/'/g, ''), min = minFont(fam), fs = parseFloat(t.getAttribute('font-size')) || 2, k;
        for (k = 0; k < 12; k++) {
          var b = t.getBBox(), cx = b.x + b.width / 2, cy = b.y + b.height / 2;
          var r = Math.max(Math.hypot(b.x - cx + (b.x < cx ? 0 : 0), 0), 0);
          var esquinas = [[b.x, b.y], [b.x + b.width, b.y], [b.x, b.y + b.height], [b.x + b.width, b.y + b.height]];
          var max = 0;
          esquinas.forEach(function (q) { max = Math.max(max, Math.hypot(q[0], q[1])); });
          if (max <= ER || fs <= min) break;
          fs = Math.max(min, fs * (ER / max) * 0.99);
          t.setAttribute('font-size', fs.toFixed(2));
        }
      });
    }

    // ---- escritorio: la vista previa pasa a la galería (igual que el resto de fichas) ----
    // ---- móvil: sube al sitio de la galería, que se oculta (eran la misma medalla lisa) ----
    var deskBox = null, movBox = null, htmlCls = document.documentElement.classList;
    var vigia = window.ResizeObserver ? new ResizeObserver(function () { tramo(); }) : null;
    // En el móvil, con el paso a paso, la vista previa va después del título, las valoraciones y el precio (Susana,
    // 9-oct-2026: «el título del producto, precio y valoraciones ¿puede ir encima de la foto?»); sin él, al principio.
    function bloquePrecio(lista) {
      var hijos = Array.prototype.slice.call(lista.children), ref = null;
      hijos.forEach(function (c) { if (c.querySelector && c.querySelector('.cm-price-note')) ref = c; });
      if (!ref) hijos.forEach(function (c) { if (c.getAttribute && c.getAttribute('data-block-type') === 'price') ref = c; });
      return ref;
    }
    // Las valoraciones (la app de reseñas, el primer bloque de app tras el título) van detrás del precio (Susana, 9-oct-2026)
    function bloqueResenas(lista) {
      var t = lista.querySelector(':scope > [data-block-type="title"]'), n = t && t.nextElementSibling;
      if (n && n.getAttribute('data-block-type') === '@app') return n;
      return lista.querySelector(':scope > [data-cm-resenas]');
    }
    function ordenarCabecera() {
      if (!WZ_ON) return;
      var lista = root.closest('.product-info__block-list') || document.querySelector('.product-info__block-list');
      if (!lista) return;
      var pr = bloquePrecio(lista), re = bloqueResenas(lista);
      if (!pr || !re) return;
      re.setAttribute('data-cm-resenas', '1');
      if (pr.nextElementSibling !== re) pr.parentNode.insertBefore(re, pr.nextSibling);
    }
    function anclaMovil(lista) {
      if (!WZ_ON) return null;
      var pr = bloquePrecio(lista), re = lista.querySelector(':scope > [data-cm-resenas]');
      return re && pr && pr.nextElementSibling === re ? re : pr;
    }
    function movilEnSitio(lista) { var a = anclaMovil(lista); return a ? a.nextElementSibling === movBox : lista.firstChild === movBox; }
    function ponerMovil(lista) { var a = anclaMovil(lista); if (a) a.parentNode.insertBefore(movBox, a.nextSibling); else lista.insertBefore(movBox, lista.firstChild); }
    function listaMovil() { return /[?&]cmarriba=0/.test(location.search) ? null : root.closest('.product-info__block-list'); }
    function quitarMovBox() {
      if (!movBox) return;
      if (vigia) vigia.disconnect();
      movBox.remove(); movBox = null;
    }
    function placeStage() {
      ordenarCabecera();
      var grid = document.querySelector('product-gallery .product-gallery__image-list'), lista;
      if (deskActive() && grid) {
        htmlCls.add('cm-desk'); htmlCls.remove('cm-movil-arriba');
        deskBox = grid.querySelector(':scope > .cm-deskbox');
        document.querySelectorAll('.cm-deskbox').forEach(function (b) { if (b !== deskBox) b.remove(); });
        if (!deskBox) deskBox = el('div', { class: 'cm-deskbox' });
        if (grid.firstChild !== deskBox) grid.insertBefore(deskBox, grid.firstChild);
        Array.prototype.slice.call(deskBox.children).forEach(function (c) { if (c !== stage && c !== note) c.remove(); });
        if (stage.parentNode !== deskBox) deskBox.appendChild(stage);
        if (note.parentNode !== deskBox) deskBox.appendChild(note);
        quitarMovBox();
      } else if ((lista = listaMovil())) {
        htmlCls.remove('cm-desk'); htmlCls.add('cm-movil-arriba');
        movBox = lista.querySelector(':scope > .cm-movbox');
        document.querySelectorAll('.cm-movbox').forEach(function (b) { if (b !== movBox) b.remove(); });
        if (!movBox) movBox = el('div', { class: 'cm-movbox' });
        if (!movilEnSitio(lista)) ponerMovil(lista);
        // al cambiar de metal el tema vuelve a pintar el diseñador: fuera la vista previa de antes
        Array.prototype.slice.call(movBox.children).forEach(function (c) { if (c !== stage && c !== note) c.remove(); });
        if (stage.parentNode !== movBox) movBox.appendChild(stage);
        if (note.parentNode !== movBox) movBox.appendChild(note);
        if (vigia) { vigia.disconnect(); vigia.observe(lista); }
        tramo();
      } else {
        htmlCls.remove('cm-desk'); htmlCls.remove('cm-movil-arriba');
        if (stage.parentNode !== root) { root.insertBefore(stage, ui); root.insertBefore(note, ui); }
        quitarMovBox();
      }
    }
    // En móvil la vista previa va pegada arriba mientras se diseña y se va con la página al llegar a
    // «Revisa y confirma». Lo pegado (sticky) solo se mueve dentro de su padre: su caja se estira hasta
    // el final del diseñador y un margen negativo devuelve ese espacio, así que nada de abajo se mueve.
    function tramo() {
      if (!root.isConnected) { if (vigia) vigia.disconnect(); return; }   // este diseñador ya lo ha cambiado el tema
      if (!movBox || !movBox.isConnected || stage.parentNode !== movBox) return;
      var ini = movBox.getBoundingClientRect().top;
      var propio = note.getBoundingClientRect().bottom + (parseFloat(getComputedStyle(note).marginBottom) || 0) - ini;
      var alto = Math.max(propio, root.getBoundingClientRect().bottom - ini);
      movBox.style.height = alto + 'px';
      movBox.style.marginBottom = (propio - alto) + 'px';
    }

    // ---- lo que viaja al pedido ----
    hiddenBox.innerHTML = '';
    var H = {
      peticion: el('input', { type: 'hidden', name: 'properties[Petición]', form: formId }, hiddenBox),
      delante: el('input', { type: 'hidden', name: 'properties[Delante]', form: formId }, hiddenBox),
      detras: el('input', { type: 'hidden', name: 'properties[Detrás]', form: formId }, hiddenBox)
    };
    // Lo que va al pedido (Susana, 9-oct-2026): la imagen se llama «Previsualizar diseño» (la cesta la usa como foto
    // de la línea y como enlace) y hay un SVG por cara grabada. Los SVG empiezan por «_»: el tema y el checkout no
    // enseñan esas propiedades, pero el pedido sí. El diseño en JSON (_cm_diseno) ya no viaja.
    var FILES = window.DataTransfer ? {
      jpg: el('input', { type: 'file', name: 'properties[Previsualizar diseño]', form: formId, tabindex: '-1', 'aria-hidden': 'true', disabled: '' }, hiddenBox),
      delante: el('input', { type: 'file', name: 'properties[_Grabado delante (SVG)]', form: formId, tabindex: '-1', 'aria-hidden': 'true', disabled: '' }, hiddenBox),
      detras: el('input', { type: 'file', name: 'properties[_Grabado detrás (SVG)]', form: formId, tabindex: '-1', 'aria-hidden': 'true', disabled: '' }, hiddenBox),
      original: el('input', { type: 'file', name: 'properties[_Foto original]', form: formId, tabindex: '-1', 'aria-hidden': 'true', disabled: '' }, hiddenBox)
    } : null;
    function apagarFicheros() { if (FILES) Object.keys(FILES).forEach(function (k) { FILES[k].disabled = true; }); }
    var claveDiseno = '', claveFicheros = '';
    function sincronizar() {
      var p = propuesta();
      if (WZ_ON && W && G.ejemplo) p = null;             // el ejemplo de partida no se puede pedir
      H.peticion.value = (WZ_ON && W && !W.d.frenteExterno ? wzPeticion() : G.texto) || (G.compartido ? '(diseño abierto desde un enlace compartido)' : '');
      H.delante.value = p ? resumen(p.delante) : '';
      H.detras.value = p ? resumen(p.detras) : '';
      var j = p ? JSON.stringify({ metal: metalKey(currentVariant()), delante: p.delante || null, detras: p.detras || null }) : '';
      if (j !== claveDiseno) {
        claveDiseno = j; claveFicheros = '';
        apagarFicheros();
      }
      var s2 = document.querySelector('[data-cm-step="2"]'), s3 = document.querySelector('[data-cm-step="3"]');
      if (s2) { s2.classList.toggle('is-done', !!p); s2.classList.toggle('is-active', !p); }
      if (s3) s3.classList.toggle('is-active', !!p);
      programarFicheros();
      var box = document.querySelector('[data-cm-resumen]');
      if (box) {
        var v = currentVariant(), opts = ((v && v.options) || []).filter(function (o) { return o && o !== 'Default Title'; }).join(' · ');
        var precio = (function (c) { try { return (c / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }); } catch (e) { return (c / 100).toFixed(2) + ' €'; } })(v ? v.price : 0);
        // Lo que se graba en cada cara, a lo ancho: antes solo salía delante, y en la columna de la derecha se
        // apelotonaba (Susana, 23-sep-2026: que nombre también lo de detrás)
        var cara = function (etq, els) { var r = resumen(els); return '<li><b>' + etq + '</b>' + esc(r === 'Sin grabado' ? 'sin grabado' : r) + '</li>'; };
        // Plegado, con el acabado y el precio a la vista: dentro, lo de siempre (desplegables, Susana, 24-sep-2026)
        box.innerHTML = '<div class="cm-dp cm-dp--sum">' + cabDesplegable('cm-dp-sum', 'Revisa y confirma', (opts ? opts + ' · ' : '') + precio, G.sumAbierto, ' data-cm-sum', WZ_ON ? 2 : 3, p ? 'is-active' : '') +
          '<div class="cm-dp__cuerpo" id="cm-dp-sum"' + (G.sumAbierto ? '' : ' hidden') + '><div class="cm-sum">' +
          '<div class="cm-sum__row"><span>Tu diseño</span><strong>' + (p ? esc(p.nombre) : '<button type="button" class="cm-sum__todo" data-cm-goto>' + (WZ_ON ? 'Falta personalizar tu medalla' : 'Falta generar tu diseño') + '</button>') + '</strong></div>' +
          (p ? '<ul class="cm-sum__caras">' + cara('Delante', p.delante) + cara('Detrás', p.detras) + '</ul>' : '') +
          (opts ? '<div class="cm-sum__row"><span>Acabado</span><span>' + esc(opts) + '</span></div>' : '') +
          '<div class="cm-sum__row cm-sum__total"><span>Total</span><strong>' + precio + '</strong></div>' +
          '<p class="cm-sum__free">Grabado incluido en el precio</p></div></div></div>';
      }
    }

    // ---- ficheros del pedido: JPG de la vista previa y SVG a tamaño real ----
    var dataUrls = {};
    function toDataUrl(url) {
      if (!dataUrls[url]) {
        dataUrls[url] = fetch(url).then(function (r) { if (!r.ok) throw new Error('img'); return r.blob(); }).then(function (b) {
          return new Promise(function (ok, ko) { var fr = new FileReader(); fr.onload = function () { ok(fr.result); }; fr.onerror = ko; fr.readAsDataURL(b); });
        });
        dataUrls[url].catch(function () { delete dataUrls[url]; });
      }
      return dataUrls[url];
    }
    function letrasUsadas() {
      var p = propuesta(), uso = {};
      ['delante', 'detras'].forEach(function (k) {
        (p && p[k] || []).forEach(function (e) { if (e.texto && e.letra) uso[e.letra] = (uso[e.letra] || '') + e.texto; });
      });
      return uso;
    }
    function fuentesIncrustadas() {
      var uso = letrasUsadas();
      return Promise.all(Object.keys(uso).map(function (f) {
        var chars = Array.from(new Set(Array.from(uso[f] + 'DELANTEDETRÁS'))).join('');
        var url = 'https://fonts.googleapis.com/css2?family=' + encodeURIComponent(f).replace(/%20/g, '+') + (ESPEC_FUENTE[f] != null ? ESPEC_FUENTE[f] : ':ital,wght@0,500;1,500') + '&text=' + encodeURIComponent(chars);
        return fetch(url).then(function (r) { return r.text(); }).then(function (css) {
          var caras = css.match(/@font-face\s*{[^}]+}/g) || [];
          return Promise.all(caras.map(function (cara) {
            var m = cara.match(/url\((https:[^)]+)\)/);
            if (!m) return '';
            return toDataUrl(m[1]).then(function (du) { return cara.replace(m[1], du); });
          })).then(function (a) { return a.join(''); });
        }).catch(function () { return ''; });
      })).then(function (a) { return a.join(''); });
    }
    function hacerJpg() {
      var m = METAL[metalKey(currentVariant())];
      return Promise.all([toDataUrl(m.src), fuentesIncrustadas()]).then(function (r) {
        // Las dos caras si se graba detrás; si no, solo la de delante (Susana, 9-oct-2026). Con dos, la de detrás va
        // debajo: en la columna estrecha de la cesta, una al lado de la otra quedaban de 35 px.
        var p = propuesta(), dos = !!(p && p.detras && p.detras.length);
        var clone = svg.cloneNode(true), W = 800, H2 = dos ? 1600 : 800;
        clone.querySelectorAll('[data-cm-oculta]').forEach(function (n) { n.removeAttribute('visibility'); });
        // sin el brillo del grabado (un filtro SVG): en un móvil era lo que más tardaba (≈16 s de 21, 9-oct-2026)
        clone.querySelectorAll('[filter]').forEach(function (n) { n.removeAttribute('filter'); });
        clone.setAttribute('xmlns', NS); clone.setAttribute('width', W); clone.setAttribute('height', H2);
        clone.setAttribute('viewBox', f2(-VIEW.w / 2) + ' ' + f2(-VIEW.h / 2) + ' ' + f2(VIEW.w / 2) + ' ' + f2(dos ? 2 * VIEW.h : VIEW.h));
        if (dos) {
          var caras = Array.prototype.filter.call(clone.children, function (n) { return n.tagName.toLowerCase() === 'g'; });
          if (caras[1]) caras[1].setAttribute('transform', 'translate(' + f2(-VIEW.h) + ' ' + f2(VIEW.h) + ')');
        }
        clone.querySelectorAll('image').forEach(function (im) { if (im.getAttribute('href') === m.src) im.setAttribute('href', r[0]); });
        var st = document.createElementNS(NS, 'style'); st.textContent = r[1]; clone.insertBefore(st, clone.firstChild);
        var src = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(clone)], { type: 'image/svg+xml' }));
        return new Promise(function (ok, ko) {
          var im = new Image();
          im.onload = function () {
            var cv = document.createElement('canvas'); cv.width = W; cv.height = H2;
            var ctx = cv.getContext('2d'); ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, W, H2); ctx.drawImage(im, 0, 0, W, H2);
            URL.revokeObjectURL(src); cv.toBlob(function (b) { b ? ok(b) : ko(new Error('jpg')); }, 'image/jpeg', 0.9);
          };
          im.onerror = function () { URL.revokeObjectURL(src); ko(new Error('svg')); };
          im.src = src;
        });
      });
    }
    // El agujero de la anilla, si la medalla cuelga de uno: en el fichero del láser va en gris, como guía (no
    // se graba), para que el taller vea dónde cae. La cara de detrás se graba con la medalla dada la vuelta,
    // así que ahí el agujero cae al otro lado.
    function agujeroLaser(cx, cy, cara) {
      if (!AGUJERO) return '';
      return '<circle cx="' + f2(cx + (cara === 'detras' ? -AGUJERO.x : AGUJERO.x)) + '" cy="' + f2(cy + AGUJERO.y) + '" r="' + f2(AGUJERO.r) + '" fill="none" stroke="#bbbbbb" stroke-width="0.05" data-guia="1"/>';
    }
    // El fichero del láser, con los textos pasados a trazos (Susana, 24-sep-2026): se dibuja como la vista previa,
    // con el mismo ajuste de seguridad, en un SVG escondido en la página, y cada texto se cambia por su contorno. Si
    // las letras no llegan a tiempo (sin conexión, un navegador muy antiguo), sale como antes, con el texto y el
    // nombre de la letra, para no dejar el pedido sin fichero.
    var AVISO_TEXTO = 'letras: Google Fonts (instalar en el equipo del láser)', AVISO_TRAZOS = 'letras pasadas a trazos: no hace falta instalar ninguna';
    function hacerSvgLaser(cara) {
      var conTexto = svgLaserTexto(cara), caja = document.createElement('div');
      caja.setAttribute('aria-hidden', 'true');
      caja.style.cssText = 'position:absolute;left:-10000px;top:0;width:10px;height:10px;overflow:hidden;visibility:hidden';
      var doc = new DOMParser().parseFromString(conTexto, 'image/svg+xml'), dib = document.importNode(doc.documentElement, true);
      caja.appendChild(dib);
      document.body.appendChild(caja);
      var tope = function (ms, que) { return new Promise(function (ok, ko) { setTimeout(function () { ko(new Error(que)); }, ms); }); };
      var trazos = null;
      var respiro = function (v) { return new Promise(function (ok) { setTimeout(function () { ok(v); }, 30); }); };   // que la página conteste entre trozo y trozo
      var hecho = respiro().then(function () {
        ajustar(dib);
        return respiro();
      }).then(function () {
        return Promise.race([textosATrazos(dib), tope(4500, 'las letras tardan')]);
      }).then(respiro).then(function () {
        var cab = null;
        Array.prototype.forEach.call(dib.childNodes, function (n) { if (!cab && n.nodeType === 8) cab = n; });
        if (cab) cab.data = cab.data.replace(AVISO_TEXTO, AVISO_TRAZOS);
        trazos = '<?xml version="1.0" encoding="UTF-8"?>\n' + new XMLSerializer().serializeToString(dib) + '\n';
        if (window.__cmDepurar) window.__cmDepurar[cara] = trazos;                     // pruebas (probar-laser.mjs)
        return Promise.race([cargarMotorLaser(), tope(6000, 'el motor del láser tarda')]);
      }).then(respiro).then(function (PK) {
        // Formato del taller: fuera guías y rótulos, todo a relleno, un solo path y el lienzo ajustado al dibujo
        dib.querySelectorAll('[data-guia]').forEach(function (n) { n.remove(); });
        if (dib.querySelector('text')) throw new Error('quedan textos');
        var c = contornoLaser(dib, PK);
        if (!c) throw new Error('nada que grabar');
        var w = +c.w.toFixed(3), h = +c.h.toFixed(3), ox = +(10 * K - c.x).toFixed(2), oy = +(12 * K - c.y).toFixed(2);
        var d = c.d;
        return '<?xml version="1.0" encoding="utf-8"?>\n' +
          '<!-- Customima · medalla ' + D + ' mm · ' + esc(cfg.handle) + ' · ' + (cara === 'detras' ? 'DETRÁS' : 'DELANTE') + ' · diseño con IA · tamaño real ' +
          w + ' × ' + h + ' mm · centro de la medalla a ' + ox + ' mm del borde izquierdo y ' + oy + ' mm del de arriba del dibujo -->\n' +
          '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="' + w + 'mm" height="' + h + 'mm" viewBox="0 0 ' + w + ' ' + h + '" xml:space="preserve">\n' +
          '<g>\n\t<path d="' + d + '"/>\n</g>\n</svg>\n';
      }).catch(function () { return trazos || conTexto; });
      return hecho.then(function (txt) {
        caja.remove();
        return new Blob([txt], { type: 'image/svg+xml' });
      });
    }
    // Un fichero por cara grabada (Susana, 9-oct-2026), a tamaño real, con la medalla centrada.
    function svgLaserTexto(k) {
      var p = propuesta(), els = p ? p[k] : null, W = +(20 * K).toFixed(2), H2 = +(22 * K).toFixed(2), cx = +(10 * K).toFixed(2), cy = +(12 * K).toFixed(2);
      var nombre = k === 'delante' ? 'DELANTE' : 'DETRÁS';
      return '<?xml version="1.0" encoding="UTF-8"?>\n<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="' + W + 'mm" height="' + H2 + 'mm" viewBox="0 0 ' + W + ' ' + H2 + '">\n' +
        '<!-- Customima · medalla ' + D + ' mm · ' + esc(cfg.handle) + ' · ' + nombre + ' · diseño con IA · ' + AVISO_TEXTO + ' · línea fina ' + HAIR + ' mm -->\n' +
        '<g id="' + (k === 'delante' ? 'DELANTE' : 'DETRAS') + '">\n' +
        '<text x="' + cx + '" y="' + (2.6 * K).toFixed(2) + '" text-anchor="middle" font-family="Arial" font-size="1.6" fill="#999" data-guia="1">' + nombre + '</text>\n' +
        '<circle cx="' + cx + '" cy="' + cy + '" r="' + (D / 2) + '" fill="none" stroke="#bbbbbb" stroke-width="0.05" data-guia="1"/>' + agujeroLaser(cx, cy, k) + '\n' +
        (els && els.length ? pintarCara(els, cx, cy, '#000000', true) : '') + '\n</g>\n</svg>\n';
    }
    function ponerFichero(input, blob, nombre) {
      if (!input) return;
      if (!blob) { input.disabled = true; return; }
      var dt = new DataTransfer(); dt.items.add(new File([blob], nombre, { type: blob.type })); input.files = dt.files; input.disabled = false;
    }
    // La foto original que subió la clienta, para el taller «por si acaso» (Susana, 9-oct-2026). Tal cual si es una
    // imagen normal de hasta 15 MB; si no (HEIC, enorme), un JPG de 3000 px de lado.
    function fotoOriginal(pr) {
      var f = null;
      refsDe(pr).some(function (r) { var fu = G.fuentes[r]; f = fu && (fu.archivo || (fu.foto && fu.foto.archivo)) || null; return !!f; });
      if (!f) return Promise.resolve(null);
      if (f.size <= 15 * 1024 * 1024 && /^image\/(jpeg|png|webp)$/.test(f.type)) return Promise.resolve({ blob: f, ext: f.type === 'image/png' ? 'png' : f.type === 'image/webp' ? 'webp' : 'jpg' });
      return leerFoto(f).then(function (bm) {
        return new Promise(function (ok) { lienzo(bm, 3000).toBlob(function (b) { ok(b ? { blob: b, ext: 'jpg' } : null); }, 'image/jpeg', 0.9); });
      }).catch(function () { return null; });
    }
    var ocupado = null;
    function prepararFicheros() {
      if (!FILES) return Promise.resolve(false);
      var clave = claveDiseno;
      if (!clave) return Promise.resolve(false);
      if (claveFicheros === clave) return Promise.resolve(true);
      if (ocupado && ocupado.clave === clave) return ocupado.p;
      var pr = propuesta(), graba = function (k) { return !!(pr && pr[k] && pr[k].length); };
      // Los SVG de una en una: la caja escondida y los trazos de HarfBuzz son de la página
      var t0 = Date.now(), tm = G.tiempos = {};          // cuánto tarda cada fichero (para medir en móviles)
      // uno detrás de otro y con un respiro entre medias, para que la página siga contestando
      var r = [], paso = function (fn, k) { return new Promise(function (ok) { setTimeout(ok, 30); }).then(function () { var t = Date.now(); return Promise.resolve(fn()).then(function (b) { tm[k] = Date.now() - t; r.push(b); }); }); };
      var p = paso(hacerJpg, 'jpg')
        .then(function () { return paso(function () { return graba('delante') ? hacerSvgLaser('delante') : null; }, 'delante'); })
        .then(function () { return paso(function () { return graba('detras') ? hacerSvgLaser('detras') : null; }, 'detras'); })
        .then(function () {
        tm.total = Date.now() - t0;
        return fotoOriginal(pr).then(function (o) { r[3] = o; return r; });
      }).then(function (r) {
        if (claveDiseno !== clave) return false;
        ponerFichero(FILES.jpg, r[0], 'diseno-' + cfg.handle + '.jpg');
        ponerFichero(FILES.delante, r[1], 'grabado-delante-' + cfg.handle + '.svg');
        ponerFichero(FILES.detras, r[2], 'grabado-detras-' + cfg.handle + '.svg');
        ponerFichero(FILES.original, r[3] && r[3].blob, 'foto-original-' + cfg.handle + '.' + (r[3] ? r[3].ext : 'jpg'));
        claveFicheros = clave; return true;
      }).catch(function () { return false; }).then(function (r) { ocupado = null; return r; });
      ocupado = { clave: clave, p: p };
      return p;
    }

    // ---- compartir el diseño ----
    function enlaceDelDiseno() {
      var p = propuesta();
      if (!p) return '';
      var canon = document.querySelector('link[rel="canonical"]');
      var u = new URL(canon && canon.href ? canon.href : location.origin + location.pathname);
      var ahora = new URLSearchParams(location.search), tema = window.Shopify && window.Shopify.theme;
      if (ahora.get('view')) u.searchParams.set('view', ahora.get('view'));
      // en el piloto (tema sin publicar), el enlace abre ese tema también en otro teléfono
      if (tema && tema.id && tema.role && tema.role !== 'main') u.searchParams.set('preview_theme_id', tema.id);
      var v = currentVariant();
      if (v) u.searchParams.set('variant', v.id);                                                                   // mismo metal y color
      u.searchParams.set('diseno', codigoDelDiseno(p));
      return u.toString();
    }
    function avisoCompartir(t) {
      copiado.textContent = t; copiado.classList.add('is-on');
      clearTimeout(copiadoT); copiadoT = setTimeout(function () { copiado.classList.remove('is-on'); }, 2600);
    }
    function copiarEnlace(url) {
      var hecho = function () { avisoCompartir('Enlace copiado: pégalo donde quieras'); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(hecho, function () { window.prompt('Copia este enlace:', url); });
      else window.prompt('Copia este enlace:', url);
    }
    // En el móvil, la hoja de compartir del teléfono (WhatsApp, mensajes…); en el ordenador, se copia el enlace.
    function compartir() {
      if (refsDe(propuesta()).length) { avisoCompartir('Los diseños con foto no se pueden compartir con un enlace'); return; }
      var url = enlaceDelDiseno();
      if (!url) return;
      var tactil = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      if (tactil && navigator.share) {
        navigator.share({ title: 'Mi medalla Customima', text: 'Mira el diseño de mi medalla:', url: url })
          .catch(function (e) { if (!e || e.name !== 'AbortError') copiarEnlace(url); });
      } else copiarEnlace(url);
    }

    // ---- añadir a la cesta ----
    // Si a la clienta le faltó un dato, la IA deja el hueco entre corchetes ([NOMBRE], [FECHA], [LUGAR];
    // guía de estilo de Susana, apartado 7). Un diseño con huecos no puede ir al taller.
    var HUECO = { NOMBRE: 'el nombre', FECHA: 'la fecha', LUGAR: 'el lugar' };
    function huecosDe(p) {
      var v = [];
      ['delante', 'detras'].forEach(function (k) {
        (p && p[k] || []).forEach(function (e) {
          String(e.texto || '').replace(/\[([A-ZÁÉÍÓÚÑ ]{3,})\]/g, function (m, h) {
            var n = HUECO[h.trim()] || 'un dato';
            if (v.indexOf(n) < 0) v.push(n);
            return m;
          });
        });
      });
      return v;
    }
    // Los ficheros se preparan por adelantado solo en el último paso («¡Lista!») y con la clienta quieta 1,5 s, por
    // trozos con respiros: si toca algo, se aplaza. Así, al pulsar suele estar todo listo y el móvil no se queda
    // bloqueado justo al tocar el botón (Susana, 9-oct-2026). Si no da tiempo, se preparan después de añadir.
    var ficherosT = null;
    function programarFicheros() {
      clearTimeout(ficherosT);
      if (!FILES || !claveDiseno || claveFicheros === claveDiseno) return;
      if (WZ_ON && W && (G.ejemplo || W.d.tipo === 'sin' || W.paso !== 'fin')) return;
      var p = propuesta();
      if (!p || refsDe(p).some(function (r) { return !G.dibujos[r]; }) || huecosDe(p).length) return;
      ficherosT = setTimeout(function () { prepararFicheros(); }, 1500);
    }
    ['pointerdown', 'keydown', 'touchstart'].forEach(function (t) { document.addEventListener(t, function () { if (ficherosT) programarFicheros(); }, { passive: true, capture: true }); });
    // La cesta al momento y los ficheros por detrás (Susana, 9-oct-2026: «que al hacer click se añada en 1 segundo como
    // antes y que genere los ficheros por detrás»). Shopify tarda ~0,8 s por fichero adjunto, así que el tema añade la
    // medalla solo con los textos y una referencia (_cm_ref) y después, en segundo plano, se le adjuntan los ficheros a
    // esa línea con /cart/change.js. Mientras queda alguno por adjuntar, ir a pagar o a la cesta espera (máx. 15 s).
    var refInput = el('input', { type: 'hidden', name: 'properties[_cm_ref]', form: formId, disabled: '' }, hiddenBox);
    G.previas = G.previas || {};
    // Delante y, si se graba, detrás, en pequeño: va en la cesta hasta que llega la imagen de verdad (la línea lleva
    // data-cm-ref mientras no tiene «Previsualizar diseño», snippets/line-item.liquid)
    function miniLinea(p) {
      var mt = METAL[metalKey(currentVariant())];
      return mini((p && p.delante) || [], mt) + (p && p.detras && p.detras.length ? mini(p.detras, mt) : '');
    }
    var ultimoEnvio = null;
    function ficherosActuales() {
      var r = {}, hay = false;
      if (!FILES) return null;
      Object.keys(FILES).forEach(function (k) { var f = !FILES[k].disabled && FILES[k].files && FILES[k].files[0]; if (f) { r[k] = f; hay = true; } });
      return hay ? r : null;
    }
    function esperarLinea(ref, n) {
      return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var l = (c.items || []).filter(function (i) { return i.properties && i.properties._cm_ref === ref; })[0];
          if (l || n >= 40) return l || null;
          return new Promise(function (ok) { setTimeout(ok, 250); }).then(function () { return esperarLinea(ref, n + 1); });
        });
    }
    function adjuntar(ref, fich, intento) {
      return esperarLinea(ref, 0).then(function (l) {
        if (!l) return;                                 // la han quitado de la cesta: nada que adjuntar
        var fd = new FormData();
        fd.append('id', l.key); fd.append('quantity', String(l.quantity));
        Object.keys(l.properties || {}).forEach(function (k) { if (l.properties[k] != null) fd.append('properties[' + k + ']', l.properties[k]); });
        Object.keys(fich).forEach(function (k) { fd.append(FILES[k].name, fich[k], fich[k].name); });
        return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/change.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return r.json(); })
          .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh')); });   // el cajón enseña el diseño
      }).catch(function (e) {
        if (!intento) return adjuntar(ref, fich, 1);
        if (window.console) console.warn('cm-medalla-ia: no se han podido adjuntar los ficheros', e);
      });
    }
    function adjuntarDespues(ref, clave, listos) {
      G.adjuntando = (G.adjuntando || 0) + 1;
      var fich = listos ? Promise.resolve(listos) : prepararFicheros().then(function (ok) {
        var f = ok && claveFicheros === clave ? ficherosActuales() : null;
        apagarFicheros();
        return f;
      });
      fich.then(function (f) { return f ? adjuntar(ref, f, 0) : null; }).catch(function () {}).then(function () {
        G.adjuntando = Math.max(0, (G.adjuntando || 1) - 1);
        if (!G.adjuntando) { var l = G.esperas || []; G.esperas = []; l.forEach(function (fn) { fn(); }); }
      });
    }
    if (!G.guardaCesta) {
      G.guardaCesta = true; G.esperas = [];
      var soltar = function () { var l = G.esperas; G.esperas = []; l.forEach(function (fn) { fn(); }); };
      var previasT = 0;
      var ponerPrevias = function () {
        previasT = 0;
        Array.prototype.forEach.call(document.querySelectorAll('[data-cm-ref]'), function (li) {
          var h = G.previas[li.getAttribute('data-cm-ref')];
          if (!h || li.querySelector('.cm-linea-previa')) return;
          var span = document.createElement('span');
          span.className = 'line-item__media cm-linea-previa'; span.innerHTML = h;
          var im = li.querySelector('.line-item__media');
          if (im) im.parentNode.replaceChild(span, im); else li.insertBefore(span, li.firstChild);
        });
      };
      if (window.MutationObserver) new MutationObserver(function () { if (!previasT) previasT = requestAnimationFrame(ponerPrevias); }).observe(document.body, { childList: true, subtree: true });
      var esperando = function (a) {
        if (a.hasAttribute('data-cm-txt')) return;
        a.setAttribute('data-cm-txt', a.innerHTML);
        a.innerHTML = '<span class="cm-cesta-giro" aria-hidden="true"></span>Preparando tu diseño…';
        a.classList.add('cm-esperando');
      };
      var yaNo = function (a) { if (a.hasAttribute('data-cm-txt')) { a.innerHTML = a.getAttribute('data-cm-txt'); a.removeAttribute('data-cm-txt'); } a.classList.remove('cm-esperando'); };
      // Pagar (o ir a la cesta) con ficheros por adjuntar: espera a que terminen y sigue solo
      document.addEventListener('click', function (e) {
        if (!G.adjuntando) return;
        var a = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"], a[href$="/cart"], a[href*="/cart?"], .shopify-payment-button button, .shopify-payment-button__button');
        if (!a || a.__cmPasa) return;
        e.preventDefault(); e.stopImmediatePropagation();
        esperando(a);
        if (!G.esperas.length) setTimeout(soltar, 15000);
        G.esperas.push(function () { yaNo(a); a.__cmPasa = true; if (a.tagName === 'A' && a.href) location.href = a.href; else a.click(); setTimeout(function () { a.__cmPasa = false; }, 1000); });
      }, true);
      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (!G.adjuntando || !f || f.__cmPasa || !/\/(cart|checkout)/.test(f.getAttribute('action') || '') || /\/cart\/add/.test(f.getAttribute('action') || '')) return;
        e.preventDefault(); e.stopImmediatePropagation();
        var sub = e.submitter || null;
        if (!G.esperas.length) setTimeout(soltar, 15000);
        G.esperas.push(function () { f.__cmPasa = true; try { f.requestSubmit ? f.requestSubmit(sub) : f.submit(); } finally { setTimeout(function () { f.__cmPasa = false; }, 1000); } });
      }, true);
    }
    var pasando = false;
    function validar(e) {
      sincronizar();
      if (WZ_ON && W && G.ejemplo) {
        e.preventDefault(); e.stopImmediatePropagation();
        var falta = wzFalta();
        if (falta === 'foto') wzAviso('Tu foto aún se está dibujando: en cuanto llegue, podrás pedirla.');
        else {
          if (W.paso === 'inicio') { W.camino = W.camino || W.d.tipo || 'nombre'; }
          wzIr(falta === 'detras' ? 'detras' : (W.d.tipo === 'simbolo' ? 'texto' : 'texto'));
          wzAviso(falta === 'detras' ? 'Escribe lo que quieres detrás, o elige «Nada».' : 'La medalla que ves es un ejemplo: escribe tu texto y la verás al momento.', wz.querySelector('[data-wz]'));
          if (falta !== 'detras') {                     // o, si la quiere lisa, sin grabar (Susana, 9-oct-2026)
            wzMsg.insertAdjacentHTML('beforeend', ' ' + wzBoton('cm-wz__msgsin', '¿La quieres sin grabar?', 'sinGrabar'));
            var bs = wzMsg.querySelector('.cm-wz__msgsin');
            if (bs) sinQuitarFoco(bs).addEventListener('click', wzClic);
          }
        }
        return;
      }
      if (!propuesta()) {
        e.preventDefault(); e.stopImmediatePropagation();
        msg.textContent = 'Primero cuéntanos qué quieres grabar y genera tu diseño.';
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { ta.focus({ preventScroll: true }); }, 350);
        return;
      }
      var perdidos = refsDe(propuesta()).filter(function (r) { return !G.dibujos[r]; });
      if (perdidos.length) {
        e.preventDefault(); e.stopImmediatePropagation();
        msg.textContent = perdidos.indexOf('ia') >= 0 ? 'Espera un momento: la IA está terminando el dibujo.' : 'Vuelve a subir la foto: al recargar la página se ha perdido su dibujo.';
        if (WZ_ON) wzAviso(msg.textContent);
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var huecos = huecosDe(propuesta());
      if (huecos.length) {
        e.preventDefault(); e.stopImmediatePropagation();
        // el nombre → escríbelo; la fecha → escríbela; los dos → escríbelos
        var fin = huecos.length > 1 ? 'os' : huecos[0].indexOf('la ') === 0 ? 'a' : 'o';
        msg.textContent = 'Nos falta' + (huecos.length > 1 ? 'n ' : ' ') + yLista(huecos) + ': escríbel' + fin +
          ' en «¿Cambiamos algo?» y l' + fin + ' ponemos en tu medalla.';
        if (WZ_ON) { wzIr('ia'); wzAviso(msg.textContent.replace('en «¿Cambiamos algo?»', 'aquí')); return; }
        abrirRt(true);                            // la caja para escribirlo está dentro del desplegable
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { rtTa.focus({ preventScroll: true }); }, 350);
        return;
      }
      refInput.disabled = true; refInput.value = '';
      if (WZ_ON && W && W.d.tipo === 'sin') { apagarFicheros(); return; }
      if (FILES && !pasando) {
        // un segundo toque seguido con el mismo diseño no la añade dos veces
        var ahora = Date.now();
        if (ultimoEnvio && ultimoEnvio.clave === claveDiseno && ahora - ultimoEnvio.t < 1500) { e.preventDefault(); e.stopImmediatePropagation(); return; }
        ultimoEnvio = { clave: claveDiseno, t: ahora };
        var ref = 'm' + ahora.toString(36) + Math.random().toString(36).slice(2, 6);
        var listos = claveFicheros === claveDiseno ? ficherosActuales() : null;
        refInput.value = ref; refInput.disabled = false;
        G.previas[ref] = miniLinea(propuesta());
        apagarFicheros();                               // el tema la añade ya, sin ficheros (medio segundo)
        adjuntarDespues(ref, claveDiseno, listos);
      }
    }

    // ---- Paso a paso (Susana, 9-oct-2026: «monta la C», recorrido «Según lo que quieras grabar») ----
    // La ficha arranca con la medalla que más se pide (90 pedidos de Zakeke revisados: un nombre en caligrafía delante y
    // una fecha detrás) y la primera pregunta decide el camino: un nombre, unas iniciales, una fecha o frase, una foto o
    // un símbolo, o «No sé qué poner» (la IA, como antes). Cada camino tiene sus pasos, todos con «Atrás». Los diseños de
    // texto y de símbolo se componen aquí, sin la IA, y los coloca el servidor (/colocar, la tinta real de cada letra).
    // La foto usa el mismo dibujo de antes (letra a trazos aquí; mascota y retrato, la IA de imagen). Con ?cmpasos=0, la
    // ficha de antes (caja de texto y «Generar diseño con IA»).
    var WZ_LETRA_W = { 'Allura': 0.36, 'Caveat': 0.38, 'Fredoka': 0.5, 'Permanent Marker': 0.58, 'Cinzel Decorative': 0.72, 'Inter': 0.52,
      'Playfair Display': 0.48, 'Courier Prime': 0.6, 'UnifrakturMaguntia': 0.46 };
    var WZ_MAX = { 'Allura': 4.8, 'Caveat': 4.4, 'Fredoka': 3.8, 'Permanent Marker': 3.6, 'Cinzel Decorative': 3.4, 'Inter': 3.6,
      'Playfair Display': 3.8, 'Courier Prime': 3.4, 'UnifrakturMaguntia': 4 };
    var WZ_SCRIPT = { 'Allura': 1, 'Caveat': 1 };
    var WZ_ICO = {
      nombre: 'M5 6h14M12 6v13M9 19h6', iniciales: 'M6 18V6l6 8 6-8v12', frase: 'M4 7h16M4 12h10M4 17h13',
      foto: 'M4 8h3l2-3h6l2 3h3v11H4zM12 16.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z', simbolo: 'M12 3v18M6 9h12',
      ia: 'M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5L18 18M6 18l2.5-2.5M15.5 8.5L18 6'
    };
    var WZ_TIPOS = {
      nombre: { label: 'Uno o varios nombres', sub: 'Lucía, o Leo y Vera · 3 pasos', ej: 'Lucía', letra: 'Allura', camino: ['texto', 'letra', 'detras', 'fin'],
                q: '¿Qué nombre o nombres grabamos?', lab: 'Nombre', ph: 'Ej.: Lucía' },
      iniciales: { label: 'Iniciales', sub: 'L & M · 3 pasos', ej: 'L & M', letra: 'Cinzel Decorative', camino: ['texto', 'disp', 'detras', 'fin'],
                   q: '¿Qué iniciales grabamos?', lab: 'Iniciales', ph: 'Ej.: L & M' },
      frase: { label: 'Fecha o frase', sub: 'Siempre contigo · 4 pasos', ej: 'Siempre contigo', letra: 'Allura', camino: ['texto', 'letra', 'disp', 'detras', 'fin'],
               q: 'Escribe tu fecha o frase', lab: 'Fecha o frase (hasta 3 líneas cortas)', ph: 'Ej.: Siempre contigo' },
      foto: { label: 'Una foto', sub: 'Mascota, persona o letra · 3 pasos', camino: ['fotoTipo', 'fotoEstilo', 'detras', 'fin'] },
      simbolo: { label: 'Un dibujo', sub: 'Más de 80, o el que pidas · 3 pasos', ej: '', letra: 'Allura', camino: ['sym', 'texto', 'detras', 'fin'],
                 q: '¿Le añadimos un nombre o un texto?', lab: 'Nombre o texto (opcional)', ph: 'Ej.: Ana · Siempre contigo' },
      ia: { camino: ['ia', 'fin'] },
      sin: { camino: ['fin'] }                        // la medalla lisa, sin grabar
    };
    var WZ_SIMBOLOS = [['cruz', 'Cruz'], ['corazon', 'Corazón'], ['estrella', 'Estrella'], ['luna', 'Luna'], ['trebol', 'Trébol'],
      ['montana', 'Montaña'], ['brujula', 'Brújula'], ['caliz', 'Cáliz']];
    // Dónde va el dibujo respecto al texto (Susana, 9-oct-2026: «que se puedan escoger las posiciones»)
    // Las cuatro maneras de colocarlo que se le enseñan ya montadas (una, con el texto en curva)
    var WZ_POS = [['arriba', 'Encima'], ['der', 'Al lado'], ['lados', 'A los lados'], ['curva', 'En curva']];
    var WZ_POS_SIM = [['arriba', 'Dibujo arriba'], ['abajo', 'Dibujo abajo'], ['izq', 'Al lado'], ['curva', 'En curva']];
    var WZ_PICKER = ['sym', 'icono', 'iconoDet'];
    var WZ_DISP = [['centro', 'Centrado'], ['filete', 'Con filete'], ['arco', 'Texto en arco'], ['inicial', 'Inicial grande']];
    var WZ_LETRAS_1 = ['caligrafia', 'manuscrita', 'clasica', 'palo', 'monograma', 'infantil'];
    var WZ_LETRAS_2 = ['negrita', 'grafiti', 'maquina', 'gotica'];
    var WZ_FECHA_EJ = '14 · 06 · 2019', WZ_FRASE_EJ = 'Siempre contigo';
    function wzD0() {
      return { tipo: 'nombre', texto: '', linea2: '', letra: 'Allura', peso: 400, disp: 'centro', detalle: 'ninguno', simbolo: 'cruz', simboloPos: 'arriba',
               icono: '', iconoPos: 'arriba', detrasIcono: '', detrasIconoPos: 'arriba',
               detrasModo: 'fecha', detrasTexto: '', frenteExterno: false, fotoTipo: 'mascota', fotoNombre: '' };
    }
    G.wz = G.wz || { paso: 'inicio', camino: '', hist: [], d: wzD0(), frenteExt: null, detrasExt: null, todas: false };
    G.cara = G.cara || 'delante';
    var W = G.wz;
    function wzActivo() { return WZ_ON; }
    function wzPartir(t, maxCh, maxLin) {
      var lineas = [];
      String(t || '').split(/\n/).forEach(function (parte) {
        var cur = '';
        parte.trim().split(/\s+/).forEach(function (w) {
          if (!w) return;
          if (cur && (cur + ' ' + w).length > maxCh) { lineas.push(cur); cur = w; } else cur = cur ? cur + ' ' + w : w;
        });
        if (cur) lineas.push(cur);
      });
      if (lineas.length > maxLin) lineas = lineas.slice(0, maxLin - 1).concat([lineas.slice(maxLin - 1).join(' ')]);
      return lineas.length ? lineas : [''];
    }
    function wzTam(texto, letra, peso, ancho, max) {
      var w = (WZ_LETRA_W[letra] || 0.55) * (letra === 'Inter' && peso === 700 ? 1.08 : 1);
      var t = ancho / (Math.max(1, String(texto).length) * w);
      return r2(Math.max(minFont(letra), Math.min(max, t)));
    }
    function wzTexto(texto, letra, peso, tam, y, extra) {
      var e = { tipo: 'texto', texto: texto, letra: letra, tam: tam, x: 0, y: r2(y) };
      if (letra === 'Inter') e.peso = peso || 400;
      return Object.assign(e, extra || {});
    }
    // El catálogo de dibujos (cm-iconos.json, junto a este fichero en el tema): se carga la primera vez que hace falta
    function wzCatalogo() {
      if (!G.iconosCat) G.iconosCat = fetch(ASSETS + 'cm-iconos.json').then(function (r) { if (!r.ok) throw new Error('iconos'); return r.json(); })
        .catch(function (e) { G.iconosCat = null; throw e; });
      return G.iconosCat;
    }
    function wzIcono(id) { var c = G.iconos; if (!c) return null; for (var i = 0; i < c.iconos.length; i++) if (c.iconos[i].id === id) return c.iconos[i]; return null; }
    // Pone el dibujo del catálogo en los dibujos de la página (ref «c» + id, la que acepta el servidor) para pintarlo y grabarlo
    function wzDibujoCatalogo(id) {
      var ref = 'c' + id, t = G.iconos && G.iconos.trazos[id], i = wzIcono(id);
      if (!G.dibujos[ref] && t) { G.dibujos[ref] = { d: t.d, w: t.w, h: t.h, tipo: 'catalogo', nombre: i ? i.n : id }; guardarDibujos(); }
      return ref;
    }
    function wzNombreSimbolo(v) {
      v = String(v || '');
      if (v === 'ia') return 'Dibujo de la IA';
      if (v.indexOf('g:') === 0) return (G.dibujos[v.slice(2)] || {}).nombre || 'Dibujo de la IA';
      var id = v.indexOf('c:') === 0 ? v.slice(2) : v, i = wzIcono(id);
      if (i) return i.n;
      return (WZ_SIMBOLOS.filter(function (x) { return x[0] === v; })[0] || ['', v])[1];
    }
    // Un dibujo (de los nuestros, del catálogo o el de la IA) de unos «t» mm: el corazón, la estrella y la luna se
    // dibujan más pequeños que su caja, como hasta ahora (grande: 7,4 → corazón 5,2, estrella 3, luna 2,9)
    function wzIconoEl(nombre, t, y) {
      nombre = String(nombre || ''); y = r2(y || 0);
      if (nombre === 'ia' || nombre.indexOf('g:') === 0 || nombre.indexOf('c:') === 0) {
        var ref = nombre === 'ia' ? 'ia' : nombre.indexOf('g:') === 0 ? nombre.slice(2) : wzDibujoCatalogo(nombre.slice(2)), tam = r2(Math.max(2, t));
        return { tipo: 'dibujo', ref: ref, x: 0, y: y, tam: tam, ancho: tam };
      }
      if (nombre === 'corazon') return { tipo: 'corazon', x: 0, y: y, tam: r2(t * 0.7), relleno: t <= 3 };
      if (nombre === 'estrella') return { tipo: 'estrella', x: 0, y: y, tam: r2(t * 0.4), relleno: t <= 3 };
      if (nombre === 'luna') return { tipo: 'luna', x: 0, y: y, radio: r2(t * 0.39), giro: 0 };
      return { tipo: 'silueta', nombre: nombre, x: 0, y: y, tam: r2(Math.max(2, t)) };
    }
    function wzSimbolo(nombre, y, grande) { return wzIconoEl(nombre, grande ? 7.4 : 2, y); }
    var wzLienzo = null;
    function wzAncho1(texto, letra, peso) {          // ancho con letra de 1 mm (sin espaciado)
      texto = String(texto || '');
      try {
        wzLienzo = wzLienzo || document.createElement('canvas').getContext('2d');
        wzLienzo.font = (peso || (letra === 'Inter' ? 400 : 500)) + " 100px '" + letra + "'";
        var w = wzLienzo.measureText(texto).width / 100;
        if (w > 0) return w;
      } catch (x) {}
      return texto.length * (WZ_LETRA_W[letra] || 0.55);
    }
    function wzAncho(e) { var t = String(e.texto || ''); return wzAncho1(t, e.letra, e.peso) * e.tam + t.length * (e.espaciado || 0); }
    // Parte en líneas sin pasar de tres: si no caben, líneas más largas (no una última larguísima)
    function wzPartir3(t, maxCh) {
      for (var mc = maxCh; mc < 30; mc++) { var L = wzPartir(t, mc, 99); if (L.length <= 3) return L; }
      return wzPartir(t, 30, 3);
    }
    // Texto en curva: sigue el borde de abajo (arriba está la anilla; el servidor no deja arcos por arriba), con la
    // letra que quepa en unos 120° de arco
    function wzArcoTexto(texto, letra, peso, max) {
      if (WZ_SCRIPT[letra]) return wzArco(String(texto).toLocaleUpperCase('es-ES'), 'Inter', 400, 2.6, { espaciado: 0.15 });
      return wzArco(texto, letra, peso, max);
    }
    function wzArco(texto, letra, peso, max, extra) {
      var esp = (extra && extra.espaciado) || 0, n = String(texto).length, tam = max, rc = ER - 1, r;
      for (var i = 0; i < 4; i++) { r = rc - 0.85 * tam - 0.15; tam = Math.max(minFont(letra), Math.min(max, (2.1 * r - n * esp) / Math.max(0.5, wzAncho1(texto, letra, peso)))); }
      var e = { tipo: 'arco', texto: texto, letra: letra, tam: r2(tam), radio: r2(rc - 0.85 * tam - 0.15), posicion: 'abajo' };
      if (letra === 'Inter') e.peso = peso || 400;
      return Object.assign(e, extra || {});
    }
    // Lo del centro, cuando el texto va en curva: en el hueco entre la anilla y la curva
    function wzCentro(cen, ac) {
      if (!cen.length) return [ac];
      wzApilar(cen, 0.9);
      var arriba = -(ER - 1) + 1.4, abajo = ac.radio - 0.7;
      wzEncajar(cen, abajo - arriba);
      var cj = wzCaja(cen), mover = (arriba + abajo) / 2 - (cj[0] + cj[1]) / 2;
      cen.forEach(function (e) { e.y = r2(e.y + mover); });
      return cen.concat([ac]);
    }
    function wzLateral(pos) { return pos === 'izq' || pos === 'der' ? 1 : pos === 'lados' ? 2 : 0; }
    function wzCaja(els) {
      var a = Infinity, b = -Infinity;
      els.forEach(function (e) { if (e.tipo === 'arco') return; var h = wzAlto(e) / 2; a = Math.min(a, e.y - h); b = Math.max(b, e.y + h); });
      return [a, b];
    }
    // Pone el dibujo junto a lo ya colocado: encima o debajo de todo, o a un lado (o a los dos) de las líneas
    // principales «prin». Luego todo se recentra y, si no cabe de alto, se encoge un poco.
    function wzPonIcono(els, prin, v, pos, t, maxAlto) {
      if (!v) return els;
      var g = 0.7, n = wzLateral(pos);
      if (!n) {
        var ic = wzIconoEl(v, t), cj = wzCaja(els), h = wzAlto(ic);
        ic.y = pos === 'arriba' ? cj[0] - 0.9 - h / 2 : cj[1] + 0.9 + h / 2;
        if (pos === 'arriba') els.unshift(ic); else els.push(ic);
        var cj2 = wzCaja(els), mover = 0.5 - (cj2[0] + cj2[1]) / 2;
        els.forEach(function (e) { if (e.tipo !== 'arco') e.y = r2(e.y + mover); });
      } else {
        var an = 0, s = Math.max(2, t), lim = n === 2 ? 2 * (ER - 1.6 - g - s) : 2 * (ER - 1.6) - g - s;
        prin.forEach(function (e) { an = Math.max(an, wzAncho(e)); });
        if (an > lim) {
          prin.forEach(function (e) { e.tam = r2(Math.max(minFont(e.letra), e.tam * lim / an)); });
          an = 0; prin.forEach(function (e) { an = Math.max(an, wzAncho(e)); });
        }
        var yc = r2((prin[0].y + prin[prin.length - 1].y) / 2), lados = n === 2 ? [-1, 1] : [pos === 'izq' ? -1 : 1];
        var dx = n === 1 ? -lados[0] * (g + s) / 2 : 0;
        prin.forEach(function (e) { e.x = r2((+e.x || 0) + dx); });
        lados.forEach(function (l) { var ic = wzIconoEl(v, s, yc); ic.x = r2(l * (an / 2 + g + s / 2) + dx); els.push(ic); });
      }
      return wzEncajar(els, maxAlto || 12.4);
    }
    function wzEncajar(els, maxAlto) {
      var cj = wzCaja(els), alto = cj[1] - cj[0];
      if (!(alto > maxAlto)) return els;
      var f = maxAlto / alto, c = (cj[0] + cj[1]) / 2;
      els.forEach(function (e) {
        if (e.tipo === 'arco') return;
        e.y = r2(0.5 + (e.y - c) * f);
        if (e.x) e.x = r2(e.x * f);
        if (e.tipo === 'texto') e.tam = r2(Math.max(minFont(e.letra), e.tam * f));
        else if (e.tipo === 'filete') e.ancho = r2(e.ancho * f);
        else {
          if (e.tam) e.tam = r2(Math.max(e.tipo === 'dibujo' || e.tipo === 'silueta' ? 2 : 0, e.tam * f));
          if (e.tipo === 'dibujo') e.ancho = e.tam;
          if (e.radio) e.radio = r2(e.radio * f);
        }
      });
      return els;
    }
    // ---- Que el diseño llene la medalla (Susana, 9-oct-2026: «aprovechar al máximo, con 2 mm de margen») ----
    // El sitio de grabar es el círculo de ER − 1 mm (en la de 20 mm, 8 mm de radio: 2 mm al borde, la «composicion» del
    // servidor) y, arriba, lo que deja libre la anilla. Cada elemento, con la caja de su tinta como la mide el servidor.
    function wzCajaEl(e) {
      var x = +e.x || 0, y = +e.y || 0, t = +e.tam || 0, w, h, dy = 0;
      if (e.tipo === 'texto') { w = wzAncho(e); h = wzAlto(e); }
      else if (e.tipo === 'dibujo') {
        var g = G.dibujos[e.ref], a = +e.ancho || t;
        if (g && g.w && g.h) { var k = Math.min(a / g.w, t / g.h); w = g.w * k; h = g.h * k; } else { w = a; h = t; }
      }
      else if (e.tipo === 'corazon') { w = t; h = 0.98 * t; dy = -0.01 * t; }
      else if (e.tipo === 'estrella') { w = h = 2 * t; }
      else if (e.tipo === 'luna') { w = h = 2 * (+e.radio || 1); }
      else if (e.tipo === 'filete') { w = 2 * (+e.ancho || 2.4); h = 0.4; x = 0; }
      else if (e.tipo === 'silueta') { w = h = t; }
      else return null;
      return [x - w / 2, x + w / 2, y + dy - h / 2, y + dy + h / 2];
    }
    function wzCaben(cajas, abajo) {
      var R = ER - 1.1, arriba = -(ER - 2.1);
      return cajas.every(function (c) {
        if (!c) return true;
        if (c[2] < arriba || c[3] > abajo) return false;
        return [c[0], c[1]].every(function (px) { return [c[2], c[3]].every(function (py) { return Math.sqrt(px * px + py * py) <= R; }); });
      });
    }
    // Agranda (o encoge, si se sale) todo a la vez, alrededor del centro del sitio libre, hasta tocar el margen. La letra
    // no pasa de un tope razonable (un nombre solo no se hace gigante) y lo que va en curva por el borde no se toca.
    function wzAmpliar(els) {
      if (!els || !els.length) return els;
      var arco = null, libres = [];
      els.forEach(function (e) { if (e.tipo === 'arco') arco = e; else libres.push(e); });
      if (!libres.length) return els;
      var arriba = -(ER - 2.1), abajo = arco ? arco.radio - 0.7 : ER - 1.1, tc = (arriba + abajo) / 2;
      var cj0 = libres.map(wzCajaEl), y0 = Infinity, y1 = -Infinity;
      cj0.forEach(function (c) { if (c) { y0 = Math.min(y0, c[2]); y1 = Math.max(y1, c[3]); } });
      if (!(y1 > y0)) return els;
      var cy = (y0 + y1) / 2, fmax = 2.2;
      libres.forEach(function (e) {
        if (e.tipo !== 'texto') return;
        var tope = e.letra === 'Inter' ? (e.peso === 300 ? 3 : 2.6) : WZ_SCRIPT[e.letra] ? 6.5 : 5.5;
        fmax = Math.min(fmax, Math.max(tope, e.tam) / e.tam);
      });
      var prueba = function (f) {
        return cj0.map(function (c) { return c && [c[0] * f, c[1] * f, tc + (c[2] - cy) * f, tc + (c[3] - cy) * f]; });
      };
      var lo = 0.5, hi = fmax;
      if (wzCaben(prueba(hi), abajo)) lo = hi;
      else for (var i = 0; i < 22; i++) { var mid = (lo + hi) / 2; if (wzCaben(prueba(mid), abajo)) lo = mid; else hi = mid; }
      var f = lo * 0.99;
      libres.forEach(function (e, i) {
        var c = cj0[i];
        e.x = r2((+e.x || 0) * f);
        e.y = r2(tc + ((+e.y || 0) - cy) * f);
        if (e.tipo === 'texto') e.tam = r2(Math.max(minFont(e.letra), e.tam * f));
        else if (e.tipo === 'dibujo') { if (c) { e.tam = r2((c[3] - c[2]) * f); e.ancho = r2((c[1] - c[0]) * f); } }
        else if (e.tipo === 'filete') e.ancho = r2((+e.ancho || 2.4) * f);
        else if (e.tipo === 'luna') e.radio = r2((+e.radio || 1) * f);
        else if (e.tam) e.tam = r2(e.tam * f);
      });
      return els;
    }
    function wzLineas(els, lh) {
      var y0 = 0.5 - (els.length - 1) * lh / 2;
      els.forEach(function (e, i) { e.y = r2(y0 + i * lh); });
      return els;
    }
    function wzAlto(e) {
      if (e.tipo === 'texto') return e.tam * (WZ_SCRIPT[e.letra] ? 0.9 : 0.75);
      if (e.tipo === 'corazon') return e.tam; if (e.tipo === 'estrella') return e.tam * 2; if (e.tipo === 'luna') return (e.radio || 1) * 2;
      if (e.tipo === 'filete') return 0.8; return e.tam || 2;
    }
    // Apila los elementos de arriba abajo, centrados un poco por debajo del centro (arriba está el agujero)
    function wzApilar(els, hueco) {
      var total = 0;
      els.forEach(function (e, i) { total += wzAlto(e) + (i ? hueco : 0); });
      var y = 0.5 - total / 2;
      els.forEach(function (e, i) { var h = wzAlto(e); if (i) y += hueco; e.y = r2(y + h / 2); y += h; });
      return els;
    }
    // Los nombres de la medalla (Susana, 9-oct-2026: «¿y si quiero grabar varios nombres?»): el primero y los que añade
    function wzNombres(d) {
      var v = [(d.texto || '').trim()].concat((d.nombres || []).map(function (n) { return String(n || '').trim(); }));
      return v.filter(Boolean);
    }
    function wzFrente(d) {
      var T = WZ_TIPOS[d.tipo] || WZ_TIPOS.nombre, tx = (d.texto || '').trim() || T.ej || '', letra = d.letra, peso = d.peso, l2 = (d.linea2 || '').trim();
      if (d.tipo === 'simbolo') {
        var conNombre = !!(d.texto || '').trim(), spos = d.simboloPos || 'arriba';
        if (conNombre && spos === 'curva') return wzCentro([wzIconoEl(d.simbolo, 6.4)], wzArcoTexto(tx.replace(/\s+/g, ' '), letra, peso, 3));
        if (conNombre && wzLateral(spos)) {             // el dibujo a un lado y el texto al otro
          var ll = tx.length > 9 && tx.indexOf(' ') > 0 ? wzPartir(tx, 9, 3) : [tx], tl = ll.length > 1 ? 2.6 : 3.2;
          ll.forEach(function (l) { tl = Math.min(tl, wzTam(l, letra, peso, 7.6, tl)); });
          var pl = wzLineas(ll.map(function (l) { return wzTexto(l, letra, peso, tl, 0); }), tl * (WZ_SCRIPT[letra] ? 1.05 : 1.2));
          return wzPonIcono(pl, pl.slice(), d.simbolo, spos === 'lados' ? 'izq' : spos, 4.8);
        }
        var s = wzSimbolo(d.simbolo, 0, true);
        if (conNombre) { if (s.tipo === 'silueta' || s.tipo === 'dibujo') s.tam = s.ancho = 6.2; if (s.tipo === 'corazon') s.tam = 4.4; if (s.tipo === 'estrella') s.tam = 2.6; if (s.tipo === 'luna') s.radio = 2.5; }
        var pila = [s];
        if (conNombre) {
          var lsim = tx.length > 12 && tx.indexOf(' ') > 0 ? wzPartir(tx, 13, 3) : [tx], tsim = lsim.length > 1 ? 2.8 : 3.2;
          lsim.forEach(function (l) { tsim = Math.min(tsim, wzTam(l, letra, peso, 11, tsim)); });
          if (lsim.length > 1) { if (s.tipo === 'silueta' || s.tipo === 'dibujo') s.tam = s.ancho = 4.8; if (s.tipo === 'corazon') s.tam = 3.4; if (s.tipo === 'estrella') s.tam = 2; if (s.tipo === 'luna') s.radio = 1.9; }
          lsim.forEach(function (l) { pila.push(wzTexto(l, letra, peso, tsim, 0)); });
          if (spos === 'abajo') pila.push(pila.shift());
          wzApilar(pila, 0.7);
          return pila;
        }
        return wzApilar(pila, 1.1);
      }
      var noms = d.tipo === 'nombre' ? wzNombres(d) : [];
      var ico = d.icono || '', ipos = d.iconoPos || 'abajo', nl = ico ? wzLateral(ipos) : 0, quita = nl * 2.9, maxCh = nl === 2 ? 9 : nl ? 11 : 13;
      if (ico && ipos === 'curva') {
        var esIni = d.disp === 'inicial' && d.tipo === 'nombre' && noms.length < 2, cen = [];
        var tc = noms.length > 1 ? (noms.length === 2 ? noms.join(' & ') : noms.join(' · ')) : tx.replace(/\s+/g, ' ');
        var ac = esIni ? wzArco(tx.toLocaleUpperCase('es-ES'), 'Inter', 400, 2, { espaciado: 0.15 })
          : wzArcoTexto(tc, letra, peso, d.tipo === 'iniciales' ? 3.6 : 3.2);
        if (esIni) cen.push(wzTexto(tx.charAt(0).toLocaleUpperCase('es-ES'), letra, peso, WZ_SCRIPT[letra] ? 7.5 : 6.2, 0));
        if (l2) cen.push(wzTexto(l2.toLocaleUpperCase('es-ES'), 'Inter', 400, wzTam(l2, 'Inter', 400, 9, 1.6), 0, { espaciado: 0.12 }));
        cen.unshift(wzIconoEl(ico, cen.length ? 2.6 : 5.6));
        return wzCentro(cen, ac);
      }
      if (d.disp === 'inicial' && d.tipo === 'nombre' && noms.length < 2) {
        var ini = tx.charAt(0).toLocaleUpperCase('es-ES');
        var pi = wzApilar([wzTexto(ini, letra, peso, WZ_SCRIPT[letra] ? 9.5 : 8, 0),
          wzTexto(tx.toLocaleUpperCase('es-ES'), 'Inter', 400, wzTam(tx, 'Inter', 400, 10, 1.6), 0, { espaciado: 0.15 })], 1.2);
        return wzPonIcono(pi, [pi[0]], ico, ipos, nl ? 2.6 : 2.2);
      }
      var lineas = d.tipo === 'frase' || (d.tipo === 'nombre' && tx.length > maxCh - 1 && tx.indexOf(' ') > 0) ? wzPartir3(tx, maxCh) : [tx];
      if (noms.length > 1) {                        // varios nombres: dos en una línea si caben; tres, uno por línea; cuatro o cinco, de dos en dos
        if (noms.length === 2) lineas = noms.join(' & ').length <= 14 - nl * 3 ? [noms.join(' & ')] : noms;
        else if (noms.length === 3) lineas = noms;
        else { lineas = []; for (var ni = 0; ni < noms.length; ni += 2) lineas.push(noms.slice(ni, ni + 2).join(' · ')); }
      }
      var max = d.tipo === 'iniciales' ? (d.disp === 'inicial' ? 7 : 5.5) : d.tipo === 'frase' ? (lineas.length > 1 ? 3.2 : 4.2) :
        noms.length > 1 ? (lineas.length === 1 ? 3.8 : lineas.length <= 3 ? 3.3 : 2.7) : lineas.length > 1 ? 3.4 : (WZ_MAX[letra] || 3.6);
      var tam = max;
      lineas.forEach(function (l) { tam = Math.min(tam, wzTam(l, letra, peso, (lineas.length > 1 ? 12 : 13) - quita, max)); });
      var els = lineas.map(function (l) { return wzTexto(l, letra, peso, tam, 0); });
      if (d.disp === 'filete') els.push({ tipo: 'filete', y: 0, ancho: 3.4, motivo: 'ninguno' });
      if (l2 && d.disp !== 'arco') els.push(wzTexto(l2.toLocaleUpperCase('es-ES'), 'Inter', 400, wzTam(l2, 'Inter', 400, 12, 1.6), 0, { espaciado: 0.12 }));
      wzApilar(els, lineas.length > 1 ? 0.6 : 1.1);
      if (lineas.length > 1) {                          // las líneas de la frase, juntas
        var lh = tam * (WZ_SCRIPT[letra] ? 1.05 : 1.2), y0 = els[0].y;
        for (var i = 1; i < lineas.length; i++) els[i].y = r2(y0 + i * lh);
        var resto = els.slice(lineas.length), fin = els[lineas.length - 1].y + tam * 0.5;
        resto.forEach(function (e) { var h = wzAlto(e); e.y = r2(fin + 1 + h / 2); fin = e.y + h / 2; });
        var alto = fin - (els[0].y - tam * 0.45), mover = 0.5 - ((els[0].y - tam * 0.45) + alto / 2);
        els.forEach(function (e) { e.y = r2(e.y + mover); });
      }
      if (ico) wzPonIcono(els, els.slice(0, lineas.length), ico, ipos, nl ? (lineas.length > 1 ? 2.2 : 2.6) : (lineas.length > 1 || l2 ? 2.8 : 3.4), l2 && d.disp === 'arco' ? 9.5 : 12.4);
      if (l2 && d.disp === 'arco') els.push({ tipo: 'arco', texto: l2.toLocaleUpperCase('es-ES'), letra: 'Inter', peso: 400, tam: 1.6, espaciado: 0.15, radio: 6.4, posicion: 'abajo' });
      return els;
    }
    function wzDetras(d) {
      var ico = d.detrasModo === 'propio' ? '' : d.detrasIcono || '', ipos = d.detrasIconoPos || 'arriba', nl = ico ? wzLateral(ipos) : 0;
      if (d.detrasModo === 'nada') return ico ? [wzIconoEl(ico, 6.4, 0.5)] : null;
      if (d.detrasModo === 'propio') return copia(W.detrasExt);
      var fecha = d.detrasModo === 'fecha', t = (d.detrasTexto || '').trim() || (fecha ? WZ_FECHA_EJ : WZ_FRASE_EJ);
      if (ico && ipos === 'curva') {
        var tcd = t.replace(/\s+/g, ' ');
        return wzCentro([wzIconoEl(ico, 5.6)], fecha ? wzArco(tcd, 'Inter', 300, 2.2, { espaciado: 0.12 }) : wzArcoTexto(tcd, d.letra, d.peso, 3));
      }
      var quita = nl * (fecha ? 2.6 : 2.9), lineas = fecha ? wzPartir(t, 14, 3) : wzPartir3(t, 12 - nl * 2), els;
      if (fecha) {
        var tf = 2.2;
        lineas.forEach(function (l) { tf = Math.min(tf, nl ? Math.max(1.6, (13 - quita - l.length * 0.12) / wzAncho1(l, 'Inter', 300)) : wzTam(l, 'Inter', 300, 13 - quita, 2.2)); });
        els = lineas.map(function (l) { return wzTexto(l, 'Inter', 300, tf, 0, { espaciado: 0.12 }); });
      } else {
        var letra = d.letra, max = lineas.length > 1 ? 3.2 : 4.2, tt = max;
        lineas.forEach(function (l) { tt = Math.min(tt, wzTam(l, letra, d.peso, 12.5 - quita, max)); });
        els = lineas.map(function (l) { return wzTexto(l, letra, d.peso, tt, 0); });
      }
      wzLineas(els, els[0].tam * (WZ_SCRIPT[els[0].letra] ? 1.05 : 1.3));
      if (ico) wzPonIcono(els, els.slice(), ico, ipos, nl ? 2.2 : fecha ? 3 : 3.2);
      return els;
    }
    function wzEstilo(letra, peso) {
      for (var i = 0; i < ESTILOS.length; i++) if (ESTILOS[i].letra === letra && (letra !== 'Inter' || ESTILOS[i].peso === (peso || 400))) return ESTILOS[i];
      return ESTILOS[0];
    }
    function wzComponer(d) {
      d = d || W.d;
      if (d.tipo === 'sin') return { nombre: 'Sin grabar', explicacion: '', delante: null, detras: null };
      var del = d.frenteExterno ? copia(W.frenteExt) : wzAmpliar(wzFrente(d));
      var tx = (d.texto || '').trim() || (WZ_TIPOS[d.tipo] || {}).ej || '';
      return { nombre: d.frenteExterno ? ((propuesta() || {}).nombre || 'Tu medalla') : (tx || 'Tu medalla'), explicacion: d.frenteExterno ? ((propuesta() || {}).explicacion || '') : '',
               delante: del && del.length ? del : null, detras: d.detrasModo === 'propio' ? wzDetras(d) : wzAmpliar(wzDetras(d)) };
    }
    // ¿Sigue siendo el ejemplo? Entonces no se puede pedir: hay que escribir el texto (o elegir «Nada» detrás)
    function wzFalta() {
      var d = W.d;
      if (d.tipo === 'sin') return '';
      if (d.tipo === 'simbolo' && d.simbolo === 'ia') return 'dibujo';
      if ((d.icono === 'ia' && !d.frenteExterno) || (d.detrasIcono === 'ia' && d.detrasModo !== 'propio')) return 'dibujo';
      if (!d.frenteExterno && d.tipo !== 'simbolo' && !(d.texto || '').trim()) return 'texto';
      if (d.frenteExterno && !W.frenteExt) return 'foto';
      if ((d.detrasModo === 'fecha' || d.detrasModo === 'texto') && !(d.detrasTexto || '').trim()) return 'detras';
      return '';
    }
    function wzPeticion() {
      var d = W.d, e = wzEstilo(d.letra, d.peso), T = WZ_TIPOS[d.tipo] || {};
      if (d.tipo === 'sin') return 'Sin grabar (la medalla lisa)';
      if (d.frenteExterno) return G.texto || '';
      var v = ['Paso a paso: ' + (T.label || d.tipo).toLowerCase()];
      if ((d.texto || '').trim()) v.push('«' + (d.tipo === 'nombre' ? wzNombres(d).join('», «') : d.texto.trim()) + '»');
      if (d.tipo === 'simbolo') v.push(wzNombreSimbolo(d.simbolo).toLowerCase() + ((d.texto || '').trim() ? ' ' + wzPosNombre(d.simboloPos || 'arriba') : ''));
      if (d.icono && d.tipo !== 'simbolo') v.push('dibujo ' + wzNombreSimbolo(d.icono).toLowerCase() + ' ' + wzPosNombre(d.iconoPos));
      v.push('letra ' + e.nombre.toLowerCase());
      if (d.disp !== 'centro' && d.tipo !== 'simbolo') v.push((WZ_DISP.filter(function (x) { return x[0] === d.disp; })[0] || ['', ''])[1].toLowerCase());
      if ((d.linea2 || '').trim()) v.push('debajo «' + d.linea2.trim() + '»');
      var dIco = d.detrasIcono && d.detrasModo !== 'propio' ? wzNombreSimbolo(d.detrasIcono).toLowerCase() : '';
      v.push(d.detrasModo === 'nada' ? (dIco ? 'detrás solo el dibujo ' + dIco : 'detrás sin grabar') : d.detrasModo === 'propio' ? 'detrás el de la IA' : 'detrás «' + (d.detrasTexto || '').trim() + '»' + (dIco ? ' con el dibujo ' + dIco + ' ' + wzPosNombre(d.detrasIconoPos) : ''));
      return v.join(' · ');
    }
    function wzPosNombre(p) {
      return { arriba: 'arriba', abajo: 'abajo', izq: 'a la izquierda', der: 'a la derecha', lados: 'a los dos lados', curva: 'en el centro y el texto en curva' }[p] || 'arriba';
    }
    var wzVersion = 0, wzColocarT = null, wzNombreT = null;
    // La foto ya dibujada en la medalla (la del tipo elegido), y si la IA la está dibujando ahora mismo
    function wzFotoRef() {
      var p = propuesta();
      if (!p || !W.d.frenteExterno || !W.frenteExt) return '';
      return refsDe(p).filter(function (r) { var g = G.dibujos[r]; return g && FOTO_TIPO[g.tipo] && g.tipo === W.d.fotoTipo; })[0] || '';
    }
    function wzDibujando() { return !fotoEstado.hidden && /is-trabajando/.test(fotoEstado.className); }
    // Pone el diseño en la vista previa al momento y, un poco después, el que coloca el servidor con la tinta real
    function wzAplicar(sinColocar) {
      var p = wzComponer(), v = ++wzVersion;
      G.propuestas = [p]; G.elegida = 0; G.base = copia(p); G.estado = 'listo'; G.aviso = '';
      G.ejemplo = !!wzFalta();
      pintar(); sincronizar();
      clearTimeout(wzColocarT);
      if (sinColocar || W.d.tipo === 'sin') return;
      wzColocarT = setTimeout(function () {
        colocarDiseno(p).then(function (q) {
          if (!q || v !== wzVersion || !root.isConnected) return;
          q.nombre = p.nombre; q.explicacion = p.explicacion;
          G.propuestas = [q]; G.base = copia(q);
          pintar(); sincronizar();
          if (W.paso === 'fin') wzPintar();
        });
      }, 450);
    }
    // Un diseño que no ha salido de aquí (la IA, un retoque, otra letra, un enlace): se queda tal cual, y el paso de
    // detrás solo cambia la cara de detrás
    function wzAdoptar() {
      var p = propuesta();
      if (!p) return;
      W.frenteExt = copia(p.delante); W.detrasExt = copia(p.detras);
      W.d.frenteExterno = true; W.d.detrasModo = 'propio';
      G.ejemplo = false;
    }
    function wzCamino() { return (WZ_TIPOS[W.camino] || {}).camino || []; }
    function wzIr(paso, opc) {
      opc = opc || {};
      if (!opc.sinHist && paso !== W.paso) W.hist.push(W.paso);
      W.paso = paso;
      G.cara = paso === 'detras' || paso === 'iconoDet' ? 'detras' : 'delante';
      wzPintar(); pintar();
      if (!opc.sinVer) setTimeout(wzVer, 30);
    }
    function wzAtras() {
      var prev = W.hist.pop();
      if (prev == null) return;
      W.paso = prev;
      if (prev === 'inicio') W.camino = '';
      G.cara = prev === 'detras' || prev === 'iconoDet' ? 'detras' : 'delante';
      wzPintar(); pintar(); setTimeout(wzVer, 30);
    }
    function wzSiguiente() {
      var c = wzCamino(), i = c.indexOf(W.paso), falta;
      if (WZ_PICKER.indexOf(W.paso) >= 0 && W.d[wzCampo()] === 'ia') return wzAviso('Espera un momento: la IA está terminando el dibujo.');
      if (W.paso === 'icono' || W.paso === 'iconoDet') return wzAtras();
      if (W.paso === 'fotoEstilo' && wzDibujando()) return wzAviso('Tu foto aún se está dibujando: en cuanto llegue, la ves en la medalla.');
      if (W.paso === 'fotoEstilo' && !wzFotoRef()) return wzAviso('Elige una foto para seguir.');
      if (W.paso === 'texto' && W.d.tipo !== 'simbolo' && !(W.d.texto || '').trim()) return wzAviso('Escribe ' + (W.d.tipo === 'iniciales' ? 'las iniciales' : W.d.tipo === 'frase' ? 'tu fecha o frase' : 'el nombre') + ' para seguir.', wz.querySelector('[data-wz="texto"]'));
      if (W.paso === 'detras' && (W.d.detrasModo === 'fecha' || W.d.detrasModo === 'texto') && !(W.d.detrasTexto || '').trim()) return wzAviso('Escribe ' + (W.d.detrasModo === 'fecha' ? 'la fecha' : 'el texto') + ' o elige «Nada».', wz.querySelector('[data-wz="detrasTexto"]'));
      if (W.paso === 'detras' && (falta = wzFalta()) === 'foto') return wzAviso('Tu foto aún se está dibujando: en cuanto llegue, la ves arriba.');
      if (i < 0 || i + 1 >= c.length) return wzIr('fin');
      wzIr(c[i + 1]);
    }
    function wzAviso(t, foco) {
      wzMsg.textContent = t || '';
      if (foco) { try { foco.focus(); } catch (e) {} }
    }
    // Que el paso se vea entero sin buscarlo: en el móvil, justo debajo de la vista previa pegada arriba
    function wzVer() {
      if (!root.isConnected) return;
      var tope = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cm-tope')) || 0;
      var r = wz.getBoundingClientRect(), y;
      if (htmlCls.contains('cm-movil-arriba')) {
        // la vista previa ya no va pegada (Susana, 10-oct-2026): se coloca justo bajo la cabecera y el paso, debajo
        y = stage.getBoundingClientRect().top - (tope + 4);
        // en el último paso, que se vea también el botón de la cesta (aunque el título quede bajo la vista previa)
        var cesta = W.paso === 'fin' && document.querySelector('.product-info button[type="submit"], .product-info [name="add"]');
        if (cesta && cesta.getClientRects().length) y = Math.max(y, Math.min(cesta.getBoundingClientRect().bottom - (window.innerHeight - 12), y + 130));
      }
      // en el ordenador la vista previa está en la galería: solo se mueve si el paso queda fuera de la pantalla
      else if (r.top < tope + 8) y = r.top - tope - 16;
      else if (r.top > window.innerHeight - 160) y = r.top - window.innerHeight * 0.3;
      else return;
      if (Math.abs(y) >= 4) window.scrollBy(0, y);
    }
    function wzBoton(clase, html, al, extra) {
      return '<button type="button" class="' + clase + '"' + (al ? ' data-wz-al="' + al + '"' : '') + (extra || '') + '>' + html + '</button>';
    }
    function wzIco(d, tam) { return '<svg width="' + (tam || 16) + '" height="' + (tam || 16) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; }
    function wzMini(d) { var p = wzComponer(d); return mini(p.delante || [], METAL[metalKey(currentVariant())]); }
    function wzCon(cambio) { return Object.assign({}, W.d, cambio, { frenteExterno: false }); }
    // El resumen de siempre es para el taller («su foto», «letra Allura»); aquí se le habla a la clienta
    function paraClienta(t) {
      t = String(t || '').replace(/ \((IA, )?de su foto\)/g, '').replace(/\bsu\b/g, 'tu');
      ESTILOS.forEach(function (e) { if (e.letra !== 'Inter' || e.peso === 400) t = t.split(e.letra).join(e.nombre.toLowerCase()); });
      return t;
    }
    // El metal y el color, al final (Susana, 9-oct-2026: «pon el metal al final como en la maqueta»). El selector del
    // tema se esconde (cm-medalla-ia.css) pero sigue mandando: estos botones tocan sus opciones, y el tema cambia la
    // variante, el precio y vuelve a pintar la ficha como siempre.
    function wzOpciones() {
      var v = currentVariant(), campos = document.querySelectorAll('variant-picker .variant-picker__option'), res = [];
      (cfg.options || []).forEach(function (nombre, k) {
        var valores = [];
        cfg.variants.forEach(function (x) { var o = x.options && x.options[k]; if (o && valores.indexOf(o) < 0) valores.push(o); });
        var esColor = /color/i.test(nombre) || valores.every(function (o) { return /dorad|platead|rosa|blanc|amarill/i.test(o); });
        res.push({ k: k, nombre: String(nombre).replace(/[:¿?]/g, '').trim(), valores: valores, actual: v && v.options ? v.options[k] : '', esColor: esColor, campo: campos[k] || null });
      });
      return res.filter(function (o) { return o.valores.length > 1; });
    }
    function wzElegirOpcion(k, valor) {
      var o = wzOpciones().filter(function (x) { return x.k === k; })[0];
      if (!o || !o.campo || o.actual === valor) return;
      var entradas = Array.prototype.slice.call(o.campo.querySelectorAll('input[type="radio"]'));
      var buena = entradas.filter(function (i) {
        var lab = document.querySelector('label[for="' + i.id + '"]');
        var t = lab ? (lab.textContent || lab.getAttribute('title') || lab.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim() : '';
        return t === valor;
      })[0] || entradas[o.valores.indexOf(valor)];
      if (buena) buena.click();
    }
    function wzPrecio() {
      var v = currentVariant();
      try { return ((v ? v.price : 0) / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }); } catch (e) { return ((v ? v.price : 0) / 100).toFixed(2) + ' €'; }
    }
    var WZ_SW = { dorad: 'linear-gradient(135deg,#f3de9c,#c9a24a)', platead: 'linear-gradient(135deg,#f4f5f7,#b5b9bf)', blanc: 'linear-gradient(135deg,#f4f5f7,#b5b9bf)', rosa: 'linear-gradient(135deg,#f1c9b8,#c98f78)', amarill: 'linear-gradient(135deg,#f3de9c,#c9a24a)' };
    function wzMetalHtml() {
      var ops = wzOpciones();
      if (!ops.length) return '';
      return '<div class="cm-wz__metal">' + ops.map(function (o) {
        return '<div class="cm-wz__fila"><span class="cm-wz__fila-lab">' + esc(o.nombre) + '</span><div class="cm-wz__fila-ops">' + o.valores.map(function (val) {
          var on = val === o.actual, fondo = '';
          if (o.esColor) Object.keys(WZ_SW).forEach(function (c) { if (!fondo && new RegExp(c, 'i').test(val)) fondo = WZ_SW[c]; });
          return o.esColor && fondo
            ? '<button type="button" class="cm-wz__sw' + (on ? ' is-on' : '') + '" style="background:' + fondo + '" data-wz-al="opcion" data-k="' + o.k + '" data-v="' + esc(val) + '" aria-pressed="' + on + '" aria-label="' + esc(val) + '" title="' + esc(val) + '"></button>'
            : '<button type="button" class="cm-wz__chip' + (on ? ' is-on' : '') + '" data-wz-al="opcion" data-k="' + o.k + '" data-v="' + esc(val) + '" aria-pressed="' + on + '">' + esc(val) + '</button>';
        }).join('') + '</div></div>';
      }).join('') + '</div>';
    }
    // ¿La petición o el diseño hablan de una mascota o de una persona? Entonces, al final, «Sube su foto y la dibujamos»
    function wzQuiereFoto() {
      var p = propuesta() || {}, ilus = ['delante', 'detras'].some(function (k) { return (p[k] || []).some(function (e) { return e.tipo === 'dibujo' && (e.ref === 'ia' || (G.dibujos[e.ref] && G.dibujos[e.ref].tipo === 'ilustracion')); }); });
      return W.d.tipo === 'ia' && (ilus || /perr|gat[oa]|mascota|caballo|conej|p[aá]jaro|loro|teckel|retrat|foto|cara de|abuel|madre|padre|hij[oa]|beb[eé]/i.test(G.texto || ''));
    }
    function wzDescribe() {
      var p = propuesta() || {}, d = W.d;
      var del = d.frenteExterno ? paraClienta(resumen(p.delante)) : (d.tipo === 'simbolo' ? wzNombreSimbolo(d.simbolo) + ((d.texto || '').trim() ? ' y «' + d.texto.trim() + '»' : '')
        : '«' + ((d.tipo === 'nombre' ? wzNombres(d).join(', ') : (d.texto || '').trim()) || '…') + '»' + ((d.linea2 || '').trim() ? ' y «' + d.linea2.trim() + '»' : '')) + ' en ' + wzEstilo(d.letra, d.peso).nombre.toLowerCase() +
        (!d.frenteExterno && d.icono && d.tipo !== 'simbolo' ? ', con ' + wzNombreSimbolo(d.icono).toLowerCase() : '');
      var dIco = d.detrasIcono && d.detrasModo !== 'propio' ? wzNombreSimbolo(d.detrasIcono).toLowerCase() : '';
      var det = !p.detras || !p.detras.length ? 'sin grabar' : d.detrasModo === 'propio' ? paraClienta(resumen(p.detras)) : d.detrasModo === 'nada' ? dIco : '«' + ((d.detrasTexto || '').trim() || '…') + '»' + (dIco ? ', con ' + dIco : '');
      return { del: del, det: det };
    }
    // ---- la interfaz del paso a paso ----
    var wz = el('div', { class: 'cm-wz' });
    ui.insertBefore(wz, ui.firstChild);
    var wzProg = el('div', { class: 'cm-wz__prog' }, wz);
    var wzCuerpo = el('div', { class: 'cm-wz__cuerpo' }, wz);
    var wzMsg = el('p', { class: 'cm-wz__msg', role: 'status' }, wz);
    var wzNav = el('div', { class: 'cm-wz__nav' }, wz);
    var wzFile = el('input', { type: 'file', accept: 'image/*', hidden: '' }, wz);
    var cajaSitio = el('div', { hidden: '' }, ui);       // la caja de la IA (paso «No sé qué poner») cuando no se usa
    // Al cerrar el teclado del móvil la página se queda movida y la medalla a medias por arriba: se vuelve a colocar
    wz.addEventListener('focusout', function () {
      setTimeout(function () {
        if (!htmlCls.contains('cm-movil-arriba') || !root.isConnected) return;
        var ae = document.activeElement;
        if (ae && wz.contains(ae) && /^(INPUT|TEXTAREA)$/.test(ae.tagName)) return;
        var tope = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cm-tope')) || 0, s = stage.getBoundingClientRect();
        if (s.top < tope - 4 && s.bottom > tope - 160) wzVer();   // solo si la medalla se ha ido un poco, no si bajó a leer
      }, 450);
    });
    if (WZ_ON) {
      wz.insertBefore(fotoEstado, wzMsg);               // la espera del dibujo de la foto, dentro del paso a paso
      cajaSitio.appendChild(caja);
    } else wz.hidden = true;
    var WZ_POPULARES = ['corazon', 'cruz', 'estrella', 'luna', 'alianzas', 'infinito', 'huella', 'perro', 'gato', 'ancla', 'arbolvida', 'mariposa'];
    function wzSinTildes(t) { return String(t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
    function wzIconosVisibles() {
      var c = G.iconos;
      if (!c) return [];
      var q = wzSinTildes(W.buscar).trim();
      if (q) {
        var palabras = q.split(/\s+/), temaN = {};
        c.temas.forEach(function (t) { temaN[t[0]] = t[1]; });
        return c.iconos.map(function (i) {
          var nombre = wzSinTildes(i.n), todo = nombre + ' ' + wzSinTildes(i.k) + ' ' + wzSinTildes(temaN[i.t]);
          if (!palabras.every(function (p) { return todo.indexOf(p) >= 0 || todo.split(/\s+/).some(function (w) { return w.indexOf(p) === 0 || (p.length > 3 && p.indexOf(w) === 0 && w.length > 3); }); })) return null;
          return { i: i, peso: nombre.indexOf(palabras[0]) === 0 ? 0 : nombre.indexOf(palabras[0]) >= 0 ? 1 : 2 };
        }).filter(Boolean).sort(function (a, b) { return a.peso - b.peso; }).map(function (x) { return x.i; }).slice(0, 24);
      }
      var tema = W.tema || 'populares';
      if (tema === 'populares') return WZ_POPULARES.map(wzIcono).filter(Boolean);
      return c.iconos.filter(function (i) { return i.t === tema; });
    }
    function wzMiniIcono(i) {
      var ink = '#4b3a2a';
      if (i.nativo) return '<svg viewBox="-4.7 -4.7 9.4 9.4" aria-hidden="true">' + pintarElemento(wzSimbolo(i.nativo, 0, true), ink, false) + '</svg>';
      var t = G.iconos.trazos[i.id];
      return t ? '<svg viewBox="0 0 ' + f2(t.w) + ' ' + f2(t.h) + '" aria-hidden="true"><path d="' + t.d + '" fill="' + ink + '" fill-rule="evenodd"/></svg>' : '';
    }
    // ¿Qué dibujo se está eligiendo? El principal («Un dibujo»), el que acompaña delante o el de detrás
    function wzCampo() { return W.paso === 'icono' ? 'icono' : W.paso === 'iconoDet' ? 'detrasIcono' : 'simbolo'; }
    function wzMiniValor(v) {
      v = String(v || '');
      if (!v) return '';
      if (v === 'ia') return '<span class="cm-wz__spin" aria-hidden="true"></span>';
      if (v.indexOf('g:') === 0) { var g = G.dibujos[v.slice(2)]; return g ? '<svg viewBox="0 0 ' + f2(g.w) + ' ' + f2(g.h) + '" aria-hidden="true"><path d="' + g.d + '" fill="#4b3a2a" fill-rule="evenodd"/></svg>' : ''; }
      if (v.indexOf('c:') === 0) { var i = wzIcono(v.slice(2)); return i ? wzMiniIcono(i) : ''; }
      return '<svg viewBox="-4.7 -4.7 9.4 9.4" aria-hidden="true">' + pintarElemento(wzSimbolo(v, 0, true), '#4b3a2a', false) + '</svg>';
    }
    // «¿Cómo lo colocamos?»: cuatro miniaturas con su diseño ya montado (Susana, 9-oct-2026: «muéstrale 4 opciones, una con curvatura»)
    function wzPosHtml(k) {
      var d = W.d, mt = METAL[metalKey(currentVariant())];
      if (!d[k] || (k === 'detrasIcono' && d.detrasModo !== 'fecha' && d.detrasModo !== 'texto')) return '';
      if (k === 'simbolo' && !(d.texto || '').trim()) return '';
      if (k === 'icono' && d.frenteExterno) return '';
      var act = d[k + 'Pos'] || 'arriba';
      return '<p class="cm-wz__lab">¿Cómo lo colocamos?</p><div class="cm-wz__minis cm-wz__minis--4">' +
        (k === 'simbolo' ? WZ_POS_SIM : WZ_POS).map(function (x) {
          var on = act === x[0], cambio = {}, prueba;
          cambio[k + 'Pos'] = x[0];
          prueba = k === 'detrasIcono' ? mini(wzDetras(Object.assign({}, d, cambio)) || [], mt) : wzMini(wzCon(cambio));
          return wzBoton('cm-wz__mini' + (on ? ' is-on' : ''), prueba + '<b>' + x[1] + '</b>', 'pos', ' data-k="' + k + '" data-v="' + x[0] + '" aria-pressed="' + on + '"');
        }).join('') + '</div>';
    }
    // Vuelve a pintar las cuatro miniaturas (al elegir otro dibujo, otra colocación o al escribir)
    var wzPosT = null;
    function wzPintarPos(espera) {
      clearTimeout(wzPosT);
      if (espera) { wzPosT = setTimeout(function () { wzPintarPos(); }, 250); return; }
      Array.prototype.forEach.call(wz.querySelectorAll('[data-wz-pos]'), function (c) {
        c.innerHTML = wzPosHtml(c.getAttribute('data-wz-pos') || wzCampo());
        Array.prototype.forEach.call(c.querySelectorAll('[data-wz-al]'), function (b) { sinQuitarFoco(b).addEventListener('click', wzClic); });
      });
    }
    // En el paso del texto y en el de detrás: «+ Añadir un dibujo», o el elegido con «Cambiar», quitar y dónde va
    function wzFilaIcono(k) {
      var v = W.d[k];
      if (!v) return wzBoton('cm-wz__addico', '<span>+</span><b>Añadir un dibujo</b><small>corazón, estrella, huella…</small>', 'irIcono', ' data-k="' + k + '"');
      return '<div class="cm-wz__ficono"><i>' + wzMiniValor(v) + '</i><b>' + esc(wzNombreSimbolo(v)) + '</b>' +
        wzBoton('cm-wz__cambiar', 'Cambiar', 'irIcono', ' data-k="' + k + '"') +
        wzBoton('cm-wz__quitar', '×', 'quitarIcono', ' data-k="' + k + '" aria-label="Quitar el dibujo"') + '</div>' + '<div class="cm-wz__posw" data-wz-pos="' + k + '">' + wzPosHtml(k) + '</div>';
    }
    function wzPintarIconos() {
      var caja = wz.querySelector('[data-wz-iconos]'), d = W.d, k = wzCampo();
      if (!caja) return;
      if (!G.iconos) { caja.innerHTML = '<p class="cm-wz__nota">Cargando dibujos…</p>'; return; }
      var lista = wzIconosVisibles(), q = (W.buscar || '').trim(), h = lista.map(function (i) {
        var v = i.nativo || ('c:' + i.id), on = d[k] === v;
        return wzBoton('cm-wz__icono' + (on ? ' is-on' : ''), wzMiniIcono(i) + '<b>' + esc(i.n) + '</b>', 'simbolo', ' data-v="' + v + '" aria-pressed="' + on + '"');
      }).join('');
      // el dibujo que ha hecho la IA, el primero y marcado, para ver que está puesto y poder volver a él
      var gen = String(d[k] || '').indexOf('g:') === 0 ? G.dibujos[d[k].slice(2)] : null;
      if (gen) h = wzBoton('cm-wz__icono is-on', wzMiniValor(d[k]) + '<b>Tu dibujo</b>', 'simbolo', ' data-v="' + esc(d[k]) + '" aria-pressed="true"') + h;
      // el que acompaña al texto se puede quitar
      if (k !== 'simbolo' && !q) h = wzBoton('cm-wz__icono cm-wz__icono--sin' + (!d[k] ? ' is-on' : ''), '<i>×</i><b>Sin dibujo</b>', 'simbolo', ' data-v="" aria-pressed="' + !d[k] + '"') + h;
      if (q) h += wzBoton('cm-wz__icono cm-wz__icono--ia', '<i>' + wzIco(WZ_ICO.ia, 20) + '</i><b>' + (lista.length ? '¿No es esto? ' : '') + 'Dibújalo con IA</b><small>«' + esc(q.slice(0, 40)) + '» · unos 30 s</small>', 'dibujarIA');
      if (!lista.length && !q) h = '<p class="cm-wz__nota">No hay dibujos en este tema.</p>';
      caja.innerHTML = h;
      if (!lista.length && q) caja.insertAdjacentHTML('afterbegin', '<p class="cm-wz__nota cm-wz__nota--ancha">No lo tenemos en la biblioteca, pero la IA te lo dibuja.</p>');
      Array.prototype.forEach.call(caja.querySelectorAll('[data-wz-al]'), function (b) { sinQuitarFoco(b).addEventListener('click', wzClic); });
    }
    // «Dibújalo con IA»: lo que ha buscado, dibujado por la IA de imagen (/ilustrar), como el dibujo de «No sé qué poner»
    function wzDibujarIA(q) {
      var d = W.d, k = wzCampo(), antes = d[k] === 'ia' ? (k === 'simbolo' ? 'corazon' : '') : d[k];
      d[k] = 'ia'; if (k !== 'detrasIcono') d.frenteExterno = false;
      wzAplicar(true); wzPintarIconos(); wzPintarPos();
      pensando('La IA está dibujando «' + q + '»… unos 30 segundos');
      var fallo = function (m) { pensando(''); if (W.d[k] === 'ia') { W.d[k] = antes; wzAplicar(); } if (WZ_PICKER.indexOf(W.paso) >= 0) { wzPintar(); wzAviso(m); } };
      fetch(API + '/ilustrar', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ descripcion: q, sesion: sesionId() }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (r) {
          if (!r.ok) return fallo(r.j && r.j.mensaje || 'No hemos podido hacer el dibujo. Prueba otra vez en un momento.');
          var n = 0, recibido = false;
          (function mirar() {
            setTimeout(function () {
              fetch(API + '/estado?encargo=' + encodeURIComponent(r.j.encargo)).then(function (x) { return x.json(); }).then(function (e) {
                if (e.estado === 'trabajando' && ++n < 120) return mirar();
                if (!e.dibujo) return fallo(e.aviso || e.mensaje || 'No hemos podido hacer el dibujo.');
                recibido = true;
                return cargarImagen('data:image/jpeg;base64,' + e.dibujo).then(function (im) {
                  var t = trazarImagen(im, { foto: false, grosor: GROSOR.normal, maxLado: 768 });
                  if (!t) return fallo('No hemos podido hacer el dibujo.');
                  var ref = nuevaRef();
                  G.dibujos[ref] = { d: t.d, w: t.w, h: t.h, tipo: 'ilustracion', nombre: q, mini: miniatura(im) };
                  guardarDibujos();
                  pensando('');
                  if (W.d[k] === 'ia') { W.d[k] = 'g:' + ref; wzAplicar(); }
                  if (WZ_PICKER.indexOf(W.paso) >= 0) wzPintar();
                });
              }).catch(function () { if (recibido) { pensando(''); return; } if (++n < 120) mirar(); else fallo('No hemos podido conectar.'); });
            }, n === 0 ? 4000 : 1500);
          })();
        }).catch(function () { fallo('No hemos podido conectar. Revisa tu conexión e inténtalo otra vez.'); });
    }
    function wzPintar() {
      if (!WZ_ON) return;
      var paso = W.paso, d = W.d, c = wzCamino(), i = c.indexOf(paso), h = '';
      root.classList.add('cm-wz-on');
      root.classList.remove('cm-ia--hecho');
      wzMsg.textContent = '';
      if (paso === 'letra') cargarLetras(ESTILOS.map(function (e) { return [e.letra, e.peso, (d.texto || 'Lucía') + 'Aa']; })).then(function () { if (W.paso === 'letra' && !W.letrasOk) { W.letrasOk = true; wzPintar(); } });
      // progreso
      if (paso === 'fin') wzProg.innerHTML = '';
      else if (i >= 0 && c.length > 2) wzProg.innerHTML = '<span class="cm-wz__barra"><i style="width:' + Math.round((i + 1) / c.length * 100) + '%"></i></span><b>Paso ' + (i + 1) + ' de ' + (c.length - 1) + '</b>';
      else wzProg.innerHTML = '';
      wzProg.hidden = !wzProg.innerHTML;
      // la caja de la IA solo en su paso
      if (caja.parentNode !== cajaSitio) cajaSitio.appendChild(caja);
      if (paso === 'inicio') {
        h = '<h2 class="cm-wz__q">¿Qué quieres grabar delante?</h2><div class="cm-wz__ops">' +
          ['nombre', 'iniciales', 'frase', 'foto', 'simbolo'].map(function (k) {
            var T = WZ_TIPOS[k];
            return wzBoton('cm-wz__op', '<i>' + wzIco(WZ_ICO[k]) + '</i><span><b>' + T.label + '</b><small>' + T.sub + '</small></span>', 'tipo', ' data-v="' + k + '"');
          }).join('') +
          wzBoton('cm-wz__op cm-wz__op--ia', '<i>' + wzIco(WZ_ICO.ia) + '</i><span><b>No sé qué poner</b><small>Cuéntaselo a la IA</small></span>', 'tipo', ' data-v="ia"') +
          '</div><p class="cm-wz__nota">Te enseñamos de ejemplo la medalla que más se pide: un nombre delante y una fecha detrás.</p>' +
          wzBoton('cm-wz__mas cm-wz__mas--izq cm-wz__sin', '¿La quieres sin grabar? Añádela lisa', 'sinGrabar');
      } else if (paso === 'texto') {
        var T = WZ_TIPOS[d.tipo] || WZ_TIPOS.nombre;
        h = '<h2 class="cm-wz__q">' + esc(T.q) + '</h2><label class="cm-wz__lab" for="cm-wz-texto">' + esc(T.lab) + '</label>' +
          (d.tipo === 'frase' ? '<textarea id="cm-wz-texto" class="cm-wz__in" data-wz="texto" rows="2" maxlength="60" placeholder="' + esc(T.ph) + '">' + esc(d.texto) + '</textarea>'
            : '<input id="cm-wz-texto" class="cm-wz__in" data-wz="texto" type="text" maxlength="' + (d.tipo === 'iniciales' ? 9 : d.tipo === 'simbolo' ? 40 : 28) + '" autocomplete="off" enterkeyhint="next" placeholder="' + esc(T.ph) + '" value="' + esc(d.texto) + '">') +
          (d.tipo === 'nombre' ? (d.nombres || []).map(function (n, k) {
            return '<div class="cm-wz__otro"><label class="cm-wz__lab" for="cm-wz-n' + k + '">Otro nombre</label><div class="cm-wz__fila-in">' +
              '<input id="cm-wz-n' + k + '" class="cm-wz__in" data-wz-n="' + k + '" type="text" maxlength="20" autocomplete="off" placeholder="Ej.: ' + ['Martín', 'Vera', 'Leo', 'Ana'][k % 4] + '" value="' + esc(n) + '">' +
              wzBoton('cm-wz__quitar', '×', 'quitarNombre', ' data-v="' + k + '" aria-label="Quitar este nombre"') + '</div></div>';
          }).join('') + ((d.nombres || []).length < 4 ? wzBoton('cm-wz__mas cm-wz__mas--izq', '+ Añadir otro nombre', 'otroNombre') : '') : '') +
          (d.tipo === 'nombre' || d.tipo === 'iniciales' ? '<label class="cm-wz__lab" for="cm-wz-l2">Debajo, una fecha o frase corta <small>(opcional)</small></label>' +
            '<input id="cm-wz-l2" class="cm-wz__in" data-wz="linea2" type="text" maxlength="24" autocomplete="off" enterkeyhint="next" placeholder="Ej.: 14 · 06 · 2019" value="' + esc(d.linea2) + '">' : '') +
          (d.tipo === 'simbolo' ? '<div class="cm-wz__posw" data-wz-pos="simbolo">' + wzPosHtml('simbolo') + '</div>' : wzFilaIcono('icono')) +
          '<p class="cm-wz__nota">Escríbelo tal cual quieres verlo grabado: lo ves arriba al momento.</p>';
      } else if (paso === 'letra') {
        var lista = WZ_LETRAS_1.concat(W.todas ? WZ_LETRAS_2 : []);
        h = '<h2 class="cm-wz__q">Elige la letra</h2><div class="cm-wz__minis">' + lista.map(function (id) {
          var e = ESTILO_POR_ID[id], on = e.letra === d.letra && (e.letra !== 'Inter' || e.peso === d.peso);
          return wzBoton('cm-wz__mini' + (on ? ' is-on' : ''), wzMini(wzCon({ letra: e.letra, peso: e.peso })) + '<b>' + esc(e.nombre) + '</b>', 'letra', ' data-v="' + id + '" aria-pressed="' + on + '"');
        }).join('') + '</div>' +
          (W.todas ? '' : wzBoton('cm-wz__mas', 'Ver las 10 letras', 'todas'));
      } else if (paso === 'disp') {
        h = '<h2 class="cm-wz__q">¿Cómo lo colocamos?</h2><div class="cm-wz__minis cm-wz__minis--2">' + WZ_DISP.filter(function (x) {
          return !(x[0] === 'inicial' && (d.tipo === 'frase' || wzNombres(d).length > 1));
        }).map(function (x) {
          var on = d.disp === x[0], prueba = wzCon({ disp: x[0], linea2: x[0] === 'arco' && !(d.linea2 || '').trim() ? WZ_FECHA_EJ : d.linea2 });
          return wzBoton('cm-wz__mini' + (on ? ' is-on' : ''), wzMini(prueba) + '<b>' + (x[0] === 'inicial' && d.tipo === 'iniciales' ? 'Más grandes' : x[1]) + '</b>', 'disp', ' data-v="' + x[0] + '" aria-pressed="' + on + '"');
        }).join('') + '</div>' +
          '<label class="cm-wz__lab" for="cm-wz-l2">' + (d.disp === 'arco' ? 'Texto del arco' : 'Debajo, una fecha o frase corta') + ' <small>(opcional)</small></label>' +
          '<input id="cm-wz-l2" class="cm-wz__in" data-wz="linea2" type="text" maxlength="24" autocomplete="off" placeholder="Ej.: 14 · 06 · 2019" value="' + esc(d.linea2) + '">';
      } else if (WZ_PICKER.indexOf(paso) >= 0) {
        var temas = [['populares', 'Populares']].concat(G.iconos ? G.iconos.temas : []);
        h = '<h2 class="cm-wz__q">' + (paso === 'sym' ? 'Elige un dibujo' : paso === 'icono' ? 'Un dibujo junto a tu texto' : 'Un dibujo detrás') + '</h2>' +
          (paso === 'sym' ? '' : '<div class="cm-wz__posw" data-wz-pos></div>') +
          '<label class="cm-wz__buscar"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></svg>' +
          '<input type="search" data-wz-buscar placeholder="Busca: perro, ancla, flor, fútbol…" aria-label="Buscar un dibujo" autocomplete="off" enterkeyhint="search" value="' + esc(W.buscar || '') + '"></label>' +
          '<div class="cm-wz__temas" role="tablist">' + temas.map(function (t) {
            var on = !(W.buscar || '').trim() && (W.tema || 'populares') === t[0];
            return wzBoton('cm-wz__tema' + (on ? ' is-on' : ''), esc(t[1]), 'tema', ' data-v="' + t[0] + '" role="tab" aria-selected="' + on + '"');
          }).join('') + '</div><div class="cm-wz__iconos" data-wz-iconos></div>';
      } else if (paso === 'fotoTipo') {
        h = '<h2 class="cm-wz__q">¿Qué hay en tu foto?</h2><div class="cm-wz__ops cm-wz__ops--1">' +
          wzBoton('cm-wz__op', '<i>' + ICONO_FOTO.pata + '</i><span><b>Tu mascota</b><small>Nuestra IA la dibuja a partir de tu foto. En unos 30 segundos.</small></span>', 'foto', ' data-v="mascota"') +
          wzBoton('cm-wz__op', '<i>' + ICONO_FOTO.persona + '</i><span><b>Una persona</b><small>Un retrato con su parecido. En unos 30 segundos.</small></span>', 'foto', ' data-v="retrato"') +
          wzBoton('cm-wz__op', '<i>' + ICONO_FOTO.letra + '</i><span><b>Una letra o un dibujo a mano</b><small>Una nota, una firma o el dibujo de tus hijos, tal cual. Al momento.</small></span>', 'foto', ' data-v="letra"') +
          '</div><p class="cm-fo__priv">' + ICONO_FOTO.candado + '<span>Tu foto solo se usa para hacer tu joya.</span></p>';
      } else if (paso === 'fotoEstilo') {
        var esLetra = d.fotoTipo === 'letra', esRet = d.fotoTipo === 'retrato';
        h = '<h2 class="cm-wz__q">' + (esLetra ? 'Sube la foto de tu letra o dibujo' : '¿Cómo ' + (esRet ? 'lo' : 'la') + ' grabamos?') + '</h2>' +
          (esLetra ? '' : '<div class="cm-fo__estilos" role="radiogroup">' + [['linea', 'Línea fina', 'Trazo limpio, como un dibujo'], ['fotojoya', 'Fotograbado', 'Con sus luces y sombras']].map(function (x) {
            var on = G.fotoEstilo === x[0];
            return '<button type="button" class="cm-fo__estilo' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" data-wz-al="estilo" data-v="' + x[0] + '"><img alt="" src="' + ASSETS + 'cm-fo-' + (esRet ? 'retrato' : 'mascota') + '-' + x[0] + '.jpg"><b>' + x[1] + '</b><small>' + x[2] + '</small></button>';
          }).join('') + '</div>' +
          '<label class="cm-wz__lab" for="cm-wz-fn">¿Cómo se llama? <small>(opcional: lo grabamos debajo)</small></label><input id="cm-wz-fn" class="cm-wz__in" data-wz="fotoNombre" type="text" maxlength="24" autocomplete="off" value="' + esc(d.fotoNombre) + '">') +
          (esRet ? '<label class="cm-fo__check cm-wz__check"><input type="checkbox" data-wz="permiso"' + (W.permiso ? ' checked' : '') + '><span>Tengo permiso de la persona de la foto y acepto que la IA de Customima (OpenAI) la dibuje solo para esta joya.</span></label>' : '') +
          (wzFotoRef() ? '<p class="cm-wz__nota cm-wz__fotook">' + (esLetra ? 'Así queda tu foto en la medalla. Si no te convence, elige otra.' : 'Así queda tu foto en la medalla. Si quieres, cambia el estilo o el nombre y lo ves al momento.') + '</p>' +
            '<button type="button" class="cm-wz__otrafoto' + (esRet && !W.permiso ? ' is-off' : '') + '" data-wz-al="elegir">' + ICONO_FOTO.camara + 'Elegir otra foto</button>'
            : '<button type="button" class="cm-fo__elegir' + (esRet && !W.permiso ? ' is-off' : '') + '" data-wz-al="elegir">' + ICONO_FOTO.camara + 'Elegir foto</button>') +
          '<p class="cm-fo__consejo">' + (esLetra ? 'Sale mejor con buena luz, de frente y sobre papel blanco liso.' : 'Sale mejor de frente, con buena luz y con ' + (esRet ? 'esa persona sola.' : 'tu mascota sola.')) + '</p>';
      } else if (paso === 'detras') {
        var opsD = [['fecha', 'Una fecha'], ['texto', 'Un texto'], ['nada', 'Nada']];
        if (W.detrasExt && W.detrasExt.length) opsD.unshift(['propio', 'El de la IA']);
        h = '<h2 class="cm-wz__q">¿Y detrás? <span class="cm-wz__gratis">GRATIS</span></h2><div class="cm-wz__chips cm-wz__chips--ancho">' + opsD.map(function (x) {
          return wzBoton('cm-wz__chip' + (d.detrasModo === x[0] ? ' is-on' : ''), x[1], 'detrasModo', ' data-v="' + x[0] + '" aria-pressed="' + (d.detrasModo === x[0]) + '"');
        }).join('') + '</div>' +
          (d.detrasModo === 'fecha' || d.detrasModo === 'texto' ? '<label class="cm-wz__lab" for="cm-wz-det">' + (d.detrasModo === 'fecha' ? 'Escribe la fecha, como quieras verla' : 'Escribe el texto (hasta 3 líneas cortas)') + '</label>' +
            '<input id="cm-wz-det" class="cm-wz__in" data-wz="detrasTexto" type="text" maxlength="40" autocomplete="off" enterkeyhint="done" placeholder="' + (d.detrasModo === 'fecha' ? 'Ej.: 14 · 06 · 2019' : 'Ej.: Siempre contigo') + '" value="' + esc(d.detrasTexto) + '">' : '') +
          (d.detrasModo === 'propio' ? '' : wzFilaIcono('detrasIcono')) +
          (d.detrasModo === 'nada' ? '<p class="cm-wz__nota">' + (d.detrasIcono ? 'Detrás va solo el dibujo, grande y centrado.' : 'Detrás queda lisa. Si cambias de idea, grabarlo es gratis.') + '</p>' : '');
      } else if (paso === 'ia') {
        h = '<h2 class="cm-wz__q">Cuéntanos qué quieres grabar</h2><p class="cm-wz__nota cm-wz__nota--arriba">Nombres, fechas, una frase, lo que significa para ti… La IA te propone tu medalla y luego la cambias a tu gusto.</p>';
      } else if (paso === 'fin') {
        // Las dos caras en miniatura, con el diseño tal cual (Susana, 9-oct-2026: «pon foto de cómo se ve la medalla por
        // delante y por detrás, no muy grande»); tocar una enseña esa cara en la vista previa. Sin los atajos de antes.
        var desc = wzDescribe(), pf = propuesta() || {}, mt = METAL[metalKey(currentVariant())];
        if (d.tipo === 'sin') h = '<h2 class="cm-wz__q">Tu medalla, sin grabar</h2><p class="cm-wz__nota cm-wz__nota--arriba">Te llega lisa, por delante y por detrás. Si cambias de idea, grabarla es gratis: pulsa «Personalizarla».</p>' + wzMetalHtml();
        else h = '<h2 class="cm-wz__q">¡Lista! Así queda tu medalla</h2><div class="cm-wz__caras">' +
          [['delante', 'Delante', pf.delante, desc.del], ['detras', 'Detrás', pf.detras, desc.det]].map(function (x) {
            var on = G.cara === x[0] || (!G.cara && x[0] === 'delante');
            return wzBoton('cm-wz__cara' + (on ? ' is-on' : ''), mini(x[2] || [], mt) + '<b>' + x[1] + '</b>', 'verCara', ' data-v="' + x[0] + '" aria-pressed="' + on + '"');
          }).join('') + '</div>' +
          (G.aviso ? '<p class="cm-wz__aviso">' + esc(G.aviso) + '</p>' : '') +
          (wzQuiereFoto() ? wzBoton('cm-wz__afoto', ICONO_FOTO.camara + '<span>¿Quieres que se parezca de verdad? <b>Sube su foto y la dibujamos</b></span>', 'aFoto') : '') +
          wzMetalHtml();
      }
      wzCuerpo.innerHTML = h;
      if (paso === 'ia') wzCuerpo.appendChild(caja);
      if (WZ_PICKER.indexOf(paso) >= 0) {
        wzPintarIconos(); wzPintarPos();
        if (!G.iconos) wzCatalogo().then(function (c) { G.iconos = c; if (WZ_PICKER.indexOf(W.paso) >= 0) wzPintar(); wzAplicar(); }).catch(function () {});
        var bus = wz.querySelector('[data-wz-buscar]');
        if (bus) ['input', 'search'].forEach(function (t) { bus.addEventListener(t, function () { W.buscar = bus.value; wzPintarIconos(); wz.querySelectorAll('.cm-wz__tema').forEach(function (b) { b.classList.toggle('is-on', !W.buscar.trim() && (W.tema || 'populares') === b.getAttribute('data-v')); }); }); });
      }
      // «¿No consigues el diseño que quieres? Escríbenos al chat», al final, en lugar de «¿Otro cambio?»
      if (paso === 'fin') { if (ayuda.parentNode !== wz) wz.appendChild(ayuda); programarFicheros(); }
      else if (ayuda.parentNode === wz) rtCuerpo.appendChild(ayuda);
      // navegación
      var conSig = ['texto', 'letra', 'disp', 'sym', 'icono', 'iconoDet', 'detras'].indexOf(paso) >= 0 || (paso === 'fotoEstilo' && !!(wzFotoRef() || wzDibujando()));
      var sigTxt = i < 0 ? 'Hecho' : c[i + 1] === 'fin' ? 'Ver mi medalla' : 'Siguiente';
      wzNav.innerHTML = (W.hist.length ? wzBoton('cm-wz__atras', '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>Atrás', 'atras') : '<span></span>') +
        (conSig ? wzBoton('cm-wz__sig', sigTxt, 'sig') : paso === 'fin' ? wzBoton('cm-wz__otra', d.tipo === 'sin' ? 'Personalizarla' : 'Empezar de nuevo', 'reset') : '');
      wzNav.hidden = !W.hist.length && !conSig && paso !== 'fin';
      explica.hidden = true;                            // las miniaturas del final ya enseñan el diseño
      pintaRetoque();
      // eventos
      Array.prototype.forEach.call(wz.querySelectorAll('[data-wz-al]'), function (b) { sinQuitarFoco(b).addEventListener('click', wzClic); });
      Array.prototype.forEach.call(wz.querySelectorAll('[data-wz-n]'), function (n) {
        ['input', 'change', 'compositionend'].forEach(function (t) {
          n.addEventListener(t, function () {
            var k = +n.getAttribute('data-wz-n');
            if ((W.d.nombres || [])[k] === n.value) return;
            W.d.nombres[k] = n.value; W.d.frenteExterno = false; wzMsg.textContent = '';
            wzAplicar(); wzPintarPos(true);
          });
        });
      });
      Array.prototype.forEach.call(wz.querySelectorAll('[data-wz]'), function (n) {
        var k = n.getAttribute('data-wz');
        if (k === 'permiso') return n.addEventListener('change', function () { W.permiso = n.checked; var b = wz.querySelector('.cm-fo__elegir'); if (b) b.classList.toggle('is-off', !n.checked); });
        ['input', 'change', 'compositionend'].forEach(function (t) {
          n.addEventListener(t, function () {
            if (W.d[k] === n.value) return;
            W.d[k] = n.value; wzMsg.textContent = '';
            if (k === 'fotoNombre') {
              var fr = wzFotoRef();
              clearTimeout(wzNombreT);
              if (fr) wzNombreT = setTimeout(function () { var nom = (W.d.fotoNombre || '').trim().slice(0, 24); if (G.dibujos[fr]) G.dibujos[fr].nombre = nom; ponerDisenoFoto(fr, nom); }, 600);
              return;
            }
            if (k !== 'detrasTexto') W.d.frenteExterno = false;
            wzAplicar(); wzPintarPos(true);
          });
        });
        n.addEventListener('keydown', function (e) { if (e.key === 'Enter' && n.tagName === 'INPUT') { e.preventDefault(); n.blur(); wzSiguiente(); } });
      });
    }
    function wzClic(e) {
      var b = e.currentTarget, al = b.getAttribute('data-wz-al'), v = b.getAttribute('data-v'), d = W.d;
      if (al === 'atras') return wzAtras();
      if (al === 'sig') return wzSiguiente();
      if (al === 'reset') { W.d = wzD0(); W.hist = []; W.camino = ''; W.frenteExt = W.detrasExt = null; G.texto = ''; rtReset(); wzAplicar(true); return wzIr('inicio', { sinHist: true }); }
      if (al === 'sinGrabar') { d.tipo = 'sin'; d.frenteExterno = false; W.camino = 'sin'; wzAplicar(); return wzIr('fin'); }
      if (al === 'tipo') {
        W.camino = v;
        if (v === 'ia') {
          if (d.tipo === 'foto' && !W.frenteExt) { Object.assign(d, { tipo: 'nombre', texto: '', frenteExterno: false }); wzAplicar(); }
          return wzIr('ia');
        }
        if (v === 'foto') {
          if (d.tipo !== 'foto') { d.tipo = 'foto'; d.frenteExterno = true; W.frenteExt = null; if (d.detrasModo === 'propio') d.detrasModo = 'fecha'; wzAplicar(true); }
          return wzIr('fotoTipo');
        }
        if (d.tipo !== v || d.frenteExterno) {
          var T = WZ_TIPOS[v];
          Object.assign(d, { tipo: v, texto: '', nombres: [], linea2: '', letra: T.letra, peso: 400, disp: 'centro', detalle: 'ninguno', icono: '', iconoPos: 'arriba', frenteExterno: false });
          if (d.detrasModo === 'propio') d.detrasModo = 'fecha';
        }
        wzAplicar();
        return wzIr(WZ_TIPOS[v].camino[0]);
      }
      if (al === 'letra') { var es = ESTILO_POR_ID[v]; d.letra = es.letra; d.peso = es.peso; d.frenteExterno = false; wzAplicar(); return wzPintar(); }
      if (al === 'todas') { W.todas = true; cargarLetras(WZ_LETRAS_2.map(function (id) { var e = ESTILO_POR_ID[id]; return [e.letra, e.peso, d.texto || 'Lucía']; })).then(function () { if (W.paso === 'letra') wzPintar(); }); return wzPintar(); }
      if (al === 'disp') {
        d.disp = v; d.frenteExterno = false; wzAplicar(); wzPintar();
        if (v === 'arco' && !(d.linea2 || '').trim()) { var l2 = wz.querySelector('[data-wz="linea2"]'); wzMsg.textContent = 'Escribe el texto que va en el arco (una fecha, un lugar…).'; if (l2) l2.focus(); }
        return;
      }
      if (al === 'detalle') { d.detalle = v; d.frenteExterno = false; wzAplicar(); return wzPintar(); }
      if (al === 'simbolo') { var kc = wzCampo(); d[kc] = v; if (kc !== 'detrasIcono') d.frenteExterno = false; wzAplicar(); wzPintarIconos(); return wzPintarPos(); }
      if (al === 'irIcono') { W.buscar = ''; if (G.iconos) W.tema = W.tema || 'populares'; return wzIr(b.getAttribute('data-k') === 'detrasIcono' ? 'iconoDet' : 'icono'); }
      if (al === 'quitarIcono') { d[b.getAttribute('data-k')] = ''; wzAplicar(); return wzPintar(); }
      if (al === 'pos') {
        var kp = b.getAttribute('data-k');
        d[kp + 'Pos'] = v; if (kp !== 'detrasIcono') d.frenteExterno = false; wzAplicar();
        Array.prototype.forEach.call(wz.querySelectorAll('.cm-wz__mini[data-wz-al="pos"][data-k="' + kp + '"]'), function (x) { var on = x.getAttribute('data-v') === v; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on); });
        return;
      }
      if (al === 'tema') { W.tema = v; W.buscar = ''; return wzPintar(); }
      if (al === 'dibujarIA') { var q = (W.buscar || '').trim(); if (q) wzDibujarIA(q); return; }
      if (al === 'detrasModo') { d.detrasModo = v; wzAplicar(); wzPintar(); var inp = wz.querySelector('[data-wz="detrasTexto"]'); if (inp && !inp.value) inp.focus(); return; }
      if (al === 'foto') { d.fotoTipo = v; return wzIr('fotoEstilo'); }
      if (al === 'estilo') {
        if (G.fotoEstilo === v) return;
        G.fotoEstilo = v;
        var fr = wzFotoRef(), fu = fr && G.fuentes[fr];
        if (fu && fu.foto && !wzDibujando()) procesarDibujo(null, fu.tipo, (d.fotoNombre || '').trim().slice(0, 24), fu.foto, v);
        return wzPintar();
      }
      if (al === 'elegir') {
        if (b.classList.contains('is-off')) { var ch = wz.querySelector('.cm-wz__check'); if (ch) ch.classList.add('is-aviso'); return; }
        wzFile.value = ''; wzFile.click(); return;
      }
      if (al === 'irA') return wzIr(v);
      if (al === 'otroNombre') { d.nombres = (d.nombres || []).concat(['']); wzPintar(); var ins = wz.querySelectorAll('[data-wz-n]'); if (ins.length) ins[ins.length - 1].focus(); return; }
      if (al === 'quitarNombre') { d.nombres = (d.nombres || []).filter(function (x, k) { return k !== +v; }); d.frenteExterno = false; wzAplicar(); return wzPintar(); }
      if (al === 'aFoto') {
        var prin = principalDe((propuesta() || {}).delante);
        Object.assign(d, { tipo: 'foto', frenteExterno: true, fotoTipo: /retrat|persona|abuel|madre|padre|mam[aá]|pap[aá]|hij|beb/i.test(G.texto || '') ? 'retrato' : 'mascota',
          fotoNombre: prin && !/[0-9]/.test(prin.texto || '') ? String(prin.texto).slice(0, 24) : d.fotoNombre });
        W.frenteExt = null; W.camino = 'foto'; G.aviso = '';
        if (d.detrasModo === 'propio' && !(W.detrasExt && W.detrasExt.length)) d.detrasModo = 'nada';
        wzAplicar(true);
        return wzIr('fotoTipo');
      }
      if (al === 'verCara') { G.cara = v; pintar(); return wzPintar(); }
      if (al === 'opcion') return wzElegirOpcion(+b.getAttribute('data-k'), v);
    }
    wzFile.addEventListener('change', function () {
      var f = wzFile.files && wzFile.files[0], d = W.d;
      if (!f) return;
      d.tipo = 'foto'; d.frenteExterno = true; W.frenteExt = null;
      if (d.detrasModo === 'propio') d.detrasModo = 'fecha';
      wzAplicar(true);
      if (d.fotoTipo === 'letra') procesarLetra(f);
      else procesarDibujo(f, d.fotoTipo, (d.fotoNombre || '').trim().slice(0, 24), null, G.fotoEstilo);
      wzPintar();                                       // se queda aquí: la foto se ve en la medalla y luego «Siguiente»
    });
    // Llega un diseño de fuera del paso a paso: la IA («No sé qué poner»), la foto o un enlace compartido
    function wzLlega() {
      var p = propuesta();
      if (!p) return;
      if (refsDe(p).filter(function (r) { return r !== 'ia'; }).length) {
        W.frenteExt = copia(p.delante); W.d.frenteExterno = true; W.d.tipo = 'foto'; W.camino = 'foto';
        if (W.d.detrasModo === 'propio') W.d.detrasModo = 'fecha';
        wzAplicar();
        if (W.paso === 'fotoEstilo') {                  // se queda en el paso de la foto, sin perder lo que esté escribiendo
          var ae = document.activeElement, enNombre = ae && ae.getAttribute && ae.getAttribute('data-wz') === 'fotoNombre', cur = enNombre ? ae.selectionStart : 0;
          wzPintar();
          var nn = enNombre && wz.querySelector('[data-wz="fotoNombre"]');
          if (nn) { try { nn.focus({ preventScroll: true }); nn.setSelectionRange(cur, cur); } catch (x) {} }
        }
        else if (W.paso === 'fotoTipo') wzIr('fotoEstilo');
        else if (W.paso === 'inicio') wzIr('detras'); else wzPintar();
        return;
      }
      wzAdoptar();
      if (!W.camino) W.camino = 'ia';
      W.d.tipo = 'ia';
      pintar(); sincronizar();
      wzIr('fin');
    }
    function wzArrancar() {
      if (!WZ_ON) return;
      var conCat = [W.d.simbolo, W.d.icono, W.d.detrasIcono].some(function (v) { return String(v || '').indexOf('c:') === 0; });
      if (conCat || G.iconos) wzCatalogo().then(function (c) { G.iconos = c; var p = propuesta(); if (p && refsDe(p).some(function (r) { return !G.dibujos[r]; })) { if (W.d.tipo === 'simbolo' || conCat) wzAplicar(); else pintar(); } }).catch(function () {});
      htmlCls.add('cm-wz');
      var n2 = document.querySelector('[data-cm-step="2"] .cm-step__n');
      if (n2) n2.textContent = '1';
      if (!W.iniciado) {
        W.iniciado = true;
        if (G.compartido && G.propuestas) { W.camino = 'ia'; wzAdoptar(); W.d.tipo = 'ia'; W.paso = 'fin'; W.hist = ['inicio']; }
      }
      if (!G.propuestas) wzAplicar();
      wzPintar();
      pintar(); sincronizar();
    }

    placeStage();
    medirTope();
    // Cuánto ocupan arriba las barras pegadas del tema (anuncio + cabecera): de ahí cuelga la vista
    // previa en móvil. Se mide en marcha porque la barra de campaña va y viene.
    function medirTope() {
      var alto = 0;
      document.querySelectorAll('.shopify-section-group-header-group').forEach(function (n) {
        var pos = getComputedStyle(n).position;
        if (pos === 'sticky' || pos === 'fixed') alto += n.getBoundingClientRect().height;
      });
      // Pegada justo debajo, sin hueco: cualquier separacion deja ver pasar el texto por detras.
      document.documentElement.style.setProperty('--cm-tope', (alto ? Math.round(alto) : 128) + 'px');
      // Y el color del fondo, para tapar con un halo las esquinas redondeadas mientras esta pegada.
      // Se lee del tema en vez de fijar un hexadecimal, que se quedaria viejo al cambiar los colores.
      var n = stage.parentNode, fondo = null;
      while (n && n.nodeType === 1 && !fondo) {
        var col = getComputedStyle(n).backgroundColor;
        if (col && col !== 'transparent' && col.indexOf('rgba(0, 0, 0, 0)') < 0) fondo = col;
        n = n.parentNode;
      }
      if (fondo) document.documentElement.style.setProperty('--cm-fondo', fondo);
    }
    function ensurePlaced() {
      medirTope();
      ordenarCabecera();
      var grid = document.querySelector('product-gallery .product-gallery__image-list'), lista;
      if (deskActive() && grid) {
        if (!deskBox || stage.parentNode !== deskBox || !deskBox.isConnected || grid.firstChild !== deskBox) placeStage();
      } else if ((lista = listaMovil())) {
        if (!movBox || stage.parentNode !== movBox || !movBox.isConnected || !movilEnSitio(lista)) placeStage();
        else tramo();
      }
    }
    var api = {
      root: root, formId: formId, place: placeStage, ensurePlaced: ensurePlaced, validate: validar,
      render: function () { pintar(); sincronizar(); },
      llegan: function () { pintar(); sincronizar(); plegar(true); },
      focusFirst: function () {
        if (WZ_ON) { wzVer(); return; }
        root.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { ta.focus({ preventScroll: true }); }, 350);
      },
      lastVariant: null, variantId: function () { var v = currentVariant(); return v && v.id; }
    };
    root.__cm = api;
    if (!G.enlaceLeido) {
      G.enlaceLeido = true;
      var compartido = disenoDelEnlace();
      if (compartido) { G.propuestas = [compartido]; G.elegida = 0; G.texto = ''; G.aviso = ''; G.estado = 'listo'; G.compartido = true; G.plegada = true; G.base = copia(compartido); }
      else if (compartido === false) msg.textContent = 'No hemos podido abrir el diseño de este enlace. Puede que se haya copiado incompleto.';
    }
    if (WZ_ON) wzArrancar();
    else {
      pintar(); sincronizar();
      if (G.propuestas && G.plegada) plegar(false);
    }
    api.lastVariant = api.variantId();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (root.isConnected) pintar(); });
    return api;
  }

  function scan() {
    var root = document.querySelector('[data-cm-medalla-ia]');
    if (root && (!G.current || G.current.root !== root)) G.current = init(root);
  }
  if (!G.bound) {
    G.bound = true;
    var nativeScrollIntoView = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function () {
      if (deskActive() && this.classList && this.classList.contains('product-gallery__media') && this.closest('product-gallery')) return;
      return nativeScrollIntoView.apply(this, arguments);
    };
    document.addEventListener('submit', function (e) {
      scan();
      var c = G.current;
      if (c && e.target && e.target.getAttribute && e.target.getAttribute('id') === c.formId) c.validate(e);
    }, true);
    document.addEventListener('click', function (e) {
      var go = e.target && e.target.closest && e.target.closest('[data-cm-goto]');
      if (go && G.current) G.current.focusFirst();
      // «Revisa y confirma»: se abre y se cierra sin volver a pintarlo (el resumen se rehace con cada cambio)
      var sum = e.target && e.target.closest && e.target.closest('[data-cm-sum]');
      if (sum) {
        G.sumAbierto = !G.sumAbierto;
        sum.setAttribute('aria-expanded', G.sumAbierto ? 'true' : 'false');
        var cuerpo = document.getElementById(sum.getAttribute('aria-controls'));
        if (cuerpo) cuerpo.hidden = !G.sumAbierto;
      }
    });
    // con el teclado abierto, tocarlo no quita el foco a la caja (el primer toque se perdía; ver sinQuitarFoco)
    document.addEventListener('mousedown', function (e) { if (e.target && e.target.closest && e.target.closest('[data-cm-sum]')) e.preventDefault(); });
    var check = function () {
      scan();
      var c = G.current;
      if (!c || !c.root.isConnected) return;
      c.ensurePlaced();
      var id = c.variantId();
      if (id !== c.lastVariant) { c.lastVariant = id; c.render(); }
    };
    if (mqDesk && mqDesk.addEventListener) mqDesk.addEventListener('change', function () { var c = G.current; if (c && c.root.isConnected) { c.place(); c.render(); } });
    document.addEventListener('change', function () { setTimeout(check, 60); });
    document.addEventListener('variant:change', function () { setTimeout(check, 60); });
    new MutationObserver(function () { scan(); }).observe(document.body, { childList: true, subtree: true });
    setInterval(check, 600);
  }
  scan();
  window.__cmIArender = { pintarCara: pintarCara, resumen: resumen, codigoDelDiseno: codigoDelDiseno, caraLarga: caraLarga, saneaElemento: saneaElemento, deBase64url: deBase64url,
    pathText: pathText, txtEl: txtEl, colocarGlifos: colocarGlifos, trazoRecto: trazoRecto, trazoArco: trazoArco, textosATrazos: textosATrazos,
    cargarLetraTTF: cargarLetraTTF, LETRAS: LETRAS, ESTILOS: ESTILOS, trazarImagen: trazarImagen, aGris: aGris, zonaDelPapel: zonaDelPapel, otsu: otsu };   // para las pruebas locales
})();
